import "ol/ol.css";
import OLMap from "ol/Map";
import View from "ol/View";
import Draw from "ol/interaction/Draw";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom";
import Modify from "ol/interaction/Modify";
import { DragBox, Select } from "ol/interaction";
import { platformModifierKeyOnly } from "ol/events/condition";
import Snap from "ol/interaction/Snap";
import { defaults as defaultControls, ScaleLine } from "ol/control";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { OSM, Vector as VectorSource, XYZ, TileWMS } from "ol/source";
import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import Feature from "ol/Feature";
import { altKeyOnly, click, pointerMove } from "ol/events/condition";
import { Fill, Stroke, Style, Text, Circle, RegularShape } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import { getUid } from "ol/util";
import { bbox as bboxStrategy } from "ol/loadingstrategy";
import WFS from "ol/format/WFS";
import GML from "ol/format/GML";
import { buffer, boundingExtent, extendFlatCoordinates } from "ol/extent";
import {
  and as andFilter,
  equalTo as equalToFilter,
  like as likeFilter,
  intersects as intersectsFilter,
  disjoint as disjointFilter,
} from "ol/format/filter";
import Overlay from "ol/Overlay";
import DragOverlay from "ol-ext/interaction/DragOverlay";
import Projection from "ol/proj/Projection";
import { getArea, getLength } from "ol/sphere";
import { toStringXY } from "ol/coordinate";

import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import Polygonizer from "jsts/org/locationtech/jts/operation/polygonize/Polygonizer";
import Union from "jsts/org/locationtech/jts/operation/union/UnionOp";
import GeoJSONReader from "jsts/org/locationtech/jts/io/GeoJSONReader";
import GeoJSONWriter from "jsts/org/locationtech/jts/io/GeoJSONWriter";
import { BufferOp } from "jsts/org/locationtech/jts/operation/buffer";
import { IsValidOp } from "jsts/org/locationtech/jts/operation/valid";

import * as turf from "@turf/turf";
import { getGeom, point } from "@turf/turf";
import axios from "axios";

import { register } from "ol/proj/proj4";
import { transform } from "ol/proj";

//register EPSG:2326
import * as proj4x from "proj4";
var proj4 = proj4x.default;
proj4.defs(
  "EPSG:2326",
  "+proj=tmerc +lat_0=22.31213333333334 +lon_0=114.1785555555556 +k=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.24365,-1.15883,-1.09425 +units=m +no_defs"
);

register(proj4);
//end of register

let map;
// let siteDraw;
let SERVER_URL;
let SERVER_URL2;
let zoneSource;
let cutZoneLine;
let queryVecSource;
let vecSource2;
let zoneLabelCentroidSource; // ==> centroid to put zone label
let zoneLabelCentroidLayer;
let siteBufferSource; // ==> site buffer
let equipmentManualLocationSource; // ==> layer for equipment points for manual location / non-notional distance
let siteSource; // ==> For site. Originally vecSource, but vecSource is now for Zones.
let vecSource7; // ==> For selection.
let nsrPointsSource; // ==> For generated nsrPoints
let calculatedNSRPointsSource; // ==> only for testng
let unregisterSitesSource; // ==> unregsites
let unregisterSiteBufferSource; // ==> unregsites buffers
let tempNSRPointsSource; // ==> temp nsr points for modifying location ==> also used for add nsr point manually ==> also for temp center points for modifying location
let nsrBuildingBufferSource; // ==> 1m buffer of nsr building to snap the points
let buildingPolygonSource; // ==> to show educational building polygon if 100m buffer extension contains the super sensitive nsr building
let notionalPointSource; // ==> show notional point when NSR point click
let defBuildingWMSSource; // ==> default building that only admin can change by changing the shp in GeoServer folder. ==> In the end choose WFS, because WMS has problem on selection (cannot select image).
let defBuildingWFSSource;
let nsrBuildingWFSSource;
let districtWFSSource;
let projBuildingWFSSource;
let projBuildingPointsWFSSource;
let projPMEWFSSource;
let zoneWFSSource;
let siteWFSSource;
let site2WFSSource;
let centerPtWFSSource;
let bufferWFSSource; // single polygon site
let buffer2WFSSource; // multi polygons site
let unregSiteWFSSource;
let unregBufferWFSSource;
let approvedSiteWFSSource;
let approvedSite2WFSSource;
let approvedBufferWFSSource;
let approvedBuffer2WFSSource;

let vecLayerID;
let vecLayerID2;
let vecLayerID3;
let vecLayerID4;
let vecLayerID5;
let vecLayerID6;
let vecLayerID7;
let defBuildingWFSLayerID;
let nsrBuildingWFSLayerID;
let projBuildingWFSLayerID;
let siteDraw;
let snapDraw;
let nsrSelect;
let nsrSelectMode = 1;
let selectedNSRFeatures = [];
let deselectedNSRFeatures = [];
let nsrFeaturesToAdd = [];
let selectedNSRPointIds = [];
let oldSelectedNSRPointIds = [];
let selectedNSRPoints = [];
let highestNoiseNSRIds = [];
let manuallyAddedNSRs = [];
let dragBox;
let saveProjectFinish;
let projectObj;
let calculationResultNSRGlobal;
let isCalculatedGlobal2; //Added by Marvin Alex

let defBuildingWFSLayer;
let nsrBuildingWFSLayer;
let districtWFSLayer;
let projBuildingWFSLayer;
let projBuildingPointsWFSLayer;
let zoneWFSLayer;
let centerPtWFSLayer;
let siteWFSLayer;
let site2WFSLayer;
let bufferWFSLayer;
let buffer2WFSLayer;
let pmeWFSLayer;
let unregSiteWFSLayer;
let unregBufferWFSLayer;
let approvedSiteWFSLayer;
let approvedSite2WFSLayer;
let approvedBufferWFSLayer;
let approvedBuffer2WFSLayer;

let zonesInput;
let modifiedFeatureList = [];
let modifiedFeatureCloneList;
let siteDistrict;
let approvedNeighbourLayersLoaded = false;

let popupContainerElement;
let popupContentElement;
let popupCloserElement;
let popupOverlay;

let select = null;
let olMap = {
  //mySiteDraw: siteDraw
};
let isZoneOrderMode = false;
let isAddNSRBuildingMode = false;
let isRemoveNSRBuildingMode = false;
let isChangeNoiseLevelNSRBuildingMode = false;
let isChangeNoiseNSRBuildingPointMode = false;
let isAddNSRPointsMode = false;
let isRemoveNSRPointsMode = false;
let isChangeCentralPointMode = false;
let isAfterCalculation = false;
let issitemultipolygon = false;

let eqpDrawEnded = false;
let eqpID;
let buildingIdsForQuery;
let buildingIdForMitigation = 0;
let zoneTaskIdsForMitigation = [];
let allBuildingsHeight = [];

let currentProjectID;
let approvedProjectIDs = [];
let approvedProjectScheduleTasks = [];
let approvedProjectCalculationResultNSR = [];
let movedNSRPointIds = [];
let movedNSRPointFeats = [];
let movedCenterPointIds = [];
let movedCenterPointFeats = [];
let radiusBuffer = 300;
let selectedNSRPointsForReport = [];

let globalCurrentSiteFeature;
let globalCurrentZoneFeatures = [];
let selectedDefaultBuildingFeats = [];
let thisProjectCalculatedNSRPointFeats = [];
let thisProjectCalculatedPMEFeats = [];
let thisProjectCalculateTask = [];

let unregisteredBufferArray = [];
let projectBuildingFeatArrayAfterReduced = [];
let calculationResultGroupArray = [];
let notionalPointsFeatArr = [];

//show coordinate while drawing boundary
let drawing = false;

//test
let outPointAtBorder;
let zoneCentroidTest;
let zoneCentroidTest2;
let zoneCentroidTest3;

let calcTypeTemp = "A";
let zoneNSRNotionalInfo = {};

let tempZoneFeatures = null;
let tempSiteFeatures = null;

//style
const greenNSRPointStyle = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(0, 255, 0, 1)",
      width: 3,
    }),
    radius: 3,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "rgba(0, 255, 0, 1)" }),
    stroke: new Stroke({ color: "black", width: 3 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const greenNSRPointWhiteStrokeStyle = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(0, 255, 0, 1)",
      width: 3,
    }),
    radius: 3,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "rgba(0, 255, 0, 1)" }),
    stroke: new Stroke({ color: "white", width: 2 }),
    placement: "Point",
    offsetY: -12,
  }),
});

const redNSRPointStyle = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(255, 0, 0, 1)",
      width: 3,
    }),
    radius: 3,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "red" }),
    stroke: new Stroke({ color: "white", width: 2 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const redNSRPointStyle2 = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(255, 0, 0, 1)",
      width: 3,
    }),
    radius: 3,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "red" }),
    stroke: new Stroke({ color: "white", width: 2 }),
    placement: "Point",
  }),
});
const unselectedNSRPointStyle = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(177, 182, 216, 1)",
      width: 3,
    }),
    radius: 3,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "red" }),
    stroke: new Stroke({ color: "white", width: 2 }),
    placement: "Point",
  }),
});

const selectedNSRStyle = new Style({
  zIndex: 9999,
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(100, 255, 255, 1)",
      width: 4,
    }),
    radius: 3,
  }),
  fill: new Fill({
    color: "rgba(255, 255, 255, 0.6)",
  }),
  text: new Text({
    font: 'bold 15px "Arial"',
    fill: new Fill({ color: "rgba(100, 255, 255, 1)" }),
    stroke: new Stroke({ color: "rgba(0, 0, 0, 1)", width: 3 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const selectedBuildingStyle = new Style({
  fill: new Fill({
    color: "rgba(81, 255, 237, 0.7)",
    //color: 'red'
  }),
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(81, 255, 237, 0.7)",
      width: 2,
    }),
    radius: 3,
  }),
});
const greenNSRPointStyle20Max = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(0, 255, 0, 1)",
      width: 20,
    }),
    radius: 7,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "rgba(0, 255, 0, 1)" }),
    stroke: new Stroke({ color: "black", width: 3 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const redNSRPointStyle20Max = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(255, 0, 0, 1)",
      width: 20,
    }),
    radius: 7,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "red" }),
    stroke: new Stroke({ color: "white", width: 2 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const bufferStyle = new Style({
  stroke: new Stroke({
    color: "rgba(0, 255, 0, 1)",
    lineDash: [10, 10],
    width: 5,
  }),
});
const approvedBufferStyle = new Style({
  stroke: new Stroke({
    color: "rgba(0, 200, 0, 1)",
    lineDash: [10, 10],
    width: 5,
  }),
});
const zoneStyle = function (feature) {
  return new Style({
    zIndex: 9998,
    fill: new Fill({
      color: feature.get("hover") ? "rgba(255, 0, 0, 0.3)" : "rgba(255, 255, 255, 0.1)",
    }),
    stroke: new Stroke({
      color: "rgba(255, 0, 0, 1)",
      width: 3,
    }),
  });
};
const orderZoneTextStyle = new Style({
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "black" }),
    stroke: new Stroke({ color: "white", width: 3 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const eqpStyle = new Style({
  image: new RegularShape({
    fill: new Fill({ color: "red" }),
    stroke: new Stroke({ color: "black", width: 2 }),
    points: 3,
    radius: 10,
    rotation: Math.PI / 4,
    angle: 0,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "red" }),
    stroke: new Stroke({ color: "white", width: 3 }),
    placement: "Point",
    offsetY: -12,
  }),
});
const siteStyle = new Style({
  fill: new Fill({
    color: "rgba(255, 255, 255, 0.2)",
  }),
});
const nsrPointStyle = new Style({
  image: new Circle({
    stroke: new Stroke({
      color: "rgba(255, 0, 255, 1)",
      width: 2,
    }),
    radius: 3,
  }),
  text: new Text({
    font: 'bold 12px "Arial"',
    fill: new Fill({ color: "rgba(255, 0, 255, 1)" }),
    stroke: new Stroke({ color: "white", width: 2 }),
    placement: "Point",
    offsetY: -12,
  }),
});
//end of style

//style function

const greenNSRPointStyleFunction = function (feature) {
  //console.log(feature.get('order'));
  if (feature.get("totalcnl")) {
    greenNSRPointWhiteStrokeStyle.getText().setText(feature.get("totalcnl").toFixed().toString());
  } else {
    greenNSRPointWhiteStrokeStyle.getText().setText("");
  }

  return greenNSRPointWhiteStrokeStyle;
};
const greenNSRPointStyleFunctionWithNSRName = function (feature) {
  if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
    greenNSRPointStyle.getText().setText(feature.get("nsrname"));
  } else {
    greenNSRPointStyle.getText().setText("");
  }

  return greenNSRPointStyle;
};
const redNSRPointUnmitStyleFunction = function (feature) {
  if (feature.get("totalcnl")) {
    redNSRPointStyle.getText().setText(feature.get("totalcnl").toFixed().toString());
  } else {
    redNSRPointStyle.getText().setText("");
  }

  return redNSRPointStyle;
};
const redNSRPointMitStyleFunction = function (feature) {
  if (feature.get("totalcnl")) {
    redNSRPointStyle.getText().setText(feature.get("totalcnlmit").toFixed().toString());
  } else {
    redNSRPointStyle.getText().setText("");
  }

  return redNSRPointStyle;
};
const redNSRPointUnmitStyleFunctionWithNSRName = function (feature) {
  if (feature.get("totalcnl")) {
    if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
      redNSRPointStyle.getText().setText(feature.get("nsrname") + " - " + feature.get("totalcnl").toFixed().toString());
    } else {
      redNSRPointStyle.getText().setText(feature.get("totalcnl").toFixed().toString());
    }
  } else {
    if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
      redNSRPointStyle.getText().setText(feature.get("nsrname"));
    } else {
      redNSRPointStyle.getText().setText("");
    }
  }

  return redNSRPointStyle;
};
const redNSRPointMitStyleFunctionWithNSRName = function (feature) {
  if (feature.get("totalcnlmit")) {
    if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
      redNSRPointStyle.getText().setText(feature.get("nsrname") + " - " + feature.get("totalcnlmit").toFixed().toString());
    } else {
      redNSRPointStyle.getText().setText(feature.get("totalcnlmit").toFixed().toString());
    }
  } else {
    if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
      redNSRPointStyle.getText().setText(feature.get("nsrname"));
    } else {
      redNSRPointStyle.getText().setText("");
    }
  }

  return redNSRPointStyle;
};
const nsrPointStyleFunctionWithNSRName = function (feature) {
  if (
    feature.get("nsrname")
    //  &&
    // selectedNSRPointIds.includes(feature.get("id"))
  ) {
    nsrPointStyle.getText().setText(feature.get("nsrname"));
  } else {
    nsrPointStyle.getText().setText("");
  }

  return nsrPointStyle;
};
const selectednsrPointStyleFunction = function (feature) {
  if (
    feature.get("nsrname")
    //  &&
    // selectedNSRPointIds.includes(feature.get("id"))
  ) {
    selectedNSRStyle.getText().setText(feature.get("nsrname"));
  } else {
    selectedNSRStyle.getText().setText("");
  }

  return selectedNSRStyle;
};
const greenNSRPointWithWhiteStrokeStyleFunctionWithNSRName = function (feature) {
  //console.log(feature.get('order'));
  if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
    greenNSRPointWhiteStrokeStyle.getText().setText(feature.get("nsrname"));
  } else {
    greenNSRPointWhiteStrokeStyle.getText().setText("");
  }

  return greenNSRPointWhiteStrokeStyle;
};
const redNSRPointMitStyle20MaxFunctionWithNSRName = function (feature) {
  //console.log(feature.get('order'));
  if (feature.get("totalcnl")) {
    redNSRPointStyle20Max.getText().setText(feature.get("totalcnlmit").toFixed().toString());
    if (feature.get("nsrname")) {
      redNSRPointStyle20Max.getText().setText(feature.get("nsrname") + " - " + feature.get("totalcnlmit").toFixed().toString());
    } else {
      redNSRPointStyle20Max.getText().setText(feature.get("totalcnlmit").toFixed().toString());
    }
  } else {
    if (feature.get("nsrname")) {
      redNSRPointStyle20Max.getText().setText(feature.get("nsrname"));
    } else {
      redNSRPointStyle20Max.getText().setText("");
    }
  }

  return redNSRPointStyle20Max;
};
const greenNSRPointStyle20MaxFunctionWithNSRName = function (feature) {
  //console.log(feature.get('order'));
  if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
    greenNSRPointStyle20Max.getText().setText(feature.get("nsrname"));
  } else {
    greenNSRPointStyle20Max.getText().setText("");
  }

  return greenNSRPointStyle20Max;
};
const redNSRPointUnmitStyle20MaxFunctionWithNSRName = function (feature) {
  //console.log(feature.get('order'));
  if (feature.get("totalcnl")) {
    if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
      redNSRPointStyle20Max.getText().setText(feature.get("nsrname") + " - " + feature.get("totalcnl").toFixed().toString());
    } else {
      redNSRPointStyle20Max.getText().setText(feature.get("totalcnl").toFixed().toString());
    }
  } else {
    if (feature.get("nsrname") && selectedNSRPoints.map((p) => p.buildingId).includes(feature.get("buildingid"))) {
      redNSRPointStyle20Max.getText().setText(feature.get("nsrname"));
    } else {
      redNSRPointStyle20Max.getText().setText("");
    }
  }

  return redNSRPointStyle20Max;
};
const selectionStyleFunction = function (feature) {
  let currentNoiseCriteria = feature.get("noisecriteria");
  let maxMitigatedCNL = feature.get("totalcnlmit");
  let maxOriginalCNL = feature.get("totalcnl");

  let thisLayer = getLayerByTitle("calculatedNSRPointsLayer");
  // get all nsr point features
  let allCalculatedNSRPointFeats = thisLayer.getSource().getFeatures();
  let sortedPointArray = allCalculatedNSRPointFeats.filter((p) => p.get("noisecriteria"));
  let sortByNoise = [...sortedPointArray];
  sortByNoise.sort((a, b) => b.get("totalcnl") - a.get("totalcnl"));
  let i = sortByNoise.findIndex((f) => f.get("id") === feature.get("id"));

  console.log("sortedPointArray", sortByNoise);
  console.log(
    "sortedPointArrayIds",
    sortByNoise.map((f) => f.get("id"))
  );
  console.log("feature", feature);
  console.log("selectionStyleFunction", i);
  let isMitgated = feature.get("totalcnl") !== feature.get("totalcnlmit");
  if (isMitgated) {
    if (i >= 20) {
      if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
        // if the result is red
        return redNSRPointMitStyleFunctionWithNSRName(feature);
      } else {
        return greenNSRPointWithWhiteStrokeStyleFunctionWithNSRName(feature);
      }
    } else {
      if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
        // if the result is red
        return redNSRPointMitStyle20MaxFunctionWithNSRName(feature);
      } else {
        return greenNSRPointStyle20MaxFunctionWithNSRName(feature);
      }
    }
  } else {
    if (i >= 20) {
      if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
        // if the result is red
        return redNSRPointUnmitStyleFunctionWithNSRName(feature);
      } else {
        return greenNSRPointWithWhiteStrokeStyleFunctionWithNSRName(feature);
      }
    } else {
      if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
        // if the result is red
        return redNSRPointUnmitStyle20MaxFunctionWithNSRName(feature);
      } else {
        return greenNSRPointStyle20MaxFunctionWithNSRName(feature);
      }
    }
  }

  // if (feature.get("totalcnl") !== feature.get("totalcnlmit")) {
  //   if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
  //     // if the result is red
  //     return redNSRPointMitStyle20MaxFunctionWithNSRName(feature);
  //   } else {
  //     return greenNSRPointStyle20MaxFunctionWithNSRName(feature);
  //   }
  // } else {
  //   if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
  //     // if the result is red
  //     return redNSRPointUnmitStyle20MaxFunctionWithNSRName(feature);
  //   } else {
  //     return greenNSRPointStyle20MaxFunctionWithNSRName(feature);
  //   }
  // }
};
//end of style function

// ### This function is where all 'openlayers' begins. Prepares the map, layers (in-memory layers, Geoserver layers), and Map Click handler (e.g. layer click for pop-up, etc).
// ### Called from: MainView.vue
olMap.initOL = function (apiURL) {
  SERVER_URL = apiURL;
  SERVER_URL2 = SERVER_URL;
  // console.log("SERVER_URL",SERVER_URL);
  // console.log("apiURL",apiURL);

  // create vector layer
  zoneSource = new VectorSource();
  var vector = new VectorLayer({
    title: "zoneLayer",
    source: zoneSource,
    style: zoneStyle,
  });

  // create title layer
  // var raster = new TileLayer({
  //     source: new OSM(),
  // });
  // create line Cutter layer
  vecSource2 = new VectorSource();
  var vector2 = new VectorLayer({
    title: "lineCutterLayer",
    source: vecSource2,
  });
  var addFeatureVecSource2EventListener = vecSource2.on("addfeature", keepVecSource2Clean);

  // create text layer for zone order
  var orderZoneTextStyleFunction = function (feature) {
    //console.log(feature.get('order'));
    if (feature.get("order")) {
      orderZoneTextStyle.getText().setText(feature.get("order"));
      //console.log("1111111");
    } else {
      orderZoneTextStyle.getText().setText("");
      //console.log("2222222");
    }

    return orderZoneTextStyle;
  };
  zoneLabelCentroidSource = new VectorSource();
  zoneLabelCentroidLayer = new VectorLayer({
    title: "zoneOrderIDPointLayer",
    source: zoneLabelCentroidSource,
    style: orderZoneTextStyleFunction,
  });
  zoneLabelCentroidLayer.setVisible(false);

  // site buffer layer
  siteBufferSource = new VectorSource();
  var vector4 = new VectorLayer({
    title: "sitebufferLayer",
    source: siteBufferSource,
    style: bufferStyle,
  });

  // manual equipment points layer
  var eqpTextStyleFunction = function (feature) {
    //console.log(feature.get('order'));
    if (feature.get("officialid")) {
      if (feature.get("officialid").trim() === "") {
        if (feature.get("othername")) {
          var name = feature.get("othername");
          eqpStyle.getText().setText(name);
        } else {
          eqpStyle.getText().setText("");
        }
      }
      var offid = feature.get("officialid");
      eqpStyle.getText().setText(offid);
    } else if (feature.get("othername")) {
      var name = feature.get("othername");
      if (feature.get("officialid")) {
        var offid = feature.get("officialid");
        name = offid + "-" + name;
      }
      eqpStyle.getText().setText(name);
      //console.log("1111111");
    } else {
      eqpStyle.getText().setText("");
      //console.log("2222222");
    }

    return eqpStyle;
  };
  equipmentManualLocationSource = new VectorSource();
  var equipmentPointLayer = new VectorLayer({
    title: "equipmentPointLayer",
    source: equipmentManualLocationSource,
    style: eqpTextStyleFunction,
  });
  var addFeatureVecSource5EventListener = equipmentManualLocationSource.on("addfeature", checkEqpInsideZone);

  //site layer. Originally vecSource, but it becomes Zone layer
  siteSource = new VectorSource();
  var vector6 = new VectorLayer({
    title: "siteLayer",
    source: siteSource,
    style: siteStyle,
  });

  // selected feature. All features that are selected.
  vecSource7 = new VectorSource();
  var vector7 = new VectorLayer({
    title: "selectedLayer",
    source: vecSource7,
    style: selectedBuildingStyle,
  });

  nsrPointsSource = new VectorSource();
  var vector8 = new VectorLayer({
    title: "nsrPointLayer",
    source: nsrPointsSource,
    style: nsrPointStyle,
  });

  var calculatedNSRPointStyle = new Style({
    image: new Circle({
      stroke: new Stroke({
        color: "rgba(0, 0, 0, 1)",
        width: 3,
      }),
      radius: 3,
    }),
    stroke: new Stroke({
      color: "black",
      width: 4,
    }),
    fill: new Fill({
      //color: 'rgba(81, 255, 237, 0.7)',
      color: "black",
    }),
  });
  calculatedNSRPointsSource = new VectorSource();
  var calculatedNSRPointsLayer = new VectorLayer({
    title: "calculatedNSRPointsLayer",
    source: calculatedNSRPointsSource,
    style: calculatedNSRPointStyle,
  });

  // unreg sites
  unregisterSitesSource = new VectorSource();
  var vector9 = new VectorLayer({
    title: "unregsiteLayer",
    source: unregisterSitesSource,
    style: zoneStyle,
  });

  // unreg sites buffer
  unregisterSiteBufferSource = new VectorSource();
  var vector10 = new VectorLayer({
    title: "unregsitebufferLayer",
    source: unregisterSiteBufferSource,
    style: bufferStyle,
  });

  // temp nsr points to modify location
  tempNSRPointsSource = new VectorSource();
  var vector11 = new VectorLayer({
    title: "tempNSRPointsToMove",
    source: tempNSRPointsSource,
    style: nsrPointStyle,
  });

  // 1m buffer of nsr building to snap the points
  var snapBuildingStyle = new Style({
    stroke: new Stroke({
      color: "rgba(200, 200, 200, 1)",
      lineDash: [5, 5],
      width: 1,
    }),
  });
  nsrBuildingBufferSource = new VectorSource();
  var vector12 = new VectorLayer({
    title: "snappedNSRBuilding",
    source: nsrBuildingBufferSource,
    style: snapBuildingStyle,
  });

  //to show educational building polygon if 100m buffer extension contains the super sensitive nsr building
  var eduBuildingStyle = new Style({
    stroke: new Stroke({
      color: "rgba(0, 127, 70, 1)",
      width: 2,
    }),
    fill: new Fill({ color: "rgba(255, 255, 255, 0.1)" }),
  });
  buildingPolygonSource = new VectorSource();
  var buildingPolygonLayer = new VectorLayer({
    title: "notifEduNSRBuilding",
    source: buildingPolygonSource,
    style: eduBuildingStyle,
  });

  //to show notional point when nsr point click
  var notionalStyle = new Style({
    image: new Circle({
      stroke: new Stroke({
        color: "rgba(255, 165, 0, 1)",
        width: 3,
      }),
      radius: 3,
    }),
    stroke: new Stroke({
      color: "orange",
      width: 4,
    }),
    fill: new Fill({
      //color: 'rgba(81, 255, 237, 0.7)',
      color: "orange",
    }),
  });
  var centerStyle = function (feature) {
    let style = new Style({
      image: new Circle({
        stroke: new Stroke({
          color: "rgba(0, 0, 0, 1)",
          width: 3,
        }),
        radius: 3,
      }),
      stroke: new Stroke({
        color: "black",
        width: 4,
      }),
      fill: new Fill({
        //color: 'rgba(81, 255, 237, 0.7)',
        color: "black",
      }),
      text: new Text({
        font: 'bold 12px "Arial"',
        fill: new Fill({ color: "black" }),
        stroke: new Stroke({ color: "white", width: 3 }),
        placement: "Point",
        offsetY: -12,
      }),
    });
    if (feature.get("zonename")) {
      style.getText().setText(feature.get("zonename"));
    } else {
      style.getText().setText("");
    }

    return style;
  };
  notionalPointSource = new VectorSource();
  var vector14 = new VectorLayer({
    title: "notionalPoint",
    source: notionalPointSource,
    style: notionalStyle,
  });

  // // Default building layer. Non-editable, only admin can change by changing the shp in GeoServer folder. Shapefile format in GeoServer data folder.
  // defBuildingWMSSource = new TileWMS({
  //     url: 'http://localhost:8080/gsProxy/hk_test/wms',
  //     params: {'LAYERS': 'hk_test:Bld_HKSAR2011_hk80_nsr', 'TILED': false},
  //     serverType: 'geoserver',
  //     // Countries have transparency, so do not fade tiles:
  //     //transition: 0,
  // });
  // var defBuildingWMSTileLayer = new TileLayer({
  //     source: defBuildingWMSSource
  // });

  //################## WFS

  var districtStyle = new Style({
    stroke: new Stroke({
      color: "rgba(60, 60, 60, 1)",
      lineDash: [10, 10],
      width: 1,
    }),
  });
  var districtURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AHKDistrict_wgs84sp&outputFormat=application%2Fjson";
  districtWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return districtURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  districtWFSLayer = new VectorLayer({
    title: "districtWFSLayer",
    source: districtWFSSource,
    style: districtStyle,
  });

  var defBuildingStyle = new Style({
    stroke: new Stroke({
      color: "rgba(0, 0, 0, 1)",
      width: 1,
    }),
    fill: new Fill({ color: "rgba(255, 255, 255, 0.2)" }),
  });
  //var testURL = SERVER_URL + '/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3ABld_HKSAR2011_wgs84sp&outputFormat=application%2Fjson';
  //var testURL = SERVER_URL + '/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3ABuilding_2022_wgs84sp&outputFormat=application%2Fjson';
  var testURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3ABuilding_2022_wgs84sp_noZM&outputFormat=application%2Fjson";
  //var testURL = 'http://localhost:8080/gsProxy/hk_test/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=hk_test%3ABld_HKSAR2011_hk80_nsr&outputFormat=application%2Fjson';
  defBuildingWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return testURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  defBuildingWFSLayer = new VectorLayer({
    title: "defaultBuildingLayer",
    source: defBuildingWFSSource,
    style: defBuildingStyle,
  });

  var nsrBuildingStyle = new Style({
    stroke: new Stroke({
      color: "rgba(255, 106, 0, 1)",
      width: 2,
    }),
    fill: new Fill({ color: "rgba(255, 255, 255, 0.5)" }),
  });
  //var nsrBuidingURL = SERVER_URL + '/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3ABuilding_2022_nsr_wgs84sp&outputFormat=application%2Fjson';
  var nsrBuidingURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3ABuilding_2022_nsr_wgs84sp_noZM&outputFormat=application%2Fjson";
  nsrBuildingWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return nsrBuidingURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  nsrBuildingWFSLayer = new VectorLayer({
    title: "nsrBuildingLayer",
    source: nsrBuildingWFSSource,
    style: nsrBuildingStyle,
  });

  var projBuildingStyle1 = new Style({
    stroke: new Stroke({
      color: "rgba(0, 0, 255, 1)",
      width: 2,
    }),
    fill: new Fill({ color: "rgba(255, 255, 255, 0.1)" }),
  });
  var projBuildingStyle2 = new Style({
    stroke: new Stroke({
      color: "rgba(0, 127, 70, 1)",
      width: 2,
    }),
    fill: new Fill({ color: "rgba(255, 255, 255, 0.1)" }),
  });
  var projBuildingStyleFunction = function (feature) {
    //console.log(feature.get('order'));
    if (feature.get("type")) {
      if (feature.get("type").trim() === "Accommodation") {
        return projBuildingStyle1;
      } else {
        return projBuildingStyle2;
      }
    } else {
      return projBuildingStyle2;
    }
  };
  var projBuidingURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectNSRBuilding&outputFormat=application%2Fjson";
  projBuildingWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projBuidingURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  projBuildingWFSLayer = new VectorLayer({
    title: "projectBuildingLayer",
    source: projBuildingWFSSource,
    style: projBuildingStyleFunction,
    visible: false,
  });

  var projNSRPointsStyle = new Style({
    image: new Circle({
      stroke: new Stroke({
        color: "rgba(255, 0, 255, 1)",
        width: 2,
      }),
      radius: 3,
    }),
  });
  var projNSRPointsURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectNSRPoints&outputFormat=application%2Fjson";
  projBuildingPointsWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projNSRPointsURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  projBuildingPointsWFSLayer = new VectorLayer({
    title: "projectBuildingPointsLayer",
    source: projBuildingPointsWFSSource,
    style: projNSRPointsStyle,
    visible: false,
  });

  var siteWFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites&outputFormat=application%2Fjson";
  siteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return siteWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  siteWFSLayer = new VectorLayer({
    title: "siteWFSLayer",
    source: siteWFSSource,
    style: siteStyle,
    visible: false,
  });
  var site2WFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites2&outputFormat=application%2Fjson";
  site2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return site2WFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  site2WFSLayer = new VectorLayer({
    title: "site2WFSLayer",
    source: site2WFSSource,
    style: siteStyle,
    visible: false,
  });

  var approvedSiteStyle = new Style({
    fill: new Fill({
      color: "rgba(255, 255, 255, 0.1)",
    }),
    stroke: new Stroke({
      color: "rgba(255, 106, 0, 1)",
      width: 3,
    }),
  });
  var approvedSiteWFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites&outputFormat=application%2Fjson";
  approvedSiteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return approvedSiteWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  approvedSiteWFSLayer = new VectorLayer({
    title: "approvedSiteWFSLayer",
    source: approvedSiteWFSSource,
    style: approvedSiteStyle,
    visible: false,
  });
  var approvedSite2WFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites2&outputFormat=application%2Fjson";
  approvedSite2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return approvedSite2WFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  approvedSite2WFSLayer = new VectorLayer({
    title: "approvedSite2WFSLayer",
    source: approvedSite2WFSSource,
    style: approvedSiteStyle,
    visible: false,
  });

  var unregsiteWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Aunregsites&outputFormat=application%2Fjson";
  unregSiteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return unregsiteWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  unregSiteWFSLayer = new VectorLayer({
    title: "unregSiteWFSLayer",
    source: unregSiteWFSSource,
    style: zoneStyle,
    visible: false,
  });

  var zoneWFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Azones&outputFormat=application%2Fjson";
  zoneWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return zoneWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  zoneWFSLayer = new VectorLayer({
    title: "zoneWFSLayer",
    source: zoneWFSSource,
    style: zoneStyle,
    visible: false,
  });

  var centerPtWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AgeomCenter&outputFormat=application%2Fjson";
  centerPtWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return centerPtWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  centerPtWFSLayer = new VectorLayer({
    title: "centerPtWFSLayer",
    source: centerPtWFSSource,
    style: centerStyle,
    visible: false,
  });

  var bufferWFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers&outputFormat=application%2Fjson";
  bufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return bufferWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  bufferWFSLayer = new VectorLayer({
    title: "bufferWFSLayer",
    source: bufferWFSSource,
    style: bufferStyle,
    visible: false,
  });
  var buffer2WFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers2&outputFormat=application%2Fjson";
  buffer2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return buffer2WFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  buffer2WFSLayer = new VectorLayer({
    title: "buffer2WFSLayer",
    source: buffer2WFSSource,
    style: bufferStyle,
    visible: false,
  });

  var approvedBufferWFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers&outputFormat=application%2Fjson";
  approvedBufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return approvedBufferWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  approvedBufferWFSLayer = new VectorLayer({
    title: "approvedBufferWFSLayer",
    source: approvedBufferWFSSource,
    style: approvedBufferStyle,
    visible: false,
  });
  var approvedBuffer2WFSURL =
    SERVER_URL + "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers2&outputFormat=application%2Fjson";
  approvedBuffer2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return approvedBuffer2WFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  approvedBuffer2WFSLayer = new VectorLayer({
    title: "approvedBuffer2WFSLayer",
    source: approvedBuffer2WFSSource,
    style: approvedBufferStyle,
    visible: false,
  });

  var unregbufferWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Aunregbuffers&outputFormat=application%2Fjson";
  unregBufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return unregbufferWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  unregBufferWFSLayer = new VectorLayer({
    title: "unregBufferWFSLayer",
    source: unregBufferWFSSource,
    style: bufferStyle,
    visible: false,
  });

  var pmeWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectPME&outputFormat=application%2Fjson";
  projPMEWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return pmeWFSURL + "&srsname=EPSG:3857&bbox=" + extent.join(",") + ",EPSG:3857";
    },
    strategy: bboxStrategy,
  });
  pmeWFSLayer = new VectorLayer({
    title: "pmeWFSLayer",
    source: projPMEWFSSource,
    style: eqpTextStyleFunction,
    visible: false,
  });

  // var raster = new TileLayer({
  //     source: new XYZ({
  //         url: 'https://mapapi.geodata.gov.hk/gs/api/v1.0.0/xyz/imagery/WGS84/{z}/{x}/{y}.png'
  //     })
  // });
  var raster = new TileLayer({
    source: new XYZ({
      url: "https://mapapi.geodata.gov.hk/gs/api/v1.0.0/xyz/basemap/WGS84/{z}/{x}/{y}.png",
      crossOrigin: "Anonymous",
    }),
  });
  var mapLabel = new TileLayer({
    source: new XYZ({
      url: "https://mapapi.geodata.gov.hk/gs/api/v1.0.0/xyz/label/hk/en/WGS84/{z}/{x}/{y}.png",
      crossOrigin: "Anonymous",
    }),
  });

  popupContainerElement = document.getElementById("popup");
  popupContentElement = document.getElementById("popup-content");
  popupCloserElement = document.getElementById("popup-closer");

  popupOverlay = new Overlay({
    element: popupContainerElement,
    // autoPan: {
    //   animation: {
    //     duration: 250,
    //   },
    // },
    stopEvent: false,
  });

  popupCloserElement.onclick = function () {
    popupOverlay.setPosition(undefined);
    popupCloserElement.blur();
    return false;
  };

  const coordinatePopup = new Overlay({
    element: document.getElementById("popup2"),
  });

  coordinatePopup.on("change:position", function (evt) {
    this.setOffset([75, 90]);
  });

  document.getElementById("mapContainer").innerHTML = "";

  // create map with 2 layer
  map = new OLMap({
    controls: defaultControls().extend([
      new ScaleLine({
        units: "metric",
      }),
    ]),
    target: "mapContainer",
    layers: [
      raster,
      mapLabel,
      projBuildingWFSLayer,
      approvedBuffer2WFSLayer,
      approvedBufferWFSLayer,
      unregBufferWFSLayer,
      buffer2WFSLayer,
      bufferWFSLayer,
      zoneWFSLayer,
      approvedSite2WFSLayer,
      approvedSiteWFSLayer,
      unregSiteWFSLayer,
      site2WFSLayer,
      siteWFSLayer,
      projBuildingPointsWFSLayer,
      pmeWFSLayer,
      buildingPolygonLayer,
      vector14,
      vector12,
      vector10,
      vector4,
      vector9,
      vector6,
      vector,
      vector2,
      zoneLabelCentroidLayer,
      equipmentPointLayer,
      vector7,
      vector11,
      vector8,
      centerPtWFSLayer,
      calculatedNSRPointsLayer,
    ],
    //layers: [raster, vector4, vector, vector2, vector3, vector5],
    overlays: [popupOverlay, coordinatePopup],
    view: new View({
      //projection: "EPSG:2326",
      projection: "EPSG:3857",
      //projection: "EPSG:4326",
      //center: [114.1045311,22.35],
      center: [12709477.933, 2547688.963],
      //center: [835593.040, 818023.949],
      zoom: 11,
    }),
  });

  // var drag = new DragOverlay({
  //   overlays: [popupOverlay],
  // });
  // map.addInteraction(drag);

  var buttonOn = document.getElementById("onoffneighbourlayeron");
  //var buttonOff = document.getElementById("onoffneighbourlayeroff");
  buttonOn.style.display = "none";
  //buttonOff.style.display= "none";

  vecLayerID = getUid(vector);
  vecLayerID2 = getUid(vector2);
  vecLayerID3 = getUid(zoneLabelCentroidLayer);
  vecLayerID4 = getUid(vector4);
  vecLayerID5 = getUid(equipmentPointLayer);
  vecLayerID6 = getUid(vector6);
  vecLayerID7 = getUid(vector7);
  defBuildingWFSLayerID = getUid(defBuildingWFSLayer);
  nsrBuildingWFSLayerID = getUid(nsrBuildingWFSLayer);
  projBuildingWFSLayerID = getUid(projBuildingWFSLayer);

  /// remove doubl clic zoom event
  var dblclickzoom;
  map.getInteractions().forEach(function (interaction) {
    if (interaction instanceof DoubleClickZoom) {
      dblclickzoom = interaction;
    }
  });
  // Remove the interaction from the map.
  if (dblclickzoom) {
    map.removeInteraction(dblclickzoom);
  }

  // // Selection
  // const selected = new Style({
  //     fill: new Fill({
  //         color: '#eeeeee',
  //     }),
  //     // stroke: new Stroke({
  //     //     color: 'rgba(255, 255, 255, 0.7)',
  //     //     width: 2,
  //     // }),
  //     // image: new RegularShape({
  //     //     fill: new Fill({color: 'red'}),
  //     //     points: 3,
  //     //     radius: 10,
  //     //     rotation: Math.PI / 4,
  //     //     angle: 0,
  //     // })
  // });

  // function selectStyle(feature) {
  //     //const color = feature.get('COLOR') || 'rgba(81, 255, 237, 0.1)';
  //     const color = 'rgba(81, 255, 237, 0)';
  //     selected.getFill().setColor(color);
  //     return selected;
  // }
  // // select interaction working on "singleclick"
  // const selectSingleClick = new Select({style: selectStyle});
  // //const selectSingleClick = new Select();
  // if (select !== null) {
  //     map.removeInteraction(select);
  // }
  // select = selectSingleClick;
  // map.addInteraction(select);
  // var zoneOrder;
  // var selectedZone = [];
  // select.on('select', function (e) {

  //     // console.log(e.target.getFeatures().getLength() +
  //     // ' selected features (last operation selected ' +
  //     // e.selected.length +
  //     // ' and deselected ' +
  //     // e.deselected.length +
  //     // ' features)');
  //     console.log("Inside selection. This below is selected:");
  //     console.log(e.selected);
  //     console.log(e.target);
  //     console.log(select);

  //     if (isSelectedLayerEqualLayerID(e.target,vecLayerID5)) { // if select equipment point, then do nothing.
  //         console.log("vecLayerID5 is selected");
  //         return;
  //     }
  //     if (isSelectedLayerEqualLayerID(e.target,vecLayerID4)) { // if select buffer, then do nothing.
  //         select.getFeatures().clear();
  //         return;
  //     }
  //     if (isAddNSRBuildingMode) {
  //         if(e.selected.length > 0){
  //             var currentFeat = e.selected[0];
  //             if(currentFeat.id_.indexOf("Bld_HKSAR2011_wgs84sp") >=0 )
  //             {
  //                 vecSource7.addFeature(currentFeat);
  //                 vecSource7.refresh();
  //             }
  //         }

  //         // var loopIndex = 0;
  //         // select.getFeatures().forEach((feature) => {
  //         //     console.log(feature.id_)
  //         //     if(feature.id_.indexOf("Bld_HKSAR2011_wgs84sp") >=0 )
  //         //     {

  //         //     }
  //         //     else
  //         //     {
  //         //         select.getFeatures().splice(loopIndex,1);
  //         //         loopIndex = loopIndex - 1;
  //         //     }
  //         //     loopIndex = loopIndex + 1;
  //         // });
  //     }
  //     else if (isRemoveNSRBuildingMode) {

  //     }
  //     else if (isChangeNoiseLevelNSRBuildingMode ) {

  //     }

  //     // if (isZoneOrderMode)
  //     // {
  //     //     console.log("inside zoneordermode");
  //     //     if(e.selected.length === 0)
  //     //     {
  //     //         return;
  //     //     }
  //     //     if(selectedZone.length === 0) {
  //     //         selectedZone.push(e.selected[0].getId());
  //     //     }
  //     //     else
  //     //     {
  //     //         if(selectedZone.indexOf(e.selected[0].getId()) !== -1)
  //     //         {
  //     //                 return;
  //     //         }
  //     //         else
  //     //         {
  //     //                 selectedZone.push(e.selected[0].getId());
  //     //         }
  //     //     }
  //     //     if(zoneOrder === 0)
  //     //     {
  //     //         vecSource3.clear();
  //     //     }
  //     //     zoneOrder = zoneOrder + 1;
  //     //     var currentFeat = e.selected[0];
  //     //     // console.log("zoneOrder");
  //     //     // console.log(zoneOrder);
  //     //     // console.log("currentFeat");
  //     //     // console.log(currentFeat);

  //     //     // create centroid
  //     //     //var centroidFeat = getCentroid(currentFeat);
  //     //     var centroidFeat = getCenterOfMass(currentFeat);
  //     //     centroidFeat.set('order', zoneOrder.toString());
  //     //     vecSource3.addFeature(centroidFeat);
  //     //     // console.log("centroidFeat")
  //     //     // console.log(centroidFeat)
  //     //     // console.log("vecSource3.getFeatures().length")
  //     //     // console.log(vecSource3.getFeatures().length)
  //     //     // console.log(e.target.getFeatures().getLength() +
  //     //     // ' selected features (last operation selected ' +
  //     //     // e.selected.length +
  //     //     // ' and deselected ' +
  //     //     // e.deselected.length +
  //     //     // ' features)');
  //     //     // console.log(e.selected.getId());
  //     // }
  //     // else{
  //     //     console.log("Inside -ELSE- of zoneordermode.");
  //     //     zoneOrder = 0;
  //     //     selectedZone = [];
  //     // }
  // });

  //showYesNoModal("No NSR building is found within the study are site buffer. Please try enlarging the study area. Do you want to enlarge the study area buffer?");

  map.on("singleclick", function (e) {
    console.log("isAddNSRBuildingMode", isAddNSRBuildingMode);
    console.log("isRemoveNSRBuildingMode", isRemoveNSRBuildingMode);
    console.log("isChangeNoiseLevelNSRBuildingMode", isChangeNoiseLevelNSRBuildingMode);
    const clickedCoordinate = e.coordinate;
    notionalPointSource.clear(); // clear the notional points
    if (isAddNSRBuildingMode) {
      var nsrLayerClicked = false;
      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        if (feature.id_.indexOf("Building_2022_nsr_wgs84sp_noZM") >= 0) {
          nsrLayerClicked = true;
        }
      });

      if (nsrLayerClicked) {
        return;
      }

      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        //if(feature.id_.indexOf("Bld_HKSAR2011_wgs84sp") >=0 )
        if (feature.id_.indexOf("Building_2022_wgs84sp_noZM") >= 0) {
          var selIndex = selectedDefaultBuildingFeats.indexOf(feature);
          if (selIndex < 0) {
            selectedDefaultBuildingFeats.push(feature);
            feature.setStyle(selectedBuildingStyle);
          } else {
            console.log("already exist");
            console.log(selIndex);
            selectedDefaultBuildingFeats.splice(selIndex, 1);
            feature.setStyle(undefined);
          }
        }
      });
      console.log(selectedDefaultBuildingFeats);
    } else if (isRemoveNSRBuildingMode) {
      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        console.log("feature.id_", feature.id_);
        //if(feature.id_.indexOf("Bld_HKSAR2011_wgs84sp") >=0 )
        if (feature.id_.indexOf("Building_2022_nsr_wgs84sp_noZM") >= 0) {
          var selIndex = selectedDefaultBuildingFeats.indexOf(feature);
          if (selIndex < 0) {
            selectedDefaultBuildingFeats.push(feature);
            feature.setStyle(selectedBuildingStyle);
          } else {
            console.log("already exist");
            console.log(selIndex);
            selectedDefaultBuildingFeats.splice(selIndex, 1);
            feature.setStyle(undefined);
          }
        }
      });
    } else if (isChangeNoiseLevelNSRBuildingMode) {
      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        if (feature.id_.indexOf("projectNSRBuilding") >= 0) {
          var selIndex = selectedDefaultBuildingFeats.indexOf(feature);
          if (selIndex < 0) {
            selectedDefaultBuildingFeats.push(feature);
            feature.setStyle(selectedBuildingStyle);
          } else {
            console.log("already exist");
            console.log(selIndex);
            selectedDefaultBuildingFeats.splice(selIndex, 1);
            feature.setStyle(undefined);
          }
        }
      });
    } else if (isRemoveNSRPointsMode) {
      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        console.log("feature", feature);
        //if(feature.id_.indexOf("Bld_HKSAR2011_wgs84sp") >=0 )
        if (feature.id_.indexOf("projectNSRPoints") >= 0) {
          var selIndex = selectedDefaultBuildingFeats.indexOf(feature);
          if (selIndex < 0) {
            selectedDefaultBuildingFeats.push(feature);
            feature.setStyle(selectedBuildingStyle);
          } else {
            console.log("already exist");
            console.log(selIndex);
            selectedDefaultBuildingFeats.splice(selIndex, 1);
            feature.setStyle(undefined);
          }
        }
      });
    } else if (isAfterCalculation) {
      //### this is to get the popup menu to show calculation results after calculation
      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        // console.log("feature");
        // console.log(feature);
        if (typeof feature.getId() === "number") {
          //do nothing
        } else if (feature.getId()?.indexOf("projectNSRPoints") >= 0 && feature.style_ !== null) {
          // selection always has 2 feats at the same spot. only take the one that has style.
          console.log("feature");
          console.log(feature);
          // return;
          if (feature.get("totalcnl")) {
            //console.log("feature", feature);
            var buildingid = feature.get("buildingid");
            console.log("selected buildingid:", buildingid);
            var aNSRName = feature.get("nsrname");
            console.log("aNSRName");
            console.log(aNSRName);
            if (!aNSRName) {
              aNSRName = "";
            }
            var criteriaVal = feature.get("noisecriteria");
            var bldName = feature.get("BldName_E");
            var ttlCNL = feature.get("totalcnl");
            var ttlCNLMit = feature.get("totalcnlmit");
            var detailInJSONString = feature.get("calcvalues");
            var neighbor = feature.get("othernoisecriteria") ? feature.get("othernoisecriteria") : "No Neighbor Site";
            var neighbornoise = feature.get("totalcnlwithneighbor") ? feature.get("totalcnlwithneighbor") : feature.get("totalcnlmit");
            var detailObj = JSON.parse(detailInJSONString);
            var conclusionText = "";
            var isExceed = false;
            var theTtlCNL = ttlCNL;
            if (ttlCNLMit > 0 && ttlCNLMit !== ttlCNL) {
              theTtlCNL = ttlCNLMit;
            }
            if (Math.round(theTtlCNL) <= Math.round(criteriaVal)) {
              conclusionText = "Satisfy noise criteria";
            } else {
              conclusionText = "Exceed noise criteria";
              isExceed = true;
            }

            // get the required elements
            var popupConclusionElement = document.getElementById("popup-conclusion");
            var popupNSRNameElement = document.getElementById("popup-nsrname");
            var popupMaxUnmitCNLElement = document.getElementById("popup-maxunmitcnl");
            var popupMaxMitCNLElement = document.getElementById("popup-maxmitcnl");
            var popupMaxDatesElement = document.getElementById("popup-maxdates");
            var popupCriteriaElement = document.getElementById("popup-noisecriteria");
            var popupBldNameElement = document.getElementById("popup-buildingname");
            var popupNieghborElement = document.getElementById("popup-neighbor");
            var popupNieghborNoiseElement = document.getElementById("popup-neighbornoise");
            var popupDetailTableElement = document.getElementById("popup-listtable");
            var popupMitigateButtonElement = document.getElementById("popup-mitButton");
            var popupDistButtonElement = document.getElementById("popup-distButton");
            var popupDistButtonElement = document.getElementById("popup-distButton");

            //delete all TR in the table first (reset the table)
            while (popupDetailTableElement.hasChildNodes()) {
              popupDetailTableElement.removeChild(popupDetailTableElement.lastChild);
            }

            //recreate single title
            var tr0 = document.createElement("tr");
            var th0 = document.createElement("th");
            th0.setAttribute("colspan", "2");
            th0.innerHTML = "Mitigated";
            tr0.appendChild(th0);
            popupDetailTableElement.appendChild(tr0);

            //recreate TH
            var tr1 = document.createElement("tr");
            var th1 = document.createElement("th");
            var th2 = document.createElement("th");
            //var th3 = document.createElement("th");
            //th1.innerHTML = "Start Date";
            th1.innerHTML = "Task Code";
            th2.innerHTML = "Total CNL";
            // th2.innerHTML = "End Date";
            // th3.innerHTML = "Total CNL";
            tr1.appendChild(th1);
            tr1.appendChild(th2);
            //tr1.appendChild(th3);
            popupDetailTableElement.appendChild(tr1);

            // create the remaining rows
            var maxVal = 0;
            var maxDates = "";
            detailObj = detailObj.filter((d) => d.totalCNL);
            for (let i = 0; i < detailObj.length; i++) {
              var itemObj = detailObj[i];

              if (itemObj.ismitigated == 0) {
                continue;
              }
              //var dateGroup = itemObj.dateGroup;
              var zonetask = itemObj.zonetask;
              var totCNL = itemObj.totalCNL.toFixed(1);
              // var dateArr = dateGroup.split("#");
              // var sDate = new Date(dateArr[0]);
              // var eDate = new Date(dateArr[1]);
              // var taskArr = itemObj.tasks;

              // if(maxVal < totCNL) {
              //     maxVal = totCNL;
              //     maxDates = getSimpleDate(sDate) + " - " + getSimpleDate(eDate);
              // }

              var tr2 = document.createElement("tr");
              var td1 = document.createElement("td");
              td1.style.minWidth = "70px";
              var td2 = document.createElement("td");
              //var td3 = document.createElement("td");
              // td1.innerHTML = getSimpleDate(sDate);
              // td2.innerHTML = getSimpleDate(eDate);
              td1.innerHTML = zonetask;
              td2.innerHTML = totCNL;
              // td3.innerHTML = totCNL;
              if (Math.round(itemObj.totalCNL) <= Math.round(criteriaVal)) {
                td2.style.color = "green";
              } else {
                td2.style.color = "red";
              }
              tr2.appendChild(td1);
              tr2.appendChild(td2);
              // tr2.appendChild(td3);
              popupDetailTableElement.appendChild(tr2);

              // // insert tasks

              // for(let t=0; t < taskArr.length; t++) {
              //     var currentTask = taskArr[t];
              //     var tr3 = document.createElement("tr");
              //     var td31 = document.createElement("td");
              //     var td32 = document.createElement("td");
              //     td32.setAttribute("colspan","2");
              //     td32.style.textAlign="left";
              //     td32.innerHTML = currentTask;
              //     td32.style.minWidth="300px";

              //     tr3.appendChild(td31);
              //     tr3.appendChild(td32);
              //     popupDetailTableElement.appendChild(tr3);
              // }
            }

            //recreate single title
            var tr4 = document.createElement("tr");
            var th4 = document.createElement("th");
            th4.setAttribute("colspan", "2");
            th4.innerHTML = "Un-Mitigated";
            tr4.appendChild(th4);
            popupDetailTableElement.appendChild(tr4);

            //recreate TH
            var tr5 = document.createElement("tr");
            var th3 = document.createElement("th");
            var th4 = document.createElement("th");
            th3.innerHTML = "Task Code";
            th4.innerHTML = "Total CNL";
            tr5.appendChild(th3);
            tr5.appendChild(th4);
            popupDetailTableElement.appendChild(tr5);

            // create the remaining rows
            for (let i = 0; i < detailObj.length; i++) {
              var itemObj = detailObj[i];

              if (itemObj.ismitigated == 1) {
                continue;
              }

              var zonetask = itemObj.zonetask;
              var totCNL = itemObj.totalCNL.toFixed(1);

              var tr6 = document.createElement("tr");
              var td3 = document.createElement("td");
              td3.style.minWidth = "70px";
              var td4 = document.createElement("td");
              td3.innerHTML = zonetask;
              td4.innerHTML = totCNL;
              if (Math.round(itemObj.totalCNL) <= Math.round(criteriaVal)) {
                td4.style.color = "green";
              } else {
                td4.style.color = "red";
              }
              tr6.appendChild(td3);
              tr6.appendChild(td4);
              popupDetailTableElement.appendChild(tr6);
            }

            popupConclusionElement.innerHTML = conclusionText;
            if (isExceed) {
              popupConclusionElement.style.color = "red";
            } else {
              popupConclusionElement.style.color = "green";
            }
            popupNSRNameElement.innerHTML = aNSRName;
            popupMaxUnmitCNLElement.innerHTML = ttlCNL.toFixed(1);
            popupMaxMitCNLElement.innerHTML = ttlCNLMit.toFixed(1);
            //popupMaxDatesElement.innerHTML = maxDates;
            popupCriteriaElement.innerHTML = criteriaVal;
            popupNieghborElement.innerHTML = neighbor.replace("#", ", ");
            popupNieghborNoiseElement.innerHTML = neighbornoise.toFixed(1);
            popupNieghborElement.innerHTML = neighbor.replace("#", ", ");
            popupNieghborNoiseElement.innerHTML = neighbornoise.toFixed(1);
            popupBldNameElement.innerHTML = bldName;

            //popupContentElement.innerHTML = feature.get("totalcnl");
            popupOverlay.setPosition(clickedCoordinate);

            // mitigate button action
            popupMitigateButtonElement.onclick = function () {
              //store building id to global var
              buildingIdForMitigation = buildingid;
              // window.location.href = SERVER_URL2 + "#/Mitigation";
              window.location.href = `${window.location.origin}/#/Mitigation/1`;

              //alert("works");
            };

            // notional distance button action
            popupDistButtonElement.onclick = function () {
              //store building id to global var
              window.location.href = `${window.location.origin}/#/NotionalDistance/${feature.get("id")}`;
            };
            console.log("notionalPointsFeatArr", notionalPointsFeatArr);
            console.log(
              "notionalPointsFeatArr",
              notionalPointsFeatArr.filter((a) => a.get("buildingid") === buildingid)
            );
            //show notional points of this nsr point's building id
            notionalPointsFeatArr.filter((a) => a.get("buildingid") === buildingid).forEach((f) => notionalPointSource.addFeature(f));
          }
        }
      });
    } else {
      //console.log("else");
      map.forEachFeatureAtPixel(e.pixel, function (feature) {
        console.log("feature.id_", feature.id_);
      });
    }
    map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
      console.log("feature clicked", feature);
      console.log("feature source", feature.getSource?.() || "no source method");
      console.log("feature clicked layer", layer?.get("title") || layer?.getClassName?.() || "unknown");
    });
  });

  map.on("pointermove", function (e) {
    if (drawing) {
      const clickedCoordinate = e.coordinate;
      if (clickedCoordinate.length > 1) {
        coordinatePopup.setPosition(clickedCoordinate);
        let hkgrid = transform(clickedCoordinate, "EPSG:3857", "EPSG:2326");
        document.getElementById("northing").innerHTML = Math.round(hkgrid[1] * 1000) / 1000;
        document.getElementById("easting").innerHTML = Math.round(hkgrid[0] * 1000) / 1000;
      }
    } else {
      coordinatePopup.setPosition(undefined);
    }

    // Hover effect for centerPtWFSLayer
    let hoveredFeature = null;
    map.forEachFeatureAtPixel(e.pixel, function (feature) {
      let featureLayer = null;
      map.getLayers().forEach((layer) => {
        if (layer === centerPtWFSLayer && layer.getSource().getFeatures().includes(feature)) {
          featureLayer = centerPtWFSLayer;
        }
      });

      if (featureLayer === centerPtWFSLayer) {
        hoveredFeature = feature;
      }
    });
    let layer = getLayerByTitle("zoneWFSLayer");
    if (!layer) {
      layer = getLayerByTitle("zoneLayer");
    }
    // Update cursor and styling based on hover
    if (layer) {
      if (hoveredFeature) {
        let zoneName = hoveredFeature.get("zonename");
        if (zoneName) {
          layer
            .getSource()
            .getFeatures()
            .forEach((f) => {
              f.set("hover", f.get("name") === zoneName);
            });
        }
      } else {
        layer
          .getSource()
          .getFeatures()
          .forEach((f) => {
            f.set("hover", false);
          });
      }
    }
  });
};

// ### This function is for VUE to obtain the selected building ID to show in the mitigation. The value is populated after clicking Mitigation button in
// ### the calculated point's pop-up window.
olMap.getBuildingIdForMitigation = function () {
  return buildingIdForMitigation;
};

// ### This function is for VUE to reset the selected building ID to show in the mitigation.
olMap.resetBuildingIdForMitigation = function () {
  console.log("resetng buildingIdForMitigation");
  buildingIdForMitigation = 0;
};

// ### This function handle the site drawing, after clicking draw button on VUE.
olMap.switchOnSiteDraw = function (bufferRadius) {
  // zoneLabelCentroidLayer.setVisible(true);
  centerPtWFSLayer.setVisible(false);
  drawing = true;
  var thisLayer = getLayerByTitle("siteWFSLayer");
  thisLayer.setVisible(false);
  var thisLayer = getLayerByTitle("site2WFSLayer");
  thisLayer.setVisible(false);

  if (bufferRadius) {
    if (bufferRadius > 0) {
      radiusBuffer = bufferRadius;
    }
  }

  siteDraw = new Draw({
    source: zoneSource,
    type: "Polygon",
  });
  map.addInteraction(siteDraw);

  siteDraw.on("drawend", function (e) {
    // // var newProjectPanel = document.getElementById("newProjectMenuPanel");
    // // newProjectPanel.style.height = "500px";

    //clear zone Source
    zoneSource.clear();

    // //clear zone order label
    // vecSource3.clear();

    // //clear buffer source
    // vecSource4.clear();

    // //clear site source
    // vecSource6.clear();

    // var currentFeat = e.feature;

    // var clonefeat = currentFeat.clone();
    // clonefeat.setId(currentFeat.getId());
    // vecSource6.addFeature(clonefeat);

    // // var jstsGeom = parser.read(e.feature.getGeometry());
    // // var buffered = jstsGeom.buffer(300);
    // // var bufferedFeat = parser.write(buffered);

    // // var cusGeoJSON = new GeoJSON();
    // // var cusfeatGeoJSON1 = cusGeoJSON.writeFeatureObject(currentFeat);
    // // var cusfeatTurfGeom1 = turf.getGeom(cusfeatGeoJSON1);
    // // var cusbufferredTurfGeom = turf.buffer(cusfeatTurfGeom1, 300, {units: 'meters'});
    // // //return geoJSON.readFeature(bufferredTurfGeom);
    // // var bufferedFeat = cusGeoJSON.readFeature(cusbufferredTurfGeom);

    // //var geoJSON = new GeoJSON();
    // //var featGeoJSON1 = geoJSON.writeFeatureObject(currentFeat);
    // //var jstsReader = new GeoJSONReader();

    // //var bufferedFeat = geoJSON.readFeature(featGeoJSON2);

    // console.log("Create buffer with radius: ",radiusBuffer );
    // var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer);
    // // console.log("bufferedFeat")
    // // console.log(bufferedFeat)
    // vecSource4.addFeature(bufferedFeat);

    // // // add site to the modifiedfeaturelist
    // // modifiedFeatureList.push(e.feature);
    // // var task = "insert";
    // // var geoserverWorkspace = "webcnmpws";
    // // var editLayer = "sites";
    // // console.log("about to save edits");
    // // saveEdits(task, geoserverWorkspace, editLayer);

    // // add default index 1 after drawing site polygon. put the point to the label layer source (vecSource3), set the label to show on 'order' attribute.
    // var index = 1;
    // var centroidFeat = getCenterOfMass(currentFeat);
    // console.log(centroidFeat);
    // centroidFeat.set('order', "zone " + index.toString());
    // vecSource3.addFeature(centroidFeat);
    // currentFeat.set('id', index);

    // //determine the district from the centroid location
    // getDistrictBySiteCentroid(centroidFeat.getGeometry());

    tempZoneFeatures = null;
    tempSiteFeatures = e.feature;

    map.removeInteraction(siteDraw);

    onSiteDrawProcess(e.feature, radiusBuffer);

    //console.log(vecSource.getFeatures())
    //console.log(vecSource2.getFeatures())
  });
};

// ### clearing the site draw from the map.
olMap.clearSiteDraw = function () {
  clearTempLayers();
  toggleWFSLayersVisibility(false);
};

olMap.updateBuffer = function (radiusBuffer) {
  if (tempSiteFeatures !== null) {
    console.log("tempSiteFeatures");
    return updateBuffer(tempSiteFeatures, radiusBuffer);
  }
  if (tempZoneFeatures !== null) {
    console.log("onZoneDrawProcess");
    return updateBuffer(tempZoneFeatures, radiusBuffer);
  }
  if (globalCurrentSiteFeature !== null) {
    console.log("current site feature");
    return updateBuffer(globalCurrentSiteFeature, radiusBuffer);
  }
};

// ### This function handle the unregistared site drawing, after clicking draw button on VUE.
olMap.switchOnUnregSiteDraw = function (bufferRadius, affectDegree) {
  var thisLayer = getLayerByTitle("unregSiteWFSLayer");
  thisLayer.setVisible(false);

  if (bufferRadius) {
    if (bufferRadius > 0) {
      radiusBuffer = bufferRadius;
    }
  }

  siteDraw = new Draw({
    source: unregisterSitesSource,
    type: "Polygon",
  });
  map.addInteraction(siteDraw);

  siteDraw.on("drawend", function (e) {
    var featNo = unregisterSitesSource.getFeatures().length + 1;

    var thisFeat = e.feature;
    thisFeat.setId(featNo);

    onUnregSiteDrawProcess(e.feature, radiusBuffer, featNo, affectDegree);

    map.removeInteraction(siteDraw);
  });
};
// ### clearing the site draw from the map.
olMap.clearUnregSiteDraw = function () {
  clearUnregSiteTempLayers();
};

// ### reseting the in-memory layers.
function clearTempLayers() {
  zoneSource.clear(); //the zones
  centerPtWFSSource.clear(); // zone center
  zoneLabelCentroidSource.clear(); // zone index label
  siteBufferSource.clear(); // buffer
  siteSource.clear(); //site
  calculatedNSRPointsSource.clear(); //red / green calculated nsr point
  projBuildingPointsWFSSource.clear();
  projBuildingWFSSource.clear();
  nsrPointsSource.clear(); // uncalculated nsr point - purple
  tempNSRPointsSource.clear(); // temp nsr point for moving
  vecSource7.clear(); //selected feature.
  equipmentManualLocationSource.clear(); // equipment points
  toggleWFSLayersVisibility(false);
  map.removeInteraction(siteDraw);
  isAfterCalculation = false;
}
// ### reseting the in-memory layers for unregistered sites.
function clearUnregSiteTempLayers() {
  unregisterSitesSource.clear(); //unreg Site feature.
  unregisterSiteBufferSource.clear(); // unregeg Site buffer
}

// ### toggle the WFS Layers visibility
function toggleWFSLayersVisibility(visible) {
  var thisLayer = getLayerByTitle("projectBuildingLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("projectBuildingPointsLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("siteWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("site2WFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("zoneWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("bufferWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("buffer2WFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("pmeWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("unregSiteWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("unregBufferWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
  thisLayer = getLayerByTitle("centerPtWFSLayer");
  if (thisLayer) {
    thisLayer.setVisible(visible);
  }
}

// ### site processes after site draw
async function onSiteDrawProcess(theFeature, radiusBuffer) {
  //clear zone order label
  zoneLabelCentroidSource.clear();
  zoneLabelCentroidLayer.setVisible(true);

  //clear buffer source
  siteBufferSource.clear();

  //clear site source
  siteSource.clear();

  // reset issitemultipolygon as current site draw only allow single polygon
  issitemultipolygon = false;

  var currentFeat = theFeature;

  var clonefeat = currentFeat.clone();
  clonefeat.setId(currentFeat.getId());
  siteSource.addFeature(clonefeat);
  console.log("onSiteDrawProcess siteSource.getFeatures()", siteSource.getFeatures());

  console.log("Create buffer with radius: ", radiusBuffer);
  var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer);
  siteBufferSource.addFeature(bufferedFeat);

  // add default index 1 after drawing site polygon. put the point to the label layer source (vecSource3), set the label to show on 'order' attribute.
  var index = 1;
  var centroidFeat = getCenterOfMass(currentFeat);
  console.log("centroidFeat", centroidFeat);
  centroidFeat.set("order", "zone " + index.toString());
  zoneLabelCentroidSource.addFeature(centroidFeat);
  currentFeat.set("id", index);

  //determine the district from the centroid location
  //getDistrictBySiteCentroid(centroidFeat.getGeometry());

  checkWhetherBufferIntersectAnyNSRBuildings(bufferedFeat);
  return await getDistrictBySitePolygon(currentFeat.getGeometry());
}

// ### unregisered site processes after site draw
function onUnregSiteDrawProcess(theFeature, radiusBuffer, featNo, affectdegree) {
  // //clear unreg Site buffer source
  // vecSource10.clear();

  var currentFeat = theFeature;
  console.log("Create buffer with radius: ", radiusBuffer);
  var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer);
  bufferedFeat.setId(featNo);
  bufferedFeat.set("affectdegree", affectdegree);
  unregisterSiteBufferSource.addFeature(bufferedFeat);
}
// ### validation for SHP upload.
function uploadSHPValidationPass(theFeatures) {
  var resultMessage = [];
  //### check if feature at least 1
  console.log("theFeatures");
  console.log(theFeatures.length);
  if (theFeatures.length < 1) {
    resultMessage.push("There is 0 polygon on your shapefile. Please upload another shapefile.");
  }
  var testFeat = theFeatures[0];
  //### Only polygon is accepted
  if (!testFeat || !testFeat.getGeometry() || testFeat.getGeometry().getType() !== "Polygon") {
    resultMessage.push("Your shapefile does not contain Polygon geometry type. Please upload another shapefile.");
  }
  // //### check the projection    ==> Cannot use because all features will have EPSG:4326
  // if(theGeoJSON.dataProjection.getCode() !== "EPSG:4326") {
  //     resultMessage.push("Your shapefile does not have . Please upload another shapefile.");
  // }

  return resultMessage;
}

// ### drawing site on map from shp upload
olMap.siteDrawByGJSON = function (file, bufferRadius, callback) {
  zoneSource.clear();
  zoneLabelCentroidSource.clear();

  calculatedNSRPointsSource.clear(); //red / green calculated nsr point
  nsrPointsSource.clear(); // uncalculated nsr point - purple
  vecSource7.clear(); //selected feature.
  equipmentManualLocationSource.clear(); // equipment points
  isAfterCalculation = false;
  console.log("enter siteDrawByGJSON");
  //var wgs84sp = new Projection('EPSG:3857');
  var theRadius = bufferRadius;
  loadshp(
    { url: file, encoding: "utf-8" },
    async function (geoJSON) {
      console.log(geoJSON);

      let testJson = new GeoJSON();
      const sitefeatures = testJson.readFeatures(geoJSON, {
        featureProjection: map.getView().getProjection(),
      });
      console.log(map.getView().getProjection());
      console.log("testJson");
      console.log(testJson);
      // console.log("sitefeatures");
      // console.log(sitefeatures);
      var valMsgs = uploadSHPValidationPass(sitefeatures);
      if (valMsgs.length > 0) {
        var msg = valMsgs.join("<br /><br />");
        showModal(msg);
        callback(false);
      } else {
        var siteFeatureFirst = sitefeatures[0];
        // console.log(siteFeatureFirst.getGeometry().getType());

        var thisLayer = getLayerByTitle("zoneLayer");
        thisLayer.getSource().clear();
        thisLayer.getSource().addFeature(siteFeatureFirst);
        console.log(thisLayer.getSource());
        map.getView().fit(thisLayer.getSource().getExtent());

        tempZoneFeatures = null;
        tempSiteFeatures = siteFeatureFirst;

        let district = await onSiteDrawProcess(siteFeatureFirst, theRadius);

        callback(true, district);
      }
    },
    function (error) {
      alert(error);
    }
  );

  //
  // console.log(sitefeatures);
  // console.log(siteFeatureFirst);
  // var thisLayer = getLayerByTitle("siteWFSLayer");
  // thisLayer.values_.visible = false;

  // var siteFeat = new Feature({
  //     geometry: new Polygon(siteFeatureFirst.getGeometry().getCoordinates())
  // });
  // // var clonefeat = siteFeatureFirst.clone();
  // // clonefeat.setId(siteFeatureFirst.getId());

  // vecSource.addFeature(siteFeat);
};

// ### drawing zone on map from shp upload
olMap.zoneDrawByGJSON = function (file, bufferRadius, callback) {
  zoneSource.clear();
  zoneLabelCentroidSource.clear();

  calculatedNSRPointsSource.clear(); //red / green calculated nsr point
  nsrPointsSource.clear(); // uncalculated nsr point - purple
  vecSource7.clear(); //selected feature.
  equipmentManualLocationSource.clear(); // equipment points
  isAfterCalculation = false;
  console.log("enter zoneDrawByGJSON");
  //var wgs84sp = new Projection('EPSG:3857');
  var theRadius = bufferRadius;
  loadshp(
    { url: file, encoding: "utf-8" },
    async function (geoJSON) {
      console.log(geoJSON);
      let testJson = new GeoJSON();
      const zonefeatures = testJson.readFeatures(geoJSON, {
        featureProjection: map.getView().getProjection(),
      });
      console.log(map.getView().getProjection());
      console.log("testJson");
      console.log(testJson);
      var valMsgs = uploadSHPValidationPass(zonefeatures);
      if (valMsgs.length > 0) {
        var msg = valMsgs.join("<br /><br />");
        showModal(msg);
        callback(0, [], false);
      } else {
        var thisLayer = getLayerByTitle("zoneLayer");
        thisLayer.getSource().clear();
        // console.log(zonefeatures);
        //get all fields to set to field option combobox - get all except geometry
        var firstFeat = zonefeatures[0];
        var allFields = Object.keys(firstFeat.getProperties());
        var fieldsToReturn = [];
        for (let i = 0; i < allFields.length; i++) {
          var aField = allFields[i];
          if (!aField.toLocaleLowerCase().includes("geom")) {
            fieldsToReturn.push(aField);
          }
        }

        // put all geojson features into zone layer
        for (let i = 0; i < zonefeatures.length; i++) {
          var zoneFeature = zonefeatures[i];
          zoneFeature.set("id", i + 1);
          //console.log(Object.keys(zoneFeature.getProperties()));
          //console.log(zoneFeature.getGeometry().getCoordinates());
          thisLayer.getSource().addFeature(zoneFeature);
        }
        map.getView().fit(thisLayer.getSource().getExtent());

        tempSiteFeatures = null;
        tempZoneFeatures = zonefeatures;

        let district = await onZoneDrawProcess(zonefeatures, theRadius);

        callback(zonefeatures.length, fieldsToReturn, true, district);
      }
    },
    function (error) {
      alert(error);
    }
  );
};

// ### setting the zone name from shp's attribute table field, from shp upload
olMap.getZoneNameByField = function (fieldName, callback) {
  var thisLayer = getLayerByTitle("zoneLayer");
  var allZoneFeatures = thisLayer.getSource().getFeatures();
  var zoneNames = [];
  zoneLabelCentroidSource.clear();
  for (let i = 0; i < allZoneFeatures.length; i++) {
    for (let j = 0; j < allZoneFeatures.length; j++) {
      var curFeat = allZoneFeatures[j];
      var curFeatId = curFeat.get("id");
      var curZoneName = curFeat.get(fieldName);
      if (curFeatId === i + 1) {
        zoneNames.push(curZoneName);

        var centroidFeat = getCenterOfMass(curFeat);
        centroidFeat.set("order", curZoneName);
        zoneLabelCentroidSource.addFeature(centroidFeat);
        //curFeat.set('id', i+1);

        break;
      }
    }
  }

  callback(zoneNames);
};

olMap.setIsMultipolygon = function (ismultipgn) {
  issitemultipolygon = ismultipgn; //==> set the global variable.
};
olMap.getIsMultipolygon = function (ismultipgn) {
  return issitemultipolygon; //==> set the global variable.
};

function getGroupOfIntersectedIndex(features) {
  var currentFeat;
  var touchedIndexArr = [];
  var allTouchedIndexArr = [];
  var groupTouchedIndexArr = [];

  if (features.length > 1) {
    //try to make the union keep single polygon, order the polygon
    touchedIndexArr.push(0);
    allTouchedIndexArr.push(0);

    var allIndexDone = false;

    while (!allIndexDone) {
      for (let i = 0; i < touchedIndexArr.length; i++) {
        var currentIndex = touchedIndexArr[i];
        currentFeat = features[currentIndex];
        for (let j = 1; j < features.length; j++) {
          if (allTouchedIndexArr.includes(j)) {
            continue;
          }
          var checkedFeat = features[j];
          if (isIntersect(currentFeat, checkedFeat)) {
            if (!touchedIndexArr.includes(j)) {
              touchedIndexArr.push(j);
              allTouchedIndexArr.push(j);
            }
          }
        }
      }

      groupTouchedIndexArr.push(touchedIndexArr);
      var checkAllDone = true;
      for (let i = 0; i < features.length; i++) {
        if (!allTouchedIndexArr.includes(i)) {
          checkAllDone = false;
          touchedIndexArr = [];
          touchedIndexArr.push(i);
          allTouchedIndexArr.push(i);
          break;
        }
      }

      allIndexDone = checkAllDone;
    }
  }

  return groupTouchedIndexArr;
}

// ### Process when drawing the zone from shp upload
async function onZoneDrawProcess(theFeatures, radiusBuffer) {
  //clear zone order label
  zoneLabelCentroidSource.clear();

  //clear buffer source
  siteBufferSource.clear();

  //clear site source
  siteSource.clear();

  //union all zone polygons to get the site
  var currentFeat;
  var touchedIndexArr = [];
  var allTouchedIndexArr = [];
  var groupTouchedIndexArr = [];

  if (theFeatures.length > 1) {
    //try to make the union keep single polygon, order the polygon
    // touchedIndexArr.push(0);
    // allTouchedIndexArr.push(0);

    // var allIndexDone = false;

    // while (!allIndexDone)
    // {
    //     for (let i=0; i < touchedIndexArr.length; i++){
    //         var currentIndex = touchedIndexArr[i];
    //         currentFeat  = theFeatures[currentIndex];
    //         for (let j=1; j < theFeatures.length; j++){
    //             if(allTouchedIndexArr.includes(j)){
    //                 continue;
    //             }
    //             var checkedFeat = theFeatures[j];
    //             if ( isIntersect(currentFeat, checkedFeat)) {
    //                 if(!touchedIndexArr.includes(j)){
    //                     touchedIndexArr.push(j);
    //                     allTouchedIndexArr.push(j);
    //                 }
    //             }
    //         }
    //     }

    //     groupTouchedIndexArr.push(touchedIndexArr);
    //     var checkAllDone = true;
    //     for (let i=0; i < theFeatures.length; i++){
    //         if(!allTouchedIndexArr.includes(i)){
    //             checkAllDone = false;
    //             touchedIndexArr = [];
    //             touchedIndexArr.push(i);
    //             allTouchedIndexArr.push(i);
    //             break;
    //         }
    //     }

    //     allIndexDone= checkAllDone;
    // }
    groupTouchedIndexArr = getGroupOfIntersectedIndex(theFeatures);
    console.log("groupTouchedIndexArr");
    console.log(groupTouchedIndexArr);

    // union all individual polygon
    var groupUnionArr = [];

    for (let i = 0; i < groupTouchedIndexArr.length; i++) {
      var curTouchedIndexArr = groupTouchedIndexArr[i];

      for (let j = 0; j < curTouchedIndexArr.length; j++) {
        var currentIndex = curTouchedIndexArr[j];
        if (j === 0) {
          currentFeat = theFeatures[currentIndex];
        } else {
          currentFeat = getUnion(currentFeat, theFeatures[currentIndex]);
        }
      }
      groupUnionArr.push(currentFeat);
    }

    //union all grouped polygons (multipolygon), if more than 1.
    if (groupUnionArr.length > 1) {
      console.log("groupUnionArr.length");
      console.log(groupUnionArr.length);
      issitemultipolygon = true; //==> set the global variable.
      for (let i = 0; i < groupUnionArr.length; i++) {
        console.log("i");
        console.log(i);
        if (i === 0) {
          currentFeat = groupUnionArr[i];
        } else {
          currentFeat = getUnion(currentFeat, groupUnionArr[i]);
          // if (currentFeat.getGeometry().getType() === "MultiPolygon") {
          //     console.log("getType() === 'MultiPolygon'");
          //     console.log("currentFeat.getGeometry()");
          //     console.log(currentFeat.getGeometry());
          //     console.log("currentFeat.getGeometry().getPolygons()");
          //     console.log(currentFeat.getGeometry().getPolygons());
          //     console.log("currentFeat.getGeometry().getPolygons()[0].getCoordinates()");
          //     console.log(currentFeat.getGeometry().getPolygons()[0].getCoordinates());
          //     if (currentFeat.getGeometry().getPolygons().length > 1){
          //         var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer);
          //         var minusBufferFeat = getPolygonBuffer(bufferedFeat, radiusBuffer * -1);
          //         currentFeat = minusBufferFeat;
          //     }

          // }
        }
      }
    } else {
      issitemultipolygon = false; //==> set the global variable.
    }

    // for (let i=0; i < theFeatures.length; i++)
    // {
    //     if(i === 0 ) {
    //         currentFeat = theFeatures[i];
    //     }
    //     else {
    //         currentFeat = getUnion(currentFeat,theFeatures[i]);
    //         if (currentFeat.getGeometry().getType() === "MultiPolygon") {
    //             if (currentFeat.getGeometry().getPolygons().length > 1){
    //                 var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer);
    //                 var minusBufferFeat = getPolygonBuffer(bufferedFeat, radiusBuffer * -1);
    //                 currentFeat = minusBufferFeat;
    //             }

    //         }
    //         // console.log("currentFeat.getGeometry().getPolygons():");
    //         // console.log(currentFeat.getGeometry().getPolygons());
    //         // console.log("currentFeat.getGeometry().getType():");
    //         // console.log(currentFeat.getGeometry().getType());
    //     }
    // }
  } else {
    currentFeat = theFeatures[0];
    issitemultipolygon = false;
  }

  var clonefeat = currentFeat.clone();
  clonefeat.setId(currentFeat.getId());
  siteSource.addFeature(clonefeat);
  console.log("onZoneDrawProcess siteSource.getFeatures()", siteSource.getFeatures());
  var centroidFeat = getCenterOfMass(currentFeat);
  //check again is the site multipolygon
  var testFeats = siteSource.getFeatures();
  for (let i = 0; i < testFeats.length; i++) {
    var aFeat = testFeats[i];
    console.log("vecSource6 aFeat.getGeometry().getType()");
    console.log(aFeat.getGeometry().getType());
    if (aFeat.getGeometry().getType() === "MultiPolygon") {
      issitemultipolygon = true; //==> set the global variable.
      break;
    }
  }

  console.log("Create buffer with radius: ", radiusBuffer);
  var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer, theFeatures.length != groupTouchedIndexArr.length);
  siteBufferSource.addFeature(bufferedFeat);
  //check the geometry type of buffer. If issitemultipolygon = true, make sure buffer is also multipolygon.
  var bufferNeedToChangeToMultipolygon = false;
  if (issitemultipolygon) {
    testFeats = siteBufferSource.getFeatures();
    for (let i = 0; i < testFeats.length; i++) {
      var aFeat = testFeats[i];
      if (aFeat.getGeometry().getType() == "Polygon") {
        bufferNeedToChangeToMultipolygon = true;
        break;
      }
    }
  }
  var newBuffFeat = bufferedFeat;
  if (bufferNeedToChangeToMultipolygon) {
    var newCoordArr = [];
    newCoordArr.push(bufferedFeat.getGeometry().getCoordinates());
    newBuffFeat = new Feature({
      geometry: new MultiPolygon(newCoordArr),
    });
    siteBufferSource.clear();
    siteBufferSource.addFeature(newBuffFeat);
  }
  testFeats = siteBufferSource.getFeatures();
  for (let i = 0; i < testFeats.length; i++) {
    var aFeat = testFeats[i];
    console.log("vecSource4 aFeat.getGeometry().getType()");
    console.log(aFeat.getGeometry().getType());
  }

  // console.log("theFeatures");
  // console.log(theFeatures);
  // add indexes to the zones
  for (let i = 0; i < theFeatures.length; i++) {
    // var index = i+1;
    var currentZoneFeat = theFeatures[i];
    var anId = currentZoneFeat.get("id");
    var index = anId;
    var centroidZoneFeat = getCenterOfMass(currentZoneFeat);
    centroidZoneFeat.set("order", "zone " + index.toString());
    zoneLabelCentroidSource.addFeature(centroidZoneFeat);
    // currentZoneFeat.set('id', index);
  }
  // console.log("theFeatures");
  // console.log(theFeatures);

  // // add default index 1 after drawing site polygon. put the point to the label layer source (vecSource3), set the label to show on 'order' attribute.
  // var index = 1;
  // var centroidFeat = getCenterOfMass(currentFeat);
  // console.log(centroidFeat);
  // centroidFeat.set('order', "zone " + index.toString());
  // vecSource3.addFeature(centroidFeat);
  // currentFeat.set('id', index);

  //determine the district from the centroid location
  // getDistrictBySiteCentroid(centroidFeat.getGeometry());
  //checkWhetherBufferIntersectAnyNSRBuildings(bufferedFeat);
  checkWhetherBufferIntersectAnyNSRBuildings(newBuffFeat);
  return await getDistrictBySitePolygon(currentFeat.getGeometry());
}

function updateBuffer(tempSiteFeature, radiusBuffer) {
  //clear buffer source
  siteBufferSource.clear();
  // projBuildingPointsWFSSource.clear();
  // projBuildingWFSSource.clear();
  //union all zone polygons to get the site
  var currentFeat;
  var touchedIndexArr = [];
  var allTouchedIndexArr = [];
  var groupTouchedIndexArr = [];

  if (tempSiteFeature.length > 1) {
    groupTouchedIndexArr = getGroupOfIntersectedIndex(tempSiteFeature);
    console.log("groupTouchedIndexArr");
    console.log(groupTouchedIndexArr);

    // union all individual polygon
    var groupUnionArr = [];

    for (let i = 0; i < groupTouchedIndexArr.length; i++) {
      var curTouchedIndexArr = groupTouchedIndexArr[i];

      for (let j = 0; j < curTouchedIndexArr.length; j++) {
        var currentIndex = curTouchedIndexArr[j];
        if (j === 0) {
          currentFeat = tempSiteFeature[currentIndex];
        } else {
          currentFeat = getUnion(currentFeat, tempSiteFeature[currentIndex]);
        }
      }
      groupUnionArr.push(currentFeat);
    }

    //union all grouped polygons (multipolygon), if more than 1.
    if (groupUnionArr.length > 1) {
      console.log("groupUnionArr.length");
      console.log(groupUnionArr.length);
      issitemultipolygon = true; //==> set the global variable.
      for (let i = 0; i < groupUnionArr.length; i++) {
        console.log("i");
        console.log(i);
        if (i === 0) {
          currentFeat = groupUnionArr[i];
        } else {
          currentFeat = getUnion(currentFeat, groupUnionArr[i]);
        }
      }
    } else {
      issitemultipolygon = false; //==> set the global variable.
    }
    //     }
    // }
  } else {
    currentFeat = tempSiteFeature.length ? tempSiteFeature[0] : tempSiteFeature;
    issitemultipolygon = false;
  }
  console.log("Create buffer with radius: ", radiusBuffer);
  var bufferedFeat = getPolygonBuffer(currentFeat, radiusBuffer);
  siteBufferSource.addFeature(bufferedFeat);
  //check the geometry type of buffer. If issitemultipolygon = true, make sure buffer is also multipolygon.
  var bufferNeedToChangeToMultipolygon = false;
  if (issitemultipolygon) {
    let testFeats = siteBufferSource.getFeatures();
    for (let i = 0; i < testFeats.length; i++) {
      var aFeat = testFeats[i];
      if (aFeat.getGeometry().getType() == "Polygon") {
        bufferNeedToChangeToMultipolygon = true;
        break;
      }
    }
  }
  var newBuffFeat = bufferedFeat;
  if (bufferNeedToChangeToMultipolygon) {
    var newCoordArr = [];
    newCoordArr.push(bufferedFeat.getGeometry().getCoordinates());
    newBuffFeat = new Feature({
      geometry: new MultiPolygon(newCoordArr),
    });
    siteBufferSource.clear();
    siteBufferSource.addFeature(newBuffFeat);
  }
  return checkWhetherBufferIntersectAnyNSRBuildings(bufferedFeat);
}

function getDistrictBySiteCentroid(siteCentroidGeom) {
  const districtFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["HKDistrict_wgs84sp"],
    outputFormat: "application/json",
    filter: intersectsFilter("the_geom", siteCentroidGeom, "EPSG:3857"),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(districtFeatRequest);
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "POST");

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const districtfeatures = new GeoJSON().readFeatures(json);
      if (districtfeatures.length > 0) {
        var districtFeature = districtfeatures[0];
        var districtName = districtFeature.get("DISTRICT");
        siteDistrict = districtName;
      }
    });
}

// ### Get district when creating new project with new site
async function getDistrictBySitePolygon(siteGeom) {
  console.log("Inside getDistrictBySitePolygon");

  const districtFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["HKDistrict_wgs84sp"],
    outputFormat: "application/json",
    filter: intersectsFilter("the_geom", siteGeom, "EPSG:3857"),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(districtFeatRequest);
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "POST");

  return await fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      siteDistrict = "";
      const districtfeatures = new GeoJSON().readFeatures(json);
      if (districtfeatures.length > 0) {
        var districtArray = [];
        for (let i = 0; i < districtfeatures.length; i++) {
          var districtFeature = districtfeatures[i];
          var districtName = districtFeature.get("DISTRICT");
          districtArray.push(districtName);
        }
        siteDistrict = districtArray.join(",");
      }
      console.log("siteDistrict", siteDistrict);
      return siteDistrict;
    });
}

// ### show the popup notification.
function showModal(modalContentText) {
  // Get the modal
  var modal = document.getElementById("myNotif");
  modal.style.display = "block";
  modal.style.color = "black";
  var modalText = document.getElementById("myNotifText");
  modalText.innerHTML = modalContentText;

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("modalClose")[0];
  // When the user clicks on <span> (x), close the modal
  span.onclick = function () {
    modal.style.display = "none";
  };
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}

// ### show notif popup with yes no and input action
function showYesNoModal(modalContentText) {
  // Get the modal
  var modal = document.getElementById("myYesNoNotif");
  modal.style.display = "block";
  var modalText = document.getElementById("myYesNoNotifText");
  modalText.innerHTML = modalContentText;
  var modalNotif = document.getElementById("modalNotif");
  modalNotif.style.display = "block";
  var modalInput = document.getElementById("modalInput");
  modalInput.style.display = "none";

  // assign button onclick
  var modalYesButton = document.getElementById("yesNoButtonYes");
  var modalNoButton = document.getElementById("yesNoButtonNo");
  // When the user clicks on No button, close the modal
  modalNoButton.onclick = function () {
    modal.style.display = "none";
  };
  modalYesButton.onclick = function () {
    alert("yes is clicked");
  };
}

function checkWhetherBufferIntersectAnyNSRBuildings(bufferFeat) {
  var bufferGeom = bufferFeat.getGeometry();
  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    featureTypes: ["Building_2022_nsr_wgs84sp_noZM"],
    outputFormat: "application/json",
    filter: intersectsFilter("the_geom", bufferGeom, "EPSG:3857"),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  return fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      // console.log("checkWhetherBufferIntersectAnyNSRBuildings response");
      // console.log(response);
      return response.json();
    })
    .then(function (json) {
      const defaultBuildingfeatures = new GeoJSON().readFeatures(json);
      var eduNSRBuildingLayer = getLayerByTitle("notifEduNSRBuilding");
      eduNSRBuildingLayer.getSource().clear();

      if (defaultBuildingfeatures.length === 0) {
        // buffer does not intersect with any nsr buildings.
        showModal("No NSR building is found within the construction site buffer. Please try enlarging the study area.");

        return "No NSR building is found within the construction site buffer. Please try enlarging the study area.";
      } else {
        //CONTINUE WITH CHECKING 100m beyond the buffer for any educational building.
        // get current buildingids
        var initialBuildingIds = [];
        for (let i = 0; i < defaultBuildingfeatures.length; i++) {
          var aNSRBuildingFeat = defaultBuildingfeatures[i];
          var bdId = aNSRBuildingFeat.get("BUILDINGID");
          if (!initialBuildingIds.includes(bdId)) {
            initialBuildingIds.push(bdId);
          }
        }
        //buffer the buffer polygon for 100m
        var extendRadius = 100;
        var bufferedBufferFeat = getPolygonBuffer(bufferFeat, extendRadius);
        var bufferedBufferGeom = bufferedBufferFeat.getGeometry();
        // var testLayer = getLayerByTitle("calculatedNSRPointsLayer");
        // testLayer.getSource().addFeature(bufferedBufferFeat);

        //query from the layer
        const extensionFeatRequest = new WFS().writeGetFeature({
          srsName: "EPSG:3857",
          featureNS: "webcnmpws",
          featureTypes: ["Building_2022_nsr_wgs84sp_noZM"],
          outputFormat: "application/json",
          filter: intersectsFilter("the_geom", bufferedBufferGeom, "EPSG:3857"),
        });
        var xs = new XMLSerializer();
        var payload = xs.serializeToString(extensionFeatRequest);

        fetch(SERVER_URL + "/gsProxy/wfs", {
          method: "POST",
          body: payload,
        })
          .then(function (response) {
            // console.log("checkWhetherBufferIntersectAnyNSRBuildings 2nd response");
            //console.log(response);
            return response.json();
          })
          .then(function (json) {
            const extensionBuildingfeatures = new GeoJSON().readFeatures(json);
            var educationalFeat = [];
            var educationalBuildingIDs = [];

            for (let i = 0; i < extensionBuildingfeatures.length; i++) {
              var aNSRBuildingFeat = extensionBuildingfeatures[i];
              var bdId = aNSRBuildingFeat.get("BUILDINGID");
              var bdType = aNSRBuildingFeat.get("NSR");
              if (!initialBuildingIds.includes(bdId)) {
                // console.log("pass !initialBuildingIds.includes(bdId)");
                if (bdType.toLowerCase() === "educational") {
                  // console.log("pass bdType.toLowerCase() === 'educational'");
                  if (!educationalBuildingIDs.includes(bdId)) {
                    // console.log("pass !educationalBuildingIDs.includes(bdId)");
                    educationalBuildingIDs.push(bdId);
                    educationalFeat.push(aNSRBuildingFeat);
                  }
                }
              }
            }
            // console.log(educationalFeat);
            // add feature to a layer to show ################################################## not yet
            eduNSRBuildingLayer = getLayerByTitle("notifEduNSRBuilding");
            if (educationalFeat.length > 0) {
              for (let i = 0; i < educationalFeat.length; i++) {
                var eduBuildingFeat = educationalFeat[i];
                eduNSRBuildingLayer.getSource().addFeature(eduBuildingFeat);
              }

              showModal(
                "At least one Educational NSR building is located within 100m outside the current assessment area. You may consider enlarging assessment area in 'Define Site & Zone' window to include the Educational NSR."
              );
            }
          });

        return "";
      }
    });
}

olMap.getSiteDistrict = function () {
  return siteDistrict;
};

olMap.switchOffSiteDraw = function () {
  drawing = false;
  map.removeInteraction(siteDraw);
  finishingMoveCenterPoints();
};

olMap.switchOnCutterLineDraw = function (callback) {
  drawing = true;
  siteDraw = new Draw({
    source: vecSource2,
    type: "LineString",
  });
  map.addInteraction(siteDraw);
  zoneLabelCentroidLayer.setVisible(true);
  centerPtWFSLayer.setVisible(false);

  siteDraw.on("drawend", function (e) {
    //vecSource2.addFeature(e.feature);

    // console.log(vecSource)
    // console.log(vecSource2)

    // console.log(vecSource.getFeatures())
    // console.log(e.feature)

    const parser = new OL3Parser();
    parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);
    // let jstsPolygon = parser.read(vecSource.getFeatures()[0].getGeometry());
    // let jstsPoline = parser.read(e.feature.getGeometry());

    //loop one by one polygon features
    // var geoJSON = new GeoJSON();
    // var lineGeoJSON = geoJSON.writeFeatureObject(e.feature);
    // var lineTurfGeom = turf.getGeom(lineGeoJSON);
    var index = 0;
    let zonesToAdd = [];
    for (let i = 0; i < zoneSource.getFeatures().length; i++) {
      let currentZoneFeat = zoneSource.getFeatures()[i];
      // var polygonGeoJSON = geoJSON.writeFeatureObject(currentFeat);
      // var polygonTurfGeom = turf.getGeom(polygonGeoJSON);
      //if (turf.booleanIntersects(lineTurfGeom, polygonTurfGeom)) //if intersect with the line
      if (isIntersect(e.feature, currentZoneFeat)) {
        //if intersect with the line
        // get the splitted polygons
        var polygons = splitByLine(currentZoneFeat, e.feature);
        if (polygons.array.length >= 2) {
          // cut happened
          // delete current feature first
          //vecSource.removeFeature(currentFeat);
          // insert all splitted polygons
          polygons.array.forEach((geom) => {
            if (geom.getArea() > 0.00001) {
              let splitted_polygon = new Feature({
                geometry: new Polygon(parser.write(geom).getCoordinates()),
              });
              // console.log("splitted_polygon")
              // console.log(splitted_polygon)
              if (isPolygonCentroidWithinPolygon(splitted_polygon, currentZoneFeat)) {
                if (isGeomValid(splitted_polygon)) {
                  index = index + 1;
                  splitted_polygon.setId(index);
                  zonesToAdd.push(splitted_polygon);
                }
              }

              // console.log(vecSource.getFeatures().length)
              // console.log("isIntersect");
              // console.log(isIntersect(splitted_polygon,currentFeat));
              // console.log("isContain");
              // console.log(isContain(splitted_polygon,currentFeat));
              // console.log("isWithin");
              // console.log(isWithin(splitted_polygon,currentFeat));
            }
          });

          zoneSource.removeFeature(currentZoneFeat);
        } // cut not happen
        else {
          // do nothing

          // add id
          index = index + 1;
          currentZoneFeat.setId(index);
        }
      } //if not intersect
      else {
        // do nothing

        // add id
        index = index + 1;
        currentZoneFeat.setId(index);
      }
    }
    for (const zone of zonesToAdd) {
      zoneSource.addFeature(zone);
    }
    callback(zoneSource.getFeatures().length);

    // //Perform union of Polygon and Line and use Polygonizer to split the polygon by line
    // // console.log(jstsPolygon)
    // // console.log(jstsPoline)
    // let union = Union.union(jstsPolygon.getExteriorRing(),jstsPoline);
    // let polygonizer = new Polygonizer();
    // polygonizer.add(union);

    // //Get splitted polygons
    // let polygons = polygonizer.getPolygons();

    // if(polygons.array.length >= 2) {
    //     //Clear old splitted polygons and measurement overlays
    //     vecSource.clear();
    //     map.getOverlays().clear();

    //     //Iterate through splitted polygons
    //     polygons.array.forEach((geom) => {
    //         let splitted_polygon = new Feature({
    //             geometry: new Polygon(parser.write(geom).getCoordinates())
    //         });
    //         console.log("splitted_polygon")
    //         console.log(splitted_polygon)
    //         vecSource.addFeature(splitted_polygon);
    //         console.log(vecSource.getFeatures().length)

    //     });
    // }
    // else{

    // }

    // #### indexing
    zoneLabelCentroidSource.clear();
    let allIds = zoneSource.getFeatures().map((f) => f.get("id"));
    for (let i = 0; i < zoneSource.getFeatures().length; i++) {
      var currentZoneFeat = zoneSource.getFeatures()[i];
      var centroidFeat = getCenterOfMass(currentZoneFeat);
      if (currentZoneFeat.get("id")) {
        centroidFeat.set("order", currentZoneFeat.get("id").toString());
        allIds.push(currentZoneFeat.get("id"));
      } else {
        let index = 1;
        while (allIds.includes(index)) {
          index++;
        }
        centroidFeat.set("order", index.toString());
        currentZoneFeat.set("id", index);
        allIds.push(index);
      }
      // create centroid
      //var centroidFeat = getCentroid(currentFeat);
      zoneLabelCentroidSource.addFeature(centroidFeat);
    }

    map.removeInteraction(siteDraw);
  });
};

olMap.clearZoneDraw = function () {
  zoneSource.clear();
  zoneLabelCentroidSource.clear();

  calculatedNSRPointsSource.clear(); //red / green calculated nsr point
  nsrPointsSource.clear(); // uncalculated nsr point - purple
  vecSource7.clear(); //selected feature.
  equipmentManualLocationSource.clear(); // equipment points
  isAfterCalculation = false;

  let siteFeats = siteSource.getFeatures();
  let siteFeat;
  if (siteFeats.length) {
    siteFeat = siteFeats[0]; //get the first feat. There is only 1 site.
    let clonefeat = siteFeat.clone();
    clonefeat.setId(siteFeat.getId());
    // clonefeat.set("id", 1);
    zoneSource.addFeature(clonefeat);

    // add default index 1 after generating site polygon. put the point to the label layer source (vecSource3), set the label to show on 'order' attribute.
    let index = 1;
    let centroidFeat = getCenterOfMass(siteFeat);
    centroidFeat.set("order", "zone " + index.toString());
    zoneLabelCentroidSource.addFeature(centroidFeat);
  }

  let nsrPointLayer = getLayerByTitle("projectBuildingPointsLayer");
  let bufferFeat;
  for (let i = 0; i < siteBufferSource.getFeatures().length; i++) {
    bufferFeat = siteBufferSource.getFeatures()[i]; // buffer feature should be only 1
  }
  if (siteFeat && bufferFeat) {
    for (const manuallyAddedNSR of manuallyAddedNSRs) {
      if (isIntersect(manuallyAddedNSR, bufferFeat) && !isIntersect(manuallyAddedNSR, siteFeat)) {
        nsrPointLayer.getSource().addFeature(manuallyAddedNSR);
      }
    }
  }

  map.removeInteraction(siteDraw);
};

olMap.clearForNew = function () {
  clearTempLayers();
  toggleWFSLayersVisibility(false);
};

olMap.switchOffCutterLineDraw = function () {
  drawing = false;
  map.removeInteraction(siteDraw);
};

olMap.switchZoneOrderDraw = function () {
  isZoneOrderMode = !isZoneOrderMode;
};

olMap.switchOnEquipDraw = function (pmedata) {
  if (siteDraw) {
    map.removeInteraction(siteDraw);
  }

  siteDraw = new Draw({
    source: equipmentManualLocationSource,
    type: "Point",
  });
  console.log("pmedata: ", pmedata);
  var idx = pmedata.projectPMEId;
  eqpID = idx;
  var eqpName = pmedata.pme;
  console.log("eqpName", eqpName);
  var eqpZone = pmedata.zone;

  siteDraw.on("drawend", function (e) {
    // remove only the feaature with current id
    deleteEquipmentPointByID(eqpID);

    // //clear eqp point draw Source
    // vecSource5.clear();

    // if (eqpDrawEnded === true)
    // {
    //     e.preventDefault();
    //     return;
    // }
    console.log("Current idx is:", eqpID);
    console.log(e);
    var thisFeat = e.feature;
    thisFeat.setId(eqpID);
    thisFeat.set("othername", eqpName);
    thisFeat.set("zone", eqpZone);
    console.log("eqpName", eqpName);
    console.log("new feature should be");
    console.log(thisFeat);
    // eqpDrawEnded = true
    //eqpDraw.setActive(false);
    map.removeInteraction(siteDraw);
    console.log("after remove interacion");
  });

  map.addInteraction(siteDraw);
};
olMap.switchOffEquipDraw = function () {
  map.removeInteraction(siteDraw);
};
olMap.deleteEquipPointByID = function (theId) {
  map.removeInteraction(siteDraw);
  deleteEquipmentPointByID(theId);
};

function checkEqpInsideZone() {
  var zoneFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["zones"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", currentProjectID),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const zonefeatures = new GeoJSON().readFeatures(json);
      var zoneFeatsOrderById = [];
      console.log("zonefeatures", zonefeatures);
      if (zonefeatures.length > 0) {
        for (let i = 0; i < zonefeatures.length; i++) {
          for (let j = 0; j < zonefeatures.length; j++) {
            zoneFeat = zonefeatures[j];
            if (zoneFeat.get("id") === i + 1) {
              zoneFeatsOrderById.push(zoneFeat);
            }
          }
        }

        var deleteHappened = false;
        var insideOneZone = true;
        let zoneName = "";
        while (insideOneZone) {
          insideOneZone = false;
          for (let i = 0; i < equipmentManualLocationSource.getFeatures().length; i++) {
            var aEqpFeat = equipmentManualLocationSource.getFeatures()[i];
            var eqpZoneId = aEqpFeat.get("zone");
            if (!isIntersect(aEqpFeat, zoneFeatsOrderById[eqpZoneId - 1])) {
              insideOneZone = true;
              deleteHappened = true;
              zoneName = zoneFeatsOrderById[eqpZoneId - 1].get("name");
              equipmentManualLocationSource.removeFeature(aEqpFeat);
              break;
            }
          }
        }
        if (deleteHappened) {
          window.alert(`Please pick a location within ${zoneName}.`);
          map.addInteraction(siteDraw);
        }
      } else {
        console.log("Zone does not exist. Clearing all drawed equipment.");
        equipmentManualLocationSource.clear();
      }
    });
}

olMap.saveEquipmentGeometries = function () {
  // console.log("eqpObj");
  // console.log(eqpObjs);

  //call all pme features of current project ID (the rows that just inserted by the API without geometry)
  modifiedFeatureList = [];

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectPME"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", currentProjectID),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      console.log("All PME response with project id-" + currentProjectID.toString() + ":");
      console.log(response);
      return response.json();
    })
    .then(function (json) {
      const projPMEfeatures = new GeoJSON().readFeatures(json);
      if (projPMEfeatures.length > 0) {
        for (let i = 0; i < projPMEfeatures.length; i++) {
          var projPMEFeature = projPMEfeatures[i];
          var pmeId = projPMEFeature.get("pmeid");
          console.log("pmeId");
          console.log(pmeId);
          var isNotional = projPMEFeature.get("isnotional");
          if (isNotional.toLowerCase().indexOf("notional") >= 0) {
            //use notional distance
            projPMEFeature.setGeometry(null);
          } // use geometry
          else {
            projPMEFeature.setGeometry(getPointFromPMEVectorSourceByPMEID(pmeId));
          }

          modifiedFeatureList.push(projPMEFeature);
        }

        var task = "update";
        var geoserverWorkspace = "http://www.abc.com/webcnmpws";
        var editLayer = "projectPME";
        saveEdits(task, geoserverWorkspace, editLayer, "geom", saveEquipmentGeometries2);
      }
    });
};
function saveEquipmentGeometries2() {
  //console.log("inside saveEquipmentGeometries2");

  equipmentManualLocationSource.clear();

  //Non-notional PME
  var projectPMEWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectPME&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString() +
    "%20AND%20isnotional='Fixed%20Location'";
  projPMEWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projectPMEWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("pmeWFSLayer");
  thisLayer.setSource(projPMEWFSSource);
  thisLayer.setVisible(true);
  projPMEWFSSource.refresh();

  updateIsCalculated(currentProjectID, 0, null);
}

function updateIsCalculated(projectId, value, callback) {
  var bodyObj = new ProjectIsCalculated(projectId, value);
  var postURL = SERVER_URL2 + "Project/iscalculated";
  fetch(postURL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    //mode: 'no-cors',
    body: JSON.stringify(bodyObj),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      console.log("Finish updateIsCalculated into: " + value.toString());
      console.log(value);
      if (callback) {
        callback();
      }
    });
}

//below Marvin Alex
olMap.hyun = function (projectId) {
  isCalculatedGlobal2 = 0;
};
//above Marvin Alex

function getIsCalculated(projectId, callback) {
  var getURL = SERVER_URL2 + "Project/iscalculated/" + projectId.toString();
  fetch(getURL, {
    method: "GET",
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
      getSelectedNSR(projectId);
    })
    .then(function (json) {
      var isCalculated = JSON.parse(json);

      callback(isCalculated, projectId);
      //recalculate(isCalculated, projectId);
    });
}

//below Marvin Alex
olMap.getIsCalculatedForVue2 = function (projectId) {
  return isCalculatedGlobal2;
};
//above Marvin Alex

function getSelectedNSR(projectId, callback) {
  var getURL = SERVER_URL2 + "Project/selectednsr/" + projectId.toString();
  //var getURL = 'https://localhost:44384/Project/selectednsr/' + projectId.toString();
  fetch(getURL, {
    method: "GET",
  })
    .then(function (response) {
      return response.text();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (selNSR) {
      let nsrIds = selNSR.split(";")[0];
      let buildingIds = selNSR.split(";")[1];
      selectedNSRPoints = [];
      let nsrIdArr = nsrIds.split(",");
      let buildingIdArr = buildingIds.split(",");
      for (let i = 0; i < nsrIdArr.length; i++) {
        selectedNSRPoints.push({
          id: Number(nsrIdArr[i]),
          buildingId: Number(buildingIdArr[i]),
        });
      }
      selectedNSRPointIds = nsrIdArr.filter((id) => id !== "").map((id) => Number(id)); // store to global variable.
      // console.log("selectedNSRPointIds");
      // console.log(selectedNSRPointIds);
      // var isCalculated = JSON.parse(json);
      // callback(isCalculated, projectId);
      // //recalculate(isCalculated, projectId);
    });
}

function initSelectedNSRFeatures(selecting) {
  if (selectedNSRPoints.length > 0) {
    let calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");
    let allFeatures = calculatedNSRPointsLayer.getSource().getFeatures();
    console.log("initSelectedNSRFeatures allFeatures", allFeatures);
    console.log("initSelectedNSRFeatures selectedNSRPoints", selectedNSRPoints);

    for (const nsrPoint of selectedNSRPoints) {
      let target = allFeatures.filter((f) => f.get("buildingid") === nsrPoint.buildingId);
      selectedNSRFeatures = selectedNSRFeatures.filter((f1) => f1.get("buildingid") !== nsrPoint.buildingId);
      if (target.length) {
        selectedNSRFeatures.push(target[0]);
        if (selecting) {
          target[0].setStyle(selectednsrPointStyleFunction);
        }
      }
    }
    selectedNSRPoints = selectedNSRFeatures.map((f) => ({ id: f.get("id"), buildingId: f.get("buildingid") }));
    selectedNSRPointIds = selectedNSRPoints.map((p) => p.id);
  }
  console.log("initSelectedNSRFeatures selectedNSRFeatures", selectedNSRFeatures);
  console.log("initSelectedNSRFeatures selectedNSRPointIds", selectedNSRPointIds);
  console.log("initSelectedNSRFeatures selectedNSRPoints", selectedNSRPoints);
}

function getPMEObjectByPMEID(eqpObjs, pmeid) {
  for (let i = 0; i < eqpObjs.length; i++) {
    var pmeObj = eqpObjs[i];
    if (pmeObj.projectPMEId === pmeid) {
      return pmeObj;
    }
  }
  return null;
}
function getPointFromPMEVectorSourceByPMEID(pmeId) {
  console.log("trying to get eqp feat id: ", pmeId);
  console.log("from these features:");
  console.log(equipmentManualLocationSource.getFeatures());
  var searchedFeat = equipmentManualLocationSource.getFeatureById(pmeId);
  var thePoint = searchedFeat?.getGeometry();
  return thePoint;
}

olMap.saveProjectGISData = function (projectId, zones, isFinish, callback) {
  zoneLabelCentroidLayer.setVisible(false);
  centerPtWFSLayer.setVisible(true);
  equipmentManualLocationSource.clear();
  nsrPointsSource.clear();
  buildingPolygonSource.clear();
  //buildingIdForMitigation = 0;
  //vecTestSource.clear();

  currentProjectID = projectId;
  zonesInput = zones;
  saveProjectFinish = isFinish;
  console.log("currentProjectID");
  console.log(currentProjectID);
  console.log("zonesInput");
  console.log(zonesInput);
  console.log("isFinish");
  console.log(isFinish);

  newProjectSaveSite(projectId, callback); //### below got commmented because they run fomr inside this newProjectSaveSite function, so that they don't run in parallel.
  // newProjectSaveBuffer(projectId);
  // newProjectSaveZones(projectId);
  //getDefBuildingsIntersectBuffer(projectId);
  //getPointsOfProjNSRBuildings(projectId);
};

olMap.saveUnregSitesGISData = function (projectId) {
  newProjectSaveUnregSites(projectId);
};

olMap.prepareProjectTempLayers = function (clear) {
  if (clear) {
    //clear the temp layers
    siteSource.clear(); //site
    siteBufferSource.clear(); //bufer
    zoneSource.clear(); //zone
    unregisterSitesSource.clear(); //unreg site
    unregisterSiteBufferSource.clear(); //unreg buffer
  }

  //copy site layer to temp layer
  var aSiteLayer = "";
  if (issitemultipolygon) {
    aSiteLayer = getLayerByTitle("site2WFSLayer");
  } else {
    aSiteLayer = getLayerByTitle("siteWFSLayer");
  }
  var aSiteFeatures = aSiteLayer.getSource().getFeatures();
  //console.log(aSiteFeatures);
  for (let i = 0; i < aSiteFeatures.length; i++) {
    var aSiteFeature = aSiteFeatures[i];

    siteSource.addFeature(aSiteFeature);
  }
  aSiteLayer.setVisible(false);
  //console.log(vecSource6.getFeatures());

  //copy buffer layer to temp layer
  var aBufferLayer = "";
  if (issitemultipolygon) {
    aBufferLayer = getLayerByTitle("buffer2WFSLayer");
  } else {
    aBufferLayer = getLayerByTitle("bufferWFSLayer");
  }
  var aBufferFeatures = aBufferLayer.getSource().getFeatures();
  //console.log(aBufferFeatures);
  for (let i = 0; i < aBufferFeatures.length; i++) {
    var aBufferFeature = aBufferFeatures[i];

    siteBufferSource.addFeature(aBufferFeature);
  }
  aBufferLayer.setVisible(false);
  //console.log(vecSource4.getFeatures());

  //copy zone layer to temp layer
  var aZoneLayer = getLayerByTitle("zoneWFSLayer");
  var aZoneFeatures = aZoneLayer.getSource().getFeatures();
  //console.log(aZoneFeatures);
  for (let i = 0; i < aZoneFeatures.length; i++) {
    var aZoneFeature = aZoneFeatures[i];

    zoneSource.addFeature(aZoneFeature);
  }
  aZoneLayer.setVisible(false);
  console.log(zoneSource.getFeatures());

  //copy unreg site layer to temp layer
  var aUnregSiteLayer = getLayerByTitle("unregSiteWFSLayer");
  var aUnregSiteFeatures = aUnregSiteLayer.getSource().getFeatures();
  //console.log(aSiteFeatures);
  for (let i = 0; i < aUnregSiteFeatures.length; i++) {
    var aUnregSiteFeature = aUnregSiteFeatures[i];

    unregisterSitesSource.addFeature(aUnregSiteFeature);
  }
  aUnregSiteLayer.setVisible(false);
  //console.log(vecSource6.getFeatures());

  //copy unreg buffer layer to temp layer
  var aUnregBufferLayer = getLayerByTitle("unregBufferWFSLayer");
  var aUnregBufferFeatures = aUnregBufferLayer.getSource().getFeatures();
  //console.log(aBufferFeatures);
  for (let i = 0; i < aUnregBufferFeatures.length; i++) {
    var aUnregBufferFeature = aUnregBufferFeatures[i];

    unregisterSiteBufferSource.addFeature(aUnregBufferFeature);
  }
  aUnregBufferLayer.setVisible(false);
  //console.log(vecSource4.getFeatures());
};

olMap.prepareEquipmentTempLayers = function () {
  console.log("inside prepareEquipmentTempLayers");
  equipmentManualLocationSource.clear(); //eqp

  //copy unreg buffer layer to temp layer
  var aEqpLayer = getLayerByTitle("pmeWFSLayer");
  var aEqpFeatures = aEqpLayer.getSource().getFeatures();
  console.log("aEqpFeatures.length");
  console.log(aEqpFeatures.length);
  for (let i = 0; i < aEqpFeatures.length; i++) {
    var aEqpFeature = aEqpFeatures[i];

    equipmentManualLocationSource.addFeature(aEqpFeature);
  }
  aEqpLayer.setVisible(true);
  //console.log(vecSource4.getFeatures());
};

olMap.clearEquipmentTempLayers = function () {
  console.log("inside clearEquipmentTempLayers");
  equipmentManualLocationSource.clear(); //eqp

  var aEqpLayer = getLayerByTitle("pmeWFSLayer");
  aEqpLayer.setVisible(false);
};

function getZoneNameByIndex(index) {
  var resultName = "";
  for (let i = 0; i < zonesInput.length; i++) {
    var curId = zonesInput[i].id;
    if (curId === index) {
      resultName = zonesInput[i].name;
      break;
    }
  }
  return resultName;
}
function getZoneCalcTypeByIndex(index) {
  var result = "";
  for (let i = 0; i < zonesInput.length; i++) {
    var curId = zonesInput[i].id;
    if (curId === index) {
      result = zonesInput[i].calculationtype;
      break;
    }
  }
  return result;
}
function getZoneStartDateByIndex(index) {
  console.log("startdate");
  console.log(new Date(zonesInput[index - 1].startdate));
  console.log(getSimpleDate(new Date(zonesInput[index - 1].startdate)));
  return getSimpleDate(new Date(zonesInput[index - 1].startdate));
}
function getZoneEndDateByIndex(index) {
  console.log("enddate");
  console.log(new Date(zonesInput[index - 1].enddate));
  console.log(getSimpleDate(new Date(zonesInput[index - 1].enddate)));
  return getSimpleDate(new Date(zonesInput[index - 1].enddate));
}

olMap.savePMEGSData = function (projectid, zoneid, actid) {};

olMap.addNSRBuilding = function () {
  changeActionMode(1);

  //remove Not related layer
  removeLayerFromMap("projectBuildingLayer");

  // add related layers
  map.addLayer(defBuildingWFSLayer);
  map.addLayer(nsrBuildingWFSLayer);

  selectedDefaultBuildingFeats = [];

  // Begin draw to select

  // From selection, copy data to NSR building layer

  // Chec if at least one building is intersects the buffer, then re-draw the project building layer and re-calculate.

  // remove the non-default layers

  // return bac the default layers
};

olMap.processAddNSRBuilding = function () {
  modifiedFeatureList = [];
  // overlay layer for site is: vector6 = "sitelayer"
  var index = 0;
  var destGeom;
  var newPolygon;
  for (let i = 0; i < selectedDefaultBuildingFeats.length; i++) {
    newPolygon = selectedDefaultBuildingFeats[i];
    console.log(newPolygon);
    // destGeom = selectedDefaultBuildingFeats[i].getGeometry();
    // newPolygon = new Feature({
    //     geometry: destGeom
    // });
    modifiedFeatureList.push(newPolygon);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "Building_2022_nsr_wgs84sp_noZM";
  saveEdits(task, geoserverWorkspace, editLayer, "the_geom", processAddNSRBuilding2);
};

function processAddNSRBuilding2() {
  // also update the project nsr building if within buffer
  //get buffer
  var bufferFeat;
  var featType = "";
  if (issitemultipolygon) {
    featType = "buffers2";
  } else {
    featType = "buffers";
  }

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    //featureTypes: ['buffers'],
    //featureTypes: ['buffers2'],
    featureTypes: [featType],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", currentProjectID),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const bufferfeatures = new GeoJSON().readFeatures(json);
      if (bufferfeatures.length > 0) {
        modifiedFeatureList = [];
        bufferFeat = bufferfeatures[0]; //buffer is only 1 per project id
        var featExist = false;
        // var loopIndex = 1;
        for (let i = 0; i < selectedDefaultBuildingFeats.length; i++) {
          var tempFeat = selectedDefaultBuildingFeats[i];
          if (isIntersect(bufferFeat, tempFeat)) {
            featExist = true;
            var mpGeom = tempFeat.getGeometry();
            var thePolygons = mpGeom.getPolygons();
            var buildingid = selectedDefaultBuildingFeats[i].get("BUILDINGID");
            var noiseCrit = selectedDefaultBuildingFeats[i].get("noisecrit");
            var buildName = selectedDefaultBuildingFeats[i].get("BldName_E") == null ? "" : selectedDefaultBuildingFeats[i].get("BldName_E");
            var bdtype = selectedDefaultBuildingFeats[i].get("NSR");
            var bdHt =
              selectedDefaultBuildingFeats[i].get("Bld_Ht") == null
                ? selectedDefaultBuildingFeats[i].get("ROOFLEVEL") - selectedDefaultBuildingFeats[i].get("BASELEVEL")
                : selectedDefaultBuildingFeats[i].get("Bld_Ht");

            for (let j = 0; j < thePolygons.length; j++) {
              var aPolygon = thePolygons[j];
              let tempFeat = new Feature({
                geom: aPolygon,
              });
              tempFeat.set("projectid", currentProjectID);
              tempFeat.set("buildingid", buildingid);
              tempFeat.set("noisecriteria", noiseCrit); //### either to generate by if else by time, or to generate one fixed value by nsr type, or just copy from the origin source
              tempFeat.set("BldName_E", buildName);
              tempFeat.set("type", bdtype);
              tempFeat.set("Bld_Ht", bdHt);
              //tempFeat.set('noofshare', someAmount); ### find other projects that are approved and not yet end date
              tempFeat.set("modifiedAt", new Date().toISOString());
              // tempFeat.set('id', maxid + loopIndex);
              modifiedFeatureList.push(tempFeat);
              // loopIndex = loopIndex + 1;
            }
          }
        }

        if (!featExist) {
          finishingAddNSRBuilding();
        } else {
          // console.log("modifiedFeatureList");
          // console.log(modifiedFeatureList);
          var task = "insert";
          var geoserverWorkspace = "webcnmpws";
          var editLayer = "projectNSRBuilding";
          saveEdits(task, geoserverWorkspace, editLayer, "geom", finishingAddNSRBuilding);
        }
      }
    });
}

function finishingAddNSRBuilding() {
  getPointsOfProjNSRBuildings(currentProjectID);

  nsrBuildingWFSSource.refresh();
  clearSelectedBuilding();

  // remove the non-default layers
  map.removeLayer(defBuildingWFSLayer);
  map.removeLayer(nsrBuildingWFSLayer);

  // return bac the default layers
  map.addLayer(projBuildingWFSLayer);
  projBuildingWFSSource.refresh();

  changeActionMode(-1);
}

function clearSelectedBuilding() {
  var tempFeat;
  for (let i = 0; i < selectedDefaultBuildingFeats.length; i++) {
    tempFeat = selectedDefaultBuildingFeats[i];
    tempFeat.setStyle(undefined);
  }
  selectedDefaultBuildingFeats = [];
}

olMap.removeNSRBuilding = function () {
  changeActionMode(2);

  //remove Not related layer
  removeLayerFromMap("projectBuildingLayer");

  // add related layers
  map.addLayer(nsrBuildingWFSLayer);

  selectedDefaultBuildingFeats = [];
};

olMap.processRemoveNSRBuilding = function () {
  modifiedFeatureList = [];
  // overlay layer for site is: vector6 = "sitelayer"
  var index = 0;
  var destGeom;
  var newPolygon;
  buildingIdsForQuery = "";
  for (let i = 0; i < selectedDefaultBuildingFeats.length; i++) {
    newPolygon = selectedDefaultBuildingFeats[i];
    if (newPolygon.get("BUILDINGID")) {
      buildingIdsForQuery = buildingIdsForQuery + newPolygon.get("BUILDINGID").toString() + ",";
    }
    console.log(newPolygon);
    // destGeom = selectedDefaultBuildingFeats[i].getGeometry();
    // newPolygon = new Feature({
    //     geometry: destGeom
    // });
    modifiedFeatureList.push(newPolygon);
  }
  buildingIdsForQuery = buildingIdsForQuery.substring(0, buildingIdsForQuery.length - 1);
  var task = "delete";
  var geoserverWorkspace = "http://www.abc.com/webcnmpws";
  var editLayer = "Building_2022_nsr_wgs84sp_noZM";
  saveEdits(task, geoserverWorkspace, editLayer, "the_geom", processRemoveNSRBuilding2);
};

function processRemoveNSRBuilding2() {
  console.log("inside processRemoveNSRBuilding2");
  console.log("buildingIdsForQuery", buildingIdsForQuery);
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "projectnsrbuilding/projectid/" + currentProjectID + "/buildingids/" + buildingIdsForQuery; //##### later change with the that have projectid ==> DONE
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      processRemoveNSRBuilding3();
    });
}
function processRemoveNSRBuilding3() {
  console.log("inside processRemoveNSRBuilding3");
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "ProjectNSRPoints/projectid/" + currentProjectID + "/buildingids/" + buildingIdsForQuery; //##### later change with the that have projectid ==> DONE
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      finishingRemoveNSRBuilding();
    });
}

function finishingRemoveNSRBuilding() {
  console.log("inside finishingRemoveNSRBuilding");
  nsrBuildingWFSSource.refresh();
  clearSelectedBuilding();
  projBuildingWFSSource.refresh();
  projBuildingPointsWFSSource.refresh();

  // remove the non-default layers
  map.removeLayer(nsrBuildingWFSLayer);

  // return bac the default layers
  map.addLayer(projBuildingWFSLayer);

  changeActionMode(-1);
}

olMap.changeNoiseLevelNSRBuilding = function () {
  changeActionMode(3);

  selectedDefaultBuildingFeats = [];

  var buildingFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectNSRBuilding"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", currentProjectID),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const bufferfeatures = new GeoJSON().readFeatures(json);
      console.log("bufferfeatures.length", bufferfeatures.length);
      if (bufferfeatures.length > 0) {
        zoneLabelCentroidSource.clear();
        for (let i = 0; i < bufferfeatures.length; i++) {
          var tempFeat = bufferfeatures[i];
          var noisecrit = tempFeat.get("noisecriteria");
          var centroidFeat = getCenterOfMass(tempFeat);
          centroidFeat.set("order", noisecrit.toString());
          zoneLabelCentroidSource.addFeature(centroidFeat);
        }
      }
    });
};

olMap.processChangeNoiseLevelNSRBuilding = function (noiseLevel) {
  modifiedFeatureList = [];
  // overlay layer for site is: vector6 = "sitelayer"
  var index = 0;
  var destGeom;
  var newPolygon;
  for (let i = 0; i < selectedDefaultBuildingFeats.length; i++) {
    newPolygon = selectedDefaultBuildingFeats[i];
    newPolygon.set("noisecriteria", noiseLevel);
    console.log(newPolygon);
    // destGeom = selectedDefaultBuildingFeats[i].getGeometry();
    // newPolygon = new Feature({
    //     geometry: destGeom
    // });
    modifiedFeatureList.push(newPolygon);
  }
  var task = "update";
  var geoserverWorkspace = "http://www.abc.com/webcnmpws";
  var editLayer = "projectNSRBuilding";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", finishingChangeNoiseCriteriaBuilding);
};

function finishingChangeNoiseCriteriaBuilding() {
  nsrBuildingWFSSource.refresh();
  clearSelectedBuilding();
  zoneLabelCentroidSource.clear();

  changeActionMode(-1);
}

olMap.moveNSRBuildingPoints = function (addNSRHistory) {
  changeActionMode(4);
  movedNSRPointIds = [];
  movedNSRPointFeats = [];
  //copy all projectnsrpoints to temp nsr point layer vector11
  tempNSRPointsSource.clear();
  var nsrPointLayer = getLayerByTitle("projectBuildingPointsLayer");
  for (let i = 0; i < nsrPointLayer.getSource().getFeatures().length; i++) {
    let pointFeat = nsrPointLayer.getSource().getFeatures()[i];
    let newPointGeom = new Point(pointFeat.getGeometry().getCoordinates());
    let currentid = pointFeat.get("id");
    let currentNSRName = pointFeat.get("nsrname");
    // console.log("currentid");
    // console.log(currentid);
    let tempPointFeat = new Feature({
      geometry: newPointGeom,
    });
    tempPointFeat.setId(currentid);
    tempPointFeat.set("id", currentid);
    if (currentNSRName != null) {
      console.log("nsrname", currentNSRName);
      tempPointFeat.set("nsrname", currentNSRName);
    }
    tempPointFeat.setStyle(nsrPointStyleFunctionWithNSRName);

    tempNSRPointsSource.addFeature(tempPointFeat);
  }

  nsrBuildingBufferSource.clear();
  let nsrBuildingLayer = getLayerByTitle("projectBuildingLayer");
  for (let i = 0; i < nsrBuildingLayer.getSource().getFeatures().length; i++) {
    let buildingFeat = nsrBuildingLayer.getSource().getFeatures()[i];
    let bufferedBuilding = getPolygonBuffer(buildingFeat, 1, true);
    nsrBuildingBufferSource.addFeature(bufferedBuilding);
  }

  nsrPointLayer.setVisible(false);
  //make calculated green red points invisible first.
  let calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");
  calculatedNSRPointsLayer.setVisible(false);

  if (siteDraw) {
    map.removeInteraction(siteDraw);
  }

  siteDraw = new Modify({
    source: tempNSRPointsSource,
  });
  siteDraw.on("modifystart", function (e) {
    e.features.getArray().forEach((f) => {
      f.set("initCoords", f.getGeometry().getCoordinates());
    });
  });
  siteDraw.on("modifyend", function (e) {
    if (!movedNSRPointIds.includes(e.features.getArray()[0].getId())) {
      movedNSRPointIds.push(e.features.getArray()[0].getId());
      movedNSRPointFeats.push(e.features.getArray()[0]);
    } else {
      let existingIndex = movedNSRPointIds.indexOf(e.features.getArray()[0].getId());
      movedNSRPointFeats[existingIndex] = e.features.getArray()[0];
    }
    addNSRHistory(e.features.getArray()[0]);
  });
  map.addInteraction(siteDraw);

  //var nsrBuldngLayer = getLayerByTitle("projectBuildingLayer");
  snapDraw = new Snap({
    source: nsrBuildingBufferSource,
  });
  map.addInteraction(snapDraw);
};

olMap.processMoveNSRBuildingPoints = function (callback) {
  map.removeInteraction(siteDraw);
  map.removeInteraction(snapDraw);
  nsrBuildingBufferSource.clear();
  console.log("movedNSRPointIds", movedNSRPointIds);
  modifiedFeatureList = [];
  let nsrPointLayer = getLayerByTitle("projectBuildingPointsLayer");
  let calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");
  // console.log("nsrPointLayer.getSource().getFeatures()");
  // console.log(nsrPointLayer.getSource().getFeatures());
  nsrPointLayer
    .getSource()
    .getFeatures()
    .filter((f) => movedNSRPointIds.includes(f.get("id")))
    .forEach((f) => {
      let movedNSRPointFeat = movedNSRPointFeats.filter((f1) => f1.get("id") == f.get("id"));
      console.log("movedNSRPointFeat", movedNSRPointFeat);
      if (movedNSRPointFeat.length > 0) {
        f.setGeometry(movedNSRPointFeat[0].getGeometry());
        modifiedFeatureList.push(f);
      }
    });
  calculatedNSRPointsLayer
    .getSource()
    .getFeatures()
    .filter((f) => movedNSRPointIds.includes(f.get("id")))
    .forEach((f) => {
      let movedNSRPointFeat = movedNSRPointFeats.filter((f1) => f1.get("id") == f.get("id"));
      console.log("movedNSRPointFeat", movedNSRPointFeat);
      if (movedNSRPointFeat.length > 0) {
        f.setGeometry(movedNSRPointFeat[0].getGeometry());
        modifiedFeatureList.push(f);
      }
    });
  console.log("modifiedFeatureList", modifiedFeatureList);
  let task = "update";
  let geoserverWorkspace = "http://www.abc.com/webcnmpws";
  let editLayer = "projectNSRPoints";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
    finishingMoveNSRBuildingPoints();
    if (callback) callback();
  });
};

function finishingMoveNSRBuildingPoints() {
  movedNSRPointIds = [];
  movedNSRPointFeats = [];
  tempNSRPointsSource.clear();
  //turn on visibility.
  let nsrPointLayer = getLayerByTitle("projectBuildingPointsLayer");
  nsrPointLayer.setVisible(true);
  let thisLayer = getLayerByTitle("calculatedNSRPointsLayer");
  thisLayer.setVisible(true);

  changeActionMode(-1);
  console.log("finishingMoveNSRBuildingPoints");
}

olMap.addNewNSRPoints = function (projectId, nsrNameRef, noiseCriteriaRef) {
  var pointIdToFill = 0;

  //Get max nsr point ID first.
  var getURL = SERVER_URL2 + "ProjectNSRPoints/maxid";
  fetch(getURL, {
    method: "GET",
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (maxid) {
      console.log("maxid");
      console.log(maxid);

      changeActionMode(5);
      pointIdToFill = maxid + 1;

      siteDraw = new Draw({
        source: tempNSRPointsSource,
        type: "Point",
      });
      map.addInteraction(siteDraw);

      siteDraw.on("drawend", function (e) {
        tempNSRPointsSource.clear();

        var thisFeat = e.feature;
        thisFeat.set("projectid", projectId);
        thisFeat.set("buildingid", pointIdToFill);
        console.log("nsrname", nsrNameRef.modelValue);
        thisFeat.set("nsrname", nsrNameRef.modelValue);
        thisFeat.set("noisecriteria", parseFloat(noiseCriteriaRef.modelValue));
        thisFeat.set("Bld_Ht", 0);
        thisFeat.set("id", pointIdToFill);

        console.log("nsrName", nsrNameRef);
        console.log("projectid", projectId);
        console.log("nsrName", nsrNameRef.modelValue);
        console.log("noisecriteria", noiseCriteriaRef.modelValue);

        thisFeat.setStyle(nsrPointStyleFunctionWithNSRName);

        nsrFeaturesToAdd.push(thisFeat);
        console.log(nsrFeaturesToAdd);
      });
    });
};

olMap.processAddNewNSRPoints = function (callback, nsrName, noiseCriteria) {
  map.removeInteraction(siteDraw);
  modifiedFeatureList = [];
  // overlay layer for site is: vector6 = "sitelayer"
  var index = 0;
  var destGeom;
  var aFeat;
  for (let i = 0; i < tempNSRPointsSource.getFeatures().length; i++) {
    aFeat = tempNSRPointsSource.getFeatures()[i];
    if (nsrName) {
      aFeat.set("nsrname", nsrName);
    }
    if (noiseCriteria) {
      aFeat.set("noisecriteria", noiseCriteria);
    }
    console.log(aFeat);
    // destGeom = selectedDefaultBuildingFeats[i].getGeometry();
    // newPolygon = new Feature({
    //     geometry: destGeom
    // });
    modifiedFeatureList.push(aFeat);
    manuallyAddedNSRs.push(aFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "projectNSRPoints";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", finishingAddNewNSRPoints(callback));
};

function finishingAddNewNSRPoints(callback) {
  tempNSRPointsSource.clear();
  var nsrPointLayer = getLayerByTitle("projectBuildingPointsLayer");
  nsrPointLayer.getSource().refresh();
  changeActionMode(-1);
  console.log("finishingAddingNSRBuildingPoints");
  if (callback) {
    callback();
  }
}

olMap.removeNSRPoints = function () {
  changeActionMode(6);

  selectedDefaultBuildingFeats = [];
};
olMap.processRemoveNSRPoints = function (projectId, addNSRHistory, callback) {
  let removedNSRIds = [];
  var aPoint;
  let added = [];
  for (let i = 0; i < selectedNSRFeatures.length; i++) {
    var curSelectedFeat = selectedNSRFeatures[i];
    for (let j = 0; j < selectedDefaultBuildingFeats.length; j++) {
      var featToCheck = selectedDefaultBuildingFeats[j];
      if (curSelectedFeat.get("id") == featToCheck.get("id")) {
        selectedNSRFeatures.splice(i, 1);
        i--;
        break;
      }
    }
  }
  for (let i = 0; i < selectedDefaultBuildingFeats.length; i++) {
    aPoint = selectedDefaultBuildingFeats[i];
    console.log("aPoint", aPoint);
    if (!added.includes(aPoint.getId())) {
      aPoint.set("initCoords", aPoint.getGeometry().getCoordinates());
      addNSRHistory(aPoint);
      added.push(aPoint.getId());
    }
    if (aPoint.getId()) {
      var curId = aPoint.getId().replace("projectNSRPoints.", "");
      if (!removedNSRIds.includes(curId)) {
        removedNSRIds.push(curId);
      }
    }
    // console.log(aPoint);
    // console.log(aPoint.getId());
    // destGeom = selectedDefaultBuildingFeats[i].getGeometry();
    // newPolygon = new Feature({
    //     geometry: destGeom
    // });
    // modifiedFeatureList.push(aPoint);
    // let index = selectedNSRPointIds.indexOf(aPoint.get("id"));
    // if (index > -1) {
    //   selectedNSRPointIds.splice(index, 1);
    // }
    selectedNSRPoints = selectedNSRPoints.filter((p) => p.buildingId !== aPoint.get("buildingid"));
  }

  console.log("inside processRemoveNSRBuilding2");
  console.log("removedNSRIds", removedNSRIds);
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "ProjectNSRPoints/projectid/" + projectId + "/ids/" + removedNSRIds.join(","); //##### later change with the that have projectid
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      finishingRemoveNSRPoints();
      if (callback) {
        callback();
      }
    });
};

function finishingRemoveNSRPoints() {
  console.log("inside finishingRemoveNSRBuilding");
  clearSelectedBuilding();
  projBuildingPointsWFSSource.refresh();

  changeActionMode(-1);
}

olMap.moveCenterPoints = function () {
  changeActionMode(7);
  movedCenterPointIds = [];
  movedCenterPointFeats = [];
  //copy all projectnsrpoints to temp nsr point layer vector11
  tempNSRPointsSource.clear();
  var centerPointLayer = getLayerByTitle("centerPtWFSLayer");
  for (let i = 0; i < centerPointLayer.getSource().getFeatures().length; i++) {
    var pointFeat = centerPointLayer.getSource().getFeatures()[i];
    var newPointGeom = new Point(pointFeat.getGeometry().getCoordinates());
    var currentid = pointFeat.get("id");
    var currentProjid = pointFeat.get("projectid");
    var currentzoneid = pointFeat.get("zoneid");
    var currentzonename = pointFeat.get("zonename");
    var currentremark = pointFeat.get("remark");
    // console.log("currentid");
    // console.log(currentid);
    var tempPointFeat = new Feature({
      geometry: newPointGeom,
    });
    tempPointFeat.setId(currentid);
    tempPointFeat.set("id", currentid);
    tempPointFeat.set("projectid", currentProjid);
    tempPointFeat.set("zoneid", currentzoneid);
    tempPointFeat.set("zonename", currentzonename);
    tempPointFeat.set("remark", currentremark);
    // console.log("currentzoneid",currentzoneid);

    tempNSRPointsSource.addFeature(tempPointFeat);
  }

  centerPointLayer.setVisible(false);

  if (siteDraw) {
    map.removeInteraction(siteDraw);
  }

  siteDraw = new Modify({
    source: tempNSRPointsSource,
  });
  siteDraw.on("modifyend", function (e) {
    // console.log(e.features.getArray());
    // console.log(e.features.getArray().length);
    // console.log(e.features.getArray()[0].getId());
    var modZoneId = e.features.getArray()[0].get("zoneid");
    var modZoneCenterFeat = e.features.getArray()[0];

    //get the zone polygon to check. If outside zone polygon then should be ignored
    var zoneLayer = getLayerByTitle("zoneWFSLayer");
    var zoneFeats = zoneLayer.getSource().getFeatures();
    var zoneFeat;
    // console.log("zoneFeats",zoneFeats);
    for (let i = 0; i < zoneFeats.length; i++) {
      var zonePolygon = zoneFeats[i];
      // console.log("zonePolygon",zonePolygon);
      var zoneId = zonePolygon.get("id");
      console.log("zoneId");
      console.log(zoneId);
      console.log("modZoneId");
      console.log(modZoneId);
      if (modZoneId == zoneId) {
        console.log("enter " + zoneId + " " + modZoneId);
        zoneFeat = zonePolygon;
      }
    }
    console.log("zoneFeat", zoneFeat);
    if (zoneFeat && isIntersect(zoneFeat, modZoneCenterFeat)) {
      if (!movedCenterPointIds.includes(modZoneId)) {
        console.log("enter 1");
        movedCenterPointIds.push(modZoneId);
        movedCenterPointFeats.push(modZoneCenterFeat);
      } else {
        console.log("enter 2");
        var existingIndex = movedCenterPointIds.indexOf(modZoneId);
        movedCenterPointFeats[existingIndex] = modZoneCenterFeat;
      }
    } else {
      console.log("enter 3");
      var existingIndex = movedCenterPointIds.indexOf(modZoneId);
      if (existingIndex > -1) {
        movedCenterPointIds.splice(existingIndex, 1);
        movedCenterPointFeats.splice(existingIndex, 1);
      }
      alert("Geographical centre must be inside the zone");
    }
    // console.log("movedCenterPointIds");
    // console.log(movedCenterPointIds);
  });

  map.addInteraction(siteDraw);
};

olMap.processMoveCenterPoints = function () {
  map.removeInteraction(siteDraw);
  console.log("movedCenterPointIds");
  console.log(movedCenterPointIds);
  modifiedFeatureList = [];
  var centerPointLayer = getLayerByTitle("centerPtWFSLayer");
  // console.log("nsrPointLayer.getSource().getFeatures()");
  // console.log(nsrPointLayer.getSource().getFeatures());
  for (let i = 0; i < movedCenterPointIds.length; i++) {
    var pointId = movedCenterPointIds[i];
    for (let j = 0; j < centerPointLayer.getSource().getFeatures().length; j++) {
      var pointFeat = centerPointLayer.getSource().getFeatures()[j];
      var ptId = pointFeat.get("zoneid");
      if (ptId !== pointId) {
        continue;
      } else {
        pointFeat.setGeometry(movedCenterPointFeats[i].getGeometry());
        modifiedFeatureList.push(pointFeat);
      }
    }
  }

  console.log("modifiedFeatureList");
  console.log(modifiedFeatureList);
  var task = "update";
  var geoserverWorkspace = "http://www.abc.com/webcnmpws";
  var editLayer = "geomCenter";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", finishingMoveCenterPoints);
};

function finishingMoveCenterPoints() {
  movedCenterPointIds = [];
  movedCenterPointFeats = [];
  tempNSRPointsSource.clear();
  var centerPointLayer = getLayerByTitle("centerPtWFSLayer");
  centerPointLayer.setVisible(true);

  changeActionMode(-1);
  console.log("finishingMoveCenterPoints");
}

olMap.clearSelectedNSRBuildings = function () {
  //FOR CLOSE BUTTON IN NSR WINDOW
  clearSelectedBuilding();

  //add remove layers...
};
olMap.isAddNSRBuildingMode = function () {
  return isAddNSRBuildingMode;
};
olMap.isRemoveNSRBuildingMode = function () {
  return isRemoveNSRBuildingMode;
};
olMap.isChangeNoiseNSRBuildingMode = function () {
  return isChangeNoiseLevelNSRBuildingMode;
};
olMap.isChangeNoiseNSRBuildingPointMode = function () {
  return isChangeNoiseNSRBuildingPointMode;
};
olMap.isAddNSRPointsMode = function () {
  return isAddNSRPointsMode;
};
olMap.isRemoveNSRPointsMode = function () {
  return isRemoveNSRPointsMode;
};
olMap.isChangeCentralPointLocationMode = function () {
  return isChangeCentralPointMode;
};

olMap.setProjectObject = function (projObj) {
  projectObj = projObj;
  projectObj.calculationResultNSR = calculationResultNSRGlobal;
  console.log("projectObj");
  console.log(projectObj);
  console.log("projectObj.calculationResultNSR on setProjectObject");
  console.log(projectObj.calculationResultNSR);
};

olMap.setBuildingIdForMitigation = function (bdid, zoneTaskIds) {
  buildingIdForMitigation = bdid;
  zoneTaskIdsForMitigation = zoneTaskIds;
  console.log("ths lne set the buildingIdForMitigation");
  console.log(buildingIdForMitigation);
};

olMap.getCalculationResultNSR = function () {
  const ids = selectedNSRPointIds.map((id) => id.toString());
  return calculationResultNSRGlobal.filter((c) => ids.includes(c.nsrpointid.toString()));
};

olMap.openProjectGISData = function (projectid) {
  currentProjectID = projectid;
  zoneLabelCentroidSource.clear(); // ==> centroid to put zone label
  siteBufferSource.clear(); // ==> site buffer
  equipmentManualLocationSource.clear(); // ==> layer for equipment points for manual location / non-notional distance
  siteSource.clear(); // ==> For site. Originally vecSource, but vecSource is now for Zones.
  zoneSource.clear();
  vecSource7.clear(); // ==> For selection.
  nsrPointsSource.clear(); // ==> For generated nsrPoints
  unregisterSitesSource.clear(); // ==> unregsites
  unregisterSiteBufferSource.clear(); // ==> unregsites buffers
  tempNSRPointsSource.clear(); // ==> temp nsr points for modifying location ==> also used for add nsr point manually ==> also for temp center points for modifying location
  nsrBuildingBufferSource.clear(); // ==> 1m buffer of nsr building to snap the points
  buildingPolygonSource.clear(); // ==> to show educational building polygon if 100m buffer extension contains the super sensitive nsr building
  notionalPointSource.clear(); // ==> show notional point when NSR point click
  calculatedNSRPointsSource.clear();
  zoneNSRNotionalInfo = {};
  notionalPointsFeatArr = [];
  selectedNSRPointIds = [];
  selectedNSRFeatures = [];
  manuallyAddedNSRs = [];
  isAfterCalculation = false;
  console.log("resetng buildingIdForMitigation");
  buildingIdForMitigation = 0;

  //projectNSRBuilding
  var projectNSRBuildingWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectNSRBuilding&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  projBuildingWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projectNSRBuildingWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("projectBuildingLayer");
  thisLayer.setSource(projBuildingWFSSource);
  thisLayer.setVisible(true);

  //unreg buffer
  var unregbufferWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Aunregbuffers&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  unregBufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return unregbufferWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("unregBufferWFSLayer");
  thisLayer.setSource(unregBufferWFSSource);
  thisLayer.setVisible(true);

  //buffer
  var bufferWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  bufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return bufferWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("bufferWFSLayer");
  thisLayer.setSource(bufferWFSSource);
  thisLayer.setVisible(true);
  var buffer2WFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers2&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  buffer2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return buffer2WFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("buffer2WFSLayer");
  thisLayer.setSource(buffer2WFSSource);
  thisLayer.setVisible(true);

  //unreg site
  var unregsiteWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Aunregsites&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  unregSiteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return unregsiteWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("unregSiteWFSLayer");
  thisLayer.setSource(unregSiteWFSSource);
  thisLayer.setVisible(true);

  //site
  var siteWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  siteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return siteWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("siteWFSLayer");
  thisLayer.setSource(siteWFSSource);
  thisLayer.setVisible(true);
  var site2WFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites2&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  site2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return site2WFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("site2WFSLayer");
  thisLayer.setSource(site2WFSSource);
  thisLayer.setVisible(true);

  getCurrentSiteFeaturePutOnGlobalVar(projectid, null);

  //zone
  var zoneWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Azones&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  zoneWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return zoneWFSURL + "&srsname=EPSG:3857";
    },
  });
  var zoneWFSLayer = getLayerByTitle("zoneWFSLayer");
  zoneWFSLayer.setSource(zoneWFSSource);
  zoneWFSLayer.setVisible(true);

  //openZoneCentroidPoints(projectid); // ==> this will give labels to the zones. Changed to several lines below.

  //zone centroid
  var centerWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AgeomCenter&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  centerPtWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return centerWFSURL + "&srsname=EPSG:3857";
    },
  });
  var centerPtWFSLayer = getLayerByTitle("centerPtWFSLayer");
  centerPtWFSLayer.setSource(centerPtWFSSource);
  centerPtWFSLayer.setVisible(true);

  centerPtWFSSource.on("change", function (evt) {
    var source = evt.target;
    if (source.getState() === "ready") {
      openZoneCentroidPoints(projectid); // ==> this will give labels to the zones.
    }
  });

  //NSR points
  var projectNSRPointsWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectNSRPoints&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString();
  projBuildingPointsWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projectNSRPointsWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("projectBuildingPointsLayer");
  thisLayer.setSource(projBuildingPointsWFSSource);
  thisLayer.setVisible(true);
  projBuildingPointsWFSSource.refresh();
  projBuildingPointsWFSSource.once("featuresloadend", function () {
    const features = projBuildingPointsWFSSource.getFeatures();
    manuallyAddedNSRs = features.filter((f) => f.get("buildingid") < 1000000000);
  });
  //Non-notional PME
  var projectPMEWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectPME&outputFormat=application%2Fjson&cql_filter=projectid=" +
    projectid.toString() +
    "%20AND%20isnotional='Fixed%20Location'";
  projPMEWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projectPMEWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("pmeWFSLayer");
  thisLayer.setSource(projPMEWFSSource);
  thisLayer.setVisible(false);
  projPMEWFSSource.refresh();

  getSelectedNSR(projectid);
  approvedProjectIDs = [];
  openApprovedSites(projectid);

  zoomToCurrentBuffer(projectid);

  getIsCalculated(projectid, recalculate);
};

function recalculate(isCalculated, projectid) {
  console.log("isCalculated");
  console.log(isCalculated);
  if (isCalculated === 1) {
    calculateNoise1(projectid, null);
  }
}

function openApprovedSites(mainProjectId) {
  // var siteWFSURL = SERVER_URL + '/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites&outputFormat=application%2Fjson&cql_filter=projectid=' + projectid.toString();
  // siteWFSSource = new VectorSource({
  //     format: new GeoJSON(),
  //     url: function (extent) {
  //         return (
  //             siteWFSURL +
  //           '&srsname=EPSG:3857'
  //         );
  //     },
  // });
  // var thisLayer = getLayerByTitle("siteWFSLayer");
  // thisLayer.setSource(siteWFSSource);
  // thisLayer.values_.visible = true;

  approvedBufferWFSSource.clear();
  approvedSiteWFSSource.clear();
  approvedBuffer2WFSSource.clear();
  approvedSite2WFSSource.clear();

  //Get all approved ids
  //console.log("inside openApprovedSites");
  var approvedURL = SERVER_URL2 + "project/approved/" + mainProjectId.toString();
  //console.log(approvedURL);
  fetch(approvedURL, {
    method: "GET",
    //mode: 'no-cors',
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (approvedProjectIdsResponse) {
      console.log("approved project ids", approvedProjectIdsResponse);

      //approved buffer
      var approvedBufferWFSURL =
        SERVER_URL +
        `/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers&outputFormat=application%2Fjson&cql_filter=INTERSECTS(geom,%20querySingle(%27webcnmpws:buffers%27,%20%27geom%27,%27projectid=${mainProjectId.toString()}%27))and projectid%20IN(${
          approvedProjectIdsResponse.length ? approvedProjectIdsResponse.join() : "-1"
        })`;
      console.log("approvedBufferWFSURL", approvedBufferWFSURL);
      approvedBufferWFSSource = new VectorSource({
        format: new GeoJSON(),
        url: function (extent) {
          return approvedBufferWFSURL + "&srsname=EPSG:3857";
        },
      });
      var approvedBuffer2WFSURL =
        SERVER_URL +
        `/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers2&outputFormat=application%2Fjson&cql_filter=INTERSECTS(geom,%20querySingle(%27webcnmpws:buffers%27,%20%27geom%27,%27projectid=${mainProjectId.toString()}%27))and projectid%20IN(${
          approvedProjectIdsResponse.length ? approvedProjectIdsResponse.join() : "-1"
        })`;
      console.log("approvedBuffer2WFSURL", approvedBuffer2WFSURL);
      approvedBuffer2WFSSource = new VectorSource({
        format: new GeoJSON(),
        url: function (extent) {
          return approvedBuffer2WFSURL + "&srsname=EPSG:3857";
        },
      });
      var buttonOn = document.getElementById("onoffneighbourlayeron");
      var buttonOff = document.getElementById("onoffneighbourlayeroff");
      if (buttonOn) {
        buttonOn.style.display = "none";
      }
      if (buttonOff) {
        buttonOff.style.display = "none";
      }

      var approvedBufferSource;
      if (issitemultipolygon) {
        approvedBufferSource = approvedBuffer2WFSSource;
      } else {
        approvedBufferSource = approvedBufferWFSSource;
      }

      var getLoadedProjectIds = [];
      //approvedBufferWFSSource.on("featuresloadend", function(a) {
      approvedBufferSource.on("featuresloadend", function (a) {
        for (let j = 0; j < approvedBufferSource.getFeatures().length; j++) {
          var aFeat = approvedBufferSource.getFeatures()[j];
          getLoadedProjectIds.push(aFeat.get("projectid"));
        }

        // console.log("getLoadedProjectIds.join()");
        // console.log(getLoadedProjectIds.join());
        // store to global var
        approvedProjectIDs = getLoadedProjectIds;

        // after get the final projectid array, load the sites too
        //approved sites
        var approvedSitesWFSURL =
          SERVER_URL +
          `/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites&outputFormat=application%2Fjson&cql_filter=projectid%20IN(${
            getLoadedProjectIds.length ? getLoadedProjectIds.join() : "-1"
          })`;
        approvedSiteWFSSource = new VectorSource({
          format: new GeoJSON(),
          url: function (extent) {
            return approvedSitesWFSURL + "&srsname=EPSG:3857";
          },
        });
        var aLayer = getLayerByTitle("approvedSiteWFSLayer");
        aLayer.setSource(approvedSiteWFSSource);
        aLayer.setVisible(true);
        var approvedSites2WFSURL =
          SERVER_URL +
          `/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites2&outputFormat=application%2Fjson&cql_filter=projectid%20IN(${
            getLoadedProjectIds.length ? getLoadedProjectIds.join() : "-1"
          })`;
        approvedSite2WFSSource = new VectorSource({
          format: new GeoJSON(),
          url: function (extent) {
            return approvedSites2WFSURL + "&srsname=EPSG:3857";
          },
        });
        var aLayer = getLayerByTitle("approvedSite2WFSLayer");
        aLayer.setSource(approvedSite2WFSSource);
        aLayer.setVisible(true);

        var tempSiteSource;
        if (issitemultipolygon) {
          tempSiteSource = approvedSite2WFSSource;
        } else {
          tempSiteSource = approvedSiteWFSSource;
        }

        //approvedSiteWFSSource.on("featuresloadend", function(a) {
        tempSiteSource.on("featuresloadend", function (a) {
          approvedNeighbourLayersLoaded = true;

          if (getLoadedProjectIds.length > 0) {
            var buttonOn = document.getElementById("onoffneighbourlayeron");
            var buttonOff = document.getElementById("onoffneighbourlayeroff");
            if (buttonOn) {
              buttonOn.style.display = "inline";
            }
            if (buttonOff) {
              buttonOff.style.display = "inline";
            }
          }

          // get required approved sites parameters
          // get dates of current main project
          var datesURL = SERVER_URL2 + "Project/getdates/" + mainProjectId.toString();
          //console.log(approvedURL);
          fetch(datesURL, {
            method: "GET",
            //mode: 'no-cors',
          })
            .then(function (response) {
              return response.text();
            })
            .catch((error) => {
              console.log(error);
            })
            .then(function (dateText) {
              var sDateAndEDates = dateText.split("#");
              // console.log("sDateAndEDates",sDateAndEDates);
              // console.log("getLoadedProjectIds");
              // console.log(getLoadedProjectIds);

              var neibourTaskURL = `${SERVER_URL2}task/multiprojects/${getLoadedProjectIds.length ? getLoadedProjectIds.join() : "-1"}/${
                sDateAndEDates[0]
              }/${sDateAndEDates[1]}`;
              //console.log(approvedURL);
              fetch(neibourTaskURL, {
                method: "GET",
                //mode: 'no-cors',
              })
                .then(function (response) {
                  return response.json();
                })
                .catch((error) => {
                  console.log(error);
                })
                .then(function (result) {
                  // console.log("task result");
                  // console.log(result);

                  //store the approved sites' task schedule on global var
                  approvedProjectScheduleTasks = result;

                  //process for each approved projectid
                  const zoneTaskRequests = {
                    requests: [],
                  };
                  for (let a = 0; a < getLoadedProjectIds.length; a++) {
                    var currentProjId = getLoadedProjectIds[a];

                    /**
                     * @type {Array<Array<{ taskZoneId: string; taskid: string }>>}
                     */
                    var currentProjId_ZoneTask = getCombinedZoneTaskListArrayPerProjectid(
                      currentProjId,
                      new Date(sDateAndEDates[0]),
                      new Date(sDateAndEDates[1]),
                      result
                    );

                    const zoneTaskRequest = {
                      projectId: currentProjId,
                      allZoneTasks: currentProjId_ZoneTask,
                    };

                    zoneTaskRequests.requests.push(zoneTaskRequest);
                  }

                  console.log("zoneTaskRequests: ", zoneTaskRequests);
                  const projectzonetaskBody = JSON.stringify(zoneTaskRequests);

                  //get neighbour resultnsr
                  var neibourTaskURL = SERVER_URL2 + "CalculationResultNSR/projectzonetask";
                  //console.log(approvedURL);
                  fetch(neibourTaskURL, {
                    method: "POST",
                    body: projectzonetaskBody,
                    headers: {
                      "Content-Type": "application/json",
                    },
                    //mode: 'no-cors',
                  })
                    .then(function (response) {
                      return response.json();
                    })
                    .catch((error) => {
                      console.log(error);
                    })
                    .then(function (result) {
                      console.log("CalculationResultNSR");
                      console.log(result);

                      //store the calculationresultnsr on global var
                      approvedProjectCalculationResultNSR = result;
                    });
                });
            });
        });
      });

      var thisLayer = getLayerByTitle("approvedBufferWFSLayer");
      thisLayer.setSource(approvedBufferWFSSource);
      thisLayer.setVisible(true);
      var thisLayer = getLayerByTitle("approvedBuffer2WFSLayer");
      thisLayer.setSource(approvedBuffer2WFSSource);
      thisLayer.setVisible(true);
    });

  // var pmeFeat;

  // const defaultFeatRequest = new WFS().writeGetFeature({
  //     srsName: 'EPSG:3857',
  //     featureNS: 'webcnmpws',
  //     //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
  //     featureTypes: ['projectPME'],
  //     outputFormat: 'application/json',
  //     filter: andFilter(equalToFilter('projectid', mainProjectId), intersectsFilter("the_geom",mainBufferGeom,"EPSG:3857"))
  // })
  // var xs = new XMLSerializer();
  // var payload = xs.serializeToString(defaultFeatRequest);

  // fetch(SERVER_URL + '/gsProxy/wfs', {
  //     method:'POST',
  //     body: payload
  // })
  // .then(function (response) {
  //     return response.json();
  // })
  // .then(function (json) {
  //     const pmefeatures = new GeoJSON().readFeatures(json);
  //     if (pmefeatures.length > 0 )
  //     {
  //         thisProjectCalculatedPMEFeats = [];
  //         for (let i = 0; i < pmefeatures.length; i++) {
  //             pmeFeat = pmefeatures[i];
  //             thisProjectCalculatedPMEFeats.push(pmeFeat);
  //         }
  //         console.log("PME Feats have been populated. " + thisProjectCalculatedPMEFeats.length.toString() + " feat exist.");

  //         console.log("Site feat is:");
  //         console.log(globalCurrentSiteFeature);

  //         calculateNoise3(projectId, callback);
  //     }

  // })
}

olMap.SwitchNeibourLayer = function (isOn) {
  console.log(isOn);
  var aLayer = getLayerByTitle("approvedSiteWFSLayer");
  aLayer.setVisible(isOn);
  aLayer.getSource().refresh();
  aLayer = getLayerByTitle("approvedBufferWFSLayer");
  aLayer.setVisible(isOn);
  aLayer.getSource().refresh();
  aLayer = getLayerByTitle("approvedSite2WFSLayer");
  aLayer.setVisible(isOn);
  aLayer.getSource().refresh();
  aLayer = getLayerByTitle("approvedBuffer2WFSLayer");
  aLayer.setVisible(isOn);
  aLayer.getSource().refresh();
};

olMap.IsApprovedNeighbourLayersLoaded = function () {
  return approvedNeighbourLayersLoaded;
};

function zoomToCurrentBuffer(projectid, callback) {
  // var featType = "";
  // if (issitemultipolygon) {
  //   featType = "buffers2";
  // } else {
  //   featType = "buffers";
  // }
  const bufferFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    // featureTypes: ["buffers"],
    featureTypes: ["buffers", "buffers2"],
    // featureTypes: [featType],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectid),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(bufferFeatRequest);
  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const bufferfeatures = new GeoJSON().readFeatures(json);
      if (bufferfeatures.length > 0) {
        map.getView().fit(bufferfeatures[0].getGeometry().getExtent(), {
          callback: function () {
            console.log("zoomed");
            if (callback) {
              callback();
            }
          },
        });
      }
    });
}

olMap.showPMEInitActions = function () {
  equipmentManualLocationSource?.clear();
  console.log("inside showPMEInitActions");
  // copy the projPMEWFSSource to vecSource5

  var thisLayer = getLayerByTitle("pmeWFSLayer");
  var pmewfsSc = thisLayer.getSource();
  var pmeFeat;
  for (let i = 0; i < pmewfsSc.getFeatures().length; i++) {
    pmeFeat = pmewfsSc.getFeatures()[i];
    //console.log(pmeFeat);
    equipmentManualLocationSource.addFeature(pmeFeat);
  }
  for (let i = 0; i < equipmentManualLocationSource.getFeatures().length; i++) {
    pmeFeat = equipmentManualLocationSource.getFeatures()[i];
    // console.log("pmeFeat", pmeFeat);
    // pmeFeat.setId(pmeFeat.id_.split(".")[1]);
    pmeFeat.setId(pmeFeat.get("pmeid"));
    console.log(pmeFeat.getId());
  }
  console.log("vecSource5.getFeatures()");
  console.log(equipmentManualLocationSource.getFeatures());
  thisLayer.setVisible(true);
  var tempLayer = getLayerByTitle("equipmentPointLayer");
};
olMap.showPMEEndActions = function () {
  equipmentManualLocationSource.clear();
  console.log("inside showPMEEndActions");
  // copy the projPMEWFSSource to vecSource5

  var thisLayer = getLayerByTitle("pmeWFSLayer");
  thisLayer.setVisible(false);
};

olMap.getBuildingHeight = function (bldid) {
  for (let j = 0; j < allBuildingsHeight.length; j++) {
    var bdHgObj = allBuildingsHeight[j];
    if (bdHgObj.key === bldid) {
      return bdHgObj.item;
    }
  }
  return 0;
};

olMap.newCustDictionary = function (key, item, remark) {
  var a = new CustDictionary(key, item, remark);
  return a;
};

olMap.calculateNoise = function (projectObject, callback) {
  projectObj = projectObject; //==> assign to global var.
  console.log("olMap.calculateNoise");
  // console.log("projectObject");
  // console.log(projectObject);
  calculateNoise1(projectObject.id, callback);
};

// ### pre calculation, get all nsrpoints for this projectid
function calculateNoise1(projectid, callback) {
  // get all projectnsrpoints by projectid, store it in Array

  var pointsFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectNSRPoints"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectid),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const nsrPointfeatures = new GeoJSON().readFeatures(json);
      if (nsrPointfeatures.length > 0) {
        thisProjectCalculatedNSRPointFeats = nsrPointfeatures;
        console.log("NSRPointFeats have been populated. " + thisProjectCalculatedNSRPointFeats.length.toString() + " feat exist.");
        calculateNoise2(projectid, callback);
      } else {
        console.log("No NSR Points for this Project. Please set the NSR points first.");
        isAfterCalculation = true;
        updateIsCalculated(projectid, 1, callback);
        isCalculatedGlobal2 = 1; //added by Marvin Alex
      }
    });
}

// ### pre calculation, get all equipment for this projectid
function calculateNoise2(projectId, callback) {
  // get all pme by projectid, store it in Array
  // console.log("calculateNoise2 callbac");
  // console.log(callback);
  var pmeFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectPME"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectId),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const pmefeatures = new GeoJSON().readFeatures(json);
      if (pmefeatures.length > 0) {
        thisProjectCalculatedPMEFeats = [];
        thisProjectCalculatedPMEFeats = pmefeatures;
        console.log("PME Feats have been populated. " + thisProjectCalculatedPMEFeats.length.toString() + " feat exist.");
        // console.log(thisProjectCalculatedPMEFeats);

        console.log("Site feat is:");
        console.log(globalCurrentSiteFeature);

        calculateNoise3(projectId, callback);
      } else {
        alert("PME is not set for this Project. Please set the equipment first.");
      }
    });
}

// ### pre calculation, get all zones for this projectid
function calculateNoise3(projectId, callback) {
  //get zone geometry
  globalCurrentZoneFeatures = [];
  var zoneFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["zones"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectId),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const zonefeatures = new GeoJSON().readFeatures(json);
      if (zonefeatures.length > 0) {
        var aCentroid;
        globalCurrentZoneFeatures = zonefeatures;
        console.log("Zone Feats have been populated. " + globalCurrentZoneFeatures.length.toString() + " feat exist.");

        calculateNoise4(projectId, callback);
      }
    });
}

// ### pre calculation, get all tasks for this projectid
function calculateNoise4(projectId, callback) {
  //get zone geometry
  thisProjectCalculateTask = [];
  var zoneFeat;

  var taskURL = SERVER_URL2 + "task?id=" + projectId.toString();
  //console.log(approvedURL);
  fetch(taskURL, {
    method: "GET",
    //mode: 'no-cors',
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      thisProjectCalculateTask = json;
      //console.log(thisProjectCalculateTask);
      calculateNoise5(projectId, callback);
    });
}

// ### pre calculation, get all calculation result of all approved projects for this projectid
function calculateNoise5(projectId, callback) {
  if (approvedProjectIDs.length > 0) {
    // if touches project sites
    var projectIdInComma = approvedProjectIDs.join();

    //Get all calculated data from db
    var getURL = SERVER_URL2 + "CalculationResultGroup/multiprojects/" + projectIdInComma;
    fetch(getURL, {
      method: "GET",
      //mode: 'no-cors',
    })
      .then(function (response) {
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      })
      .then(function (json) {
        console.log("Finish calculateNoise5");
        // console.log(json);

        calculateNoise6(projectId, json, callback);
      });
  } else {
    calculateNoise6(projectId, null, callback);
  }
}

function getZoneFeatFromArray(index) {
  let zone = globalCurrentZoneFeatures.filter((f) => f.get("id") === index);
  if (zone.length > 0) {
    return zone[0];
  } else {
    return null;
  }
}
function getZoneCentroidFeatFromArray(index) {
  var theZoneFeat = getZoneFeatFromArray(index);
  if (theZoneFeat) {
    var aCentroid = getSavedCenterPointByZoneID(index);
    //return getCenterOfMass(theZoneFeat);
    if (aCentroid == null) {
      aCentroid = getCenterOfMass(theZoneFeat);
    }
    return aCentroid;
  } else {
    return null;
  }
}

function testgetZoneCenterOfMassFeatFromArray(index) {
  var theZoneFeat = getZoneFeatFromArray(index);
  if (theZoneFeat) {
    return getCenterOfMass(theZoneFeat);
  } else {
    return null;
  }
}
function testgetZoneCentroidFeatFromArray(index) {
  var theZoneFeat = getZoneFeatFromArray(index);
  if (theZoneFeat) {
    return getCentroid(theZoneFeat);
  } else {
    return null;
  }
}
function testgetZoneCenterFeatFromArray(index) {
  var theZoneFeat = getZoneFeatFromArray(index);
  if (theZoneFeat) {
    return getCenter(theZoneFeat);
  } else {
    return null;
  }
}

olMap.getCombinedNoiseLevelOL = function (numberArray) {
  return getCombinedNoiseLevel(numberArray);
};

function getCombinedNoiseLevel(numberArray) {
  var sumNumber = 0;
  for (let i = 0; i < numberArray.length; i++) {
    var furtheCalc = Math.pow(10, numberArray[i] / 10);
    sumNumber = sumNumber + furtheCalc;
  }
  var total = 10 * Math.log10(sumNumber);

  return total;
}

//Alex modified below
function getExtendedLineAtTheEndForKilometerDistance(extensionDistance, linestringGeometry) {
  var linestringCoordinates = linestringGeometry.getCoordinates();
  var lastPointCoord = linestringCoordinates[linestringCoordinates.length - 1];
  var secondToLastPointCoord = linestringCoordinates[linestringCoordinates.length - 2];
  var lastPoint = new Feature(new Point(lastPointCoord));
  var secondToLastPoint = new Feature(new Point(secondToLastPointCoord));
  var lastPoint01 = lastPoint.getGeometry().getCoordinates();
  var lastPoint01 = [].concat.apply([], lastPoint01);
  var secondToLastPoint01 = secondToLastPoint.getGeometry().getCoordinates();
  var secondToLastPoint01 = [].concat.apply([], secondToLastPoint01);
  var lastPoint02 = JSON.stringify(lastPoint01);
  var secondToLastPoint02 = JSON.stringify(secondToLastPoint01);
  var lastPoint03 = epsg3857toEpsg4326(lastPoint01);
  var secondToLastPoint03 = epsg3857toEpsg4326(secondToLastPoint01);
  var pt1 = turf.point(lastPoint03);
  var pt2 = turf.point(secondToLastPoint03);

  var linestringBearing = turf.bearing(pt2, pt1);
  console.log("앵글");
  console.log(linestringBearing);

  var destinationoptions = { units: "kilometers" };
  var destinationPoint = turf.destination(pt2, extensionDistance, linestringBearing, destinationoptions);

  var destinationPoint01 = destinationPoint.geometry.coordinates;

  var destinationPoint02 = epsg4326toEpsg3857(destinationPoint01);

  return destinationPoint02;
}
//Alex modified above and below
function epsg4326toEpsg3857(coordinates) {
  let x = coordinates[0];
  let y = coordinates[1];
  x = (coordinates[0] * 20037508.34) / 180;
  y = Math.log(Math.tan(((90 + coordinates[1]) * Math.PI) / 360)) / (Math.PI / 180);
  y = (y * 20037508.34) / 180;
  return [x, y];
}

function epsg3857toEpsg4326(pos) {
  let x = pos[0];
  let y = pos[1];
  x = (x * 180) / 20037508.34;
  y = (y * 180) / 20037508.34;
  y = (Math.atan(Math.pow(Math.E, y * (Math.PI / 180))) * 360) / Math.PI - 90;
  return [x, y];
}

function getNotionalInfo(pointZoneId, nsrPointFeat) {
  var { notionalPoint, calcType } = getNotionalPoint(pointZoneId, nsrPointFeat);
  if (!notionalPoint) {
    return {
      notionalPoint: notionalPoint,
      notionalDistance: null,
      calcType: calcType,
    };
  }
  //console.log(outPointAtBorder);
  var notionalDistancePointArr = [notionalPoint.getCoordinates(), nsrPointFeat.getGeometry().getCoordinates()];
  //Alex modified Feb 23
  var notionalDistanceLine = new LineString(notionalDistancePointArr);
  var notionalDistance = getLength(notionalDistanceLine);
  return {
    notionalPoint: notionalPoint,
    notionalDistance: notionalDistance,
    calcType: calcType,
  };
}

//Alex modified below and above
function getNotionalPoint(pointZoneId, nsrPointFeat) {
  //### check if this is calculation type A or B
  var zoneFeature = getZoneFeatFromArray(pointZoneId);
  if (!zoneFeature) {
    return {
      notionalPoint: null,
      calcType: calcType,
    };
  }
  var calcType = zoneFeature.get("calculationtype");
  if (calcType) {
    if (calcType === "B") {
      calcTypeTemp = "B";
      var zoneCentroid = getZoneCentroidFeatFromArray(pointZoneId);
      zoneCentroidTest = zoneCentroid; // save to global var
      zoneCentroidTest2 = testgetZoneCentroidFeatFromArray(pointZoneId);
      zoneCentroidTest3 = testgetZoneCenterFeatFromArray(pointZoneId);
      var notionalPoint;
      //check if the centroid is outside of the polygon (not intersect)
      var longerCoordinateIndex = 0;
      if (isIntersect(zoneFeature, zoneCentroid)) {
        var maxCoorMembers = 0;
        if (zoneFeature.getGeometry().getCoordinates().length > 1) {
          for (let i = 0; i < zoneFeature.getGeometry().getCoordinates().length; i++) {
            var aCoorSet = zoneFeature.getGeometry().getCoordinates()[i];
            if (maxCoorMembers < aCoorSet.length) {
              maxCoorMembers = aCoorSet.length;
              longerCoordinateIndex = i;
            }
          }
        }
      }

      var bbb = zoneFeature.getGeometry().getCoordinates();

      var poly = turf.polygon(bbb);
      var aaa = turf.polygonToLine(poly);

      var zoneLine = new LineString(
        zoneFeature.getGeometry().getCoordinates()[longerCoordinateIndex],

        "XY"
      );
      var zoneLineFeat = new Feature({
        geometry: zoneLine,
      });
      var xxx = new LineString(bbb);
      var zzz = aaa.geometry.coordinates;
      var yyy = new Feature(zzz);

      var www = new Feature({
        geometry: xxx,
      });

      var david = nsrPointFeat.getGeometry().getCoordinates();

      var geoJSON = new GeoJSON();
      //var featGeoJSON1 = geoJSON.writeFeatureObject(zoneLineFeat);
      var featGeoJSON1 = geoJSON.writeFeatureObject(zoneLineFeat);
      var featTurfGeom1 = turf.getGeom(featGeoJSON1);
      var ddd = new Feature(featTurfGeom1);
      var featTurfGeom2 = zoneLineFeat.getGeometry().getCoordinates();
      ///var featTurfGeom2 = yyy.getGeometry().getCoordinates();
      //var featTurfGeom2 = bbb;
      featTurfGeom2 = [].concat.apply([], featTurfGeom2);

      var eee = new Feature(featTurfGeom1);

      var jesus = zoneLineFeat.getGeometry().transform("EPSG:3857", "EPSG:4326");

      // var hhh = xxx.transform("EPSG:3857", "EPSG:4326");

      // console.log('가자 가자 가자');
      // console.log(hhh)

      var christ = jesus.getCoordinates();

      var davidgood = epsg3857toEpsg4326(david);

      var line = turf.lineString(christ);
      var pt = turf.point(davidgood);

      var snapped = turf.nearestPointOnLine(line, pt);

      var snapped01 = snapped.geometry.coordinates;
      var snapped02 = epsg4326toEpsg3857(snapped01);

      var pointArr = [david, snapped02];
      var finalshortestline = new LineString(pointArr);

      var linestringCoordinates = finalshortestline.getCoordinates();
      var lastPointCoord = linestringCoordinates[linestringCoordinates.length - 1];
      var secondToLastPointCoord = linestringCoordinates[linestringCoordinates.length - 2];
      var lastPoint = new Feature(new Point(lastPointCoord));
      var secondToLastPoint = new Feature(new Point(secondToLastPointCoord));
      var lastPoint01 = lastPoint.getGeometry().getCoordinates();
      var lastPoint01 = [].concat.apply([], lastPoint01);
      var secondToLastPoint01 = secondToLastPoint.getGeometry().getCoordinates();
      var secondToLastPoint01 = [].concat.apply([], secondToLastPoint01);
      var lastPoint02 = JSON.stringify(lastPoint01);
      var secondToLastPoint02 = JSON.stringify(secondToLastPoint01);
      var lastPoint03 = epsg3857toEpsg4326(lastPoint01);
      var secondToLastPoint03 = epsg3857toEpsg4326(secondToLastPoint01);
      var pt1 = turf.point(lastPoint03);
      var pt2 = turf.point(secondToLastPoint03);

      var linestringBearing = turf.bearing(pt2, pt1);

      var destinationoptions = { units: "kilometers" };
      var extensionDistance = 20;
      var destinationPoint = turf.destination(pt2, extensionDistance, linestringBearing, destinationoptions);

      var destinationPoint01 = destinationPoint.geometry.coordinates;

      var destinationPoint02 = epsg4326toEpsg3857(destinationPoint01);

      var pointArr2 = [destinationPoint02, david];

      // var paul = getExtendedLineAtTheEndForKilometerDistance(
      //   20,
      //   finalshortestline
      // );

      // connection from nsrPoint to destinationPoint //

      var line1 = turf.lineString([destinationPoint02, david]);

      var ans = turf.lineIntersect(line1, featTurfGeom1);

      if (ans.features.length < 2) {
        // var linestringCoordinates = finalshortestline.getCoordinates();

        // var lastPointCoord =
        //   linestringCoordinates[linestringCoordinates.length - 2];
        var snapped03 = new Point(snapped02);
        var notionalPoint = snapped03;
        outPointAtBorder = snapped03;

        return {
          notionalPoint: notionalPoint,
          calcType: calcType,
        };
      } else {
        var Apoint = ans.features[0].geometry.coordinates;
        var Bpoint = ans.features[1].geometry.coordinates;

        // connection from Apoint to Bpoint
        var pointArr = [Apoint, Bpoint];
        var AToBLine = new LineString(pointArr);
        var AToBLineFeat = new Feature({
          geometry: AToBLine,
        });
        var AToBDistance = AToBLine.getLength();
        var fraction = 0.5;
        //notionalPoint = new Point(AToBLine.getCoordinateAt(fraction));
        var centralPoint;
        centralPoint = new Point(AToBLine.getCoordinateAt(fraction));
        //var newdavid = nsrPointFeat.getGeometry().getCoordinates();

        //var kkk = centralPoint.features.geometry.coordinates;
        var kkk = centralPoint.getCoordinates();

        // var newgeoJSON = new GeoJSON();
        // var newfeatGeoJSON1 = newgeoJSON.writeFeatureObject(zoneLineFeat);
        // var newfeatTurfGeom1 = turf.getGeom(newfeatGeoJSON1);

        // var newfeatTurfGeom2 = zoneLineFeat.getGeometry().getCoordinates();
        // newfeatTurfGeom2 = [].concat.apply([], newfeatTurfGeom2);
        // var newjesus = zoneLineFeat
        //   .getGeometry()
        //   .transform("EPSG:3857", "EPSG:4326");
        // console.log('김정희2');
        // console.log(zoneLineFeat);
        // var newchrist = newjesus.getCoordinates();
        // console.log('김정희3');
        // console.log(newchrist);

        // var newdavidgood = epsg3857toEpsg4326(newdavid);
        // console.log('김정희4');
        // console.log(newdavidgood);

        // var newline = turf.lineString(newchrist);
        // var newpt = turf.point(newdavidgood);
        // console.log('김정희5');
        // console.log(newline);
        // console.log(newpt);

        // var newsnapped = turf.nearestPointOnLine(newline, newpt);
        // var newsnapped01 = newsnapped.geometry.coordinates;
        // var newsnapped02 = epsg4326toEpsg3857(newsnapped01);
        // var centralPoint;
        // centralPoint = new Point(AToBLine.getCoordinateAt(fraction));

        var pointArr007 = [kkk, snapped02];

        var fraction007 = 0.5;
        var CentralToSnappedLine = new LineString(pointArr007);
        notionalPoint = new Point(CentralToSnappedLine.getCoordinateAt(fraction007));

        //outPointAtBorder = Apoint; // save to global var, 위의 if처럼 시도
        var snapped03 = new Point(snapped02);

        //outPointAtBorder = Apoint;
        outPointAtBorder = snapped03;

        return {
          notionalPoint: notionalPoint,
          calcType: calcType,
        };
      }
    }
  }
  //### get notional point
  var zoneCentroid = getZoneCentroidFeatFromArray(pointZoneId);
  zoneCentroidTest = zoneCentroid; // save to global var
  zoneCentroidTest2 = testgetZoneCentroidFeatFromArray(pointZoneId);
  zoneCentroidTest3 = testgetZoneCenterFeatFromArray(pointZoneId);
  var notionalPoint;

  //check if the centroid is outside of the polygon (not intersect)
  if (isIntersect(zoneFeature, zoneCentroid) && zoneFeature && zoneCentroid && nsrPointFeat) {
    var longerCoordinateIndex = 0;
    var maxCoorMembers = 0;
    if (zoneFeature.getGeometry().getCoordinates().length > 1) {
      for (let i = 0; i < zoneFeature.getGeometry().getCoordinates().length; i++) {
        var aCoorSet = zoneFeature.getGeometry().getCoordinates()[i];
        if (maxCoorMembers < aCoorSet.length) {
          maxCoorMembers = aCoorSet.length;
          longerCoordinateIndex = i;
        }
      }
    }
    // change the zone to line
    var zoneLine = new LineString(zoneFeature.getGeometry().getCoordinates()[longerCoordinateIndex], "XY");
    var zoneLineFeat = new Feature({
      geometry: zoneLine,
    });
    // console.log(zoneCentroid.getGeometry().getCoordinates());
    var pointArr = [zoneCentroid.getGeometry().getCoordinates(), nsrPointFeat.getGeometry().getCoordinates()];
    var distanceLine = new LineString(pointArr);
    var distanceLineFeat = new Feature({
      geometry: distanceLine,
    });
    var currentDistance = distanceLine.getLength();
    //get notional point
    var pointAtSiteBorder = getIntesectedPoint(distanceLineFeat, zoneLineFeat, nsrPointFeat);
    if (!pointAtSiteBorder) {
      console.error("NSR Point is within zone boundary");
      console.error("zoneFeature", zoneFeature);
      console.error("nsrPointFeat", nsrPointFeat);

      return {
        notionalPoint: null,
        calcType: calcType,
      };
    }
    var pointArr2 = [zoneCentroid.getGeometry().getCoordinates(), pointAtSiteBorder.getGeometry().getCoordinates()];
    var centroidToSiteBorderLine = new LineString(pointArr2);
    var fraction = 0.5;
    notionalPoint = new Point(centroidToSiteBorderLine.getCoordinateAt(fraction));
    outPointAtBorder = pointAtSiteBorder; // save to global var //Feb 22 Alex modified

    //check if the notional point has bigger distance than 50m from the site boundary
    var pointCheckArr = [pointAtSiteBorder.getGeometry().getCoordinates(), notionalPoint.getCoordinates()];
    var lineCheck = new LineString(pointCheckArr);
    //var bigSizeCheckDistance = getLength(lineCheck);
    var bigSizeCheckDistance = lineCheck.getLength();
    if (bigSizeCheckDistance > 50 && centroidToSiteBorderLine.getLength() > 0) {
      //fraction = 50 / getLength(centroidToSiteBorderLine);
      let fraction50 = 50 / centroidToSiteBorderLine.getLength();
      fraction = 1 - fraction50;
      notionalPoint = new Point(centroidToSiteBorderLine.getCoordinateAt(fraction));
    }

    return {
      notionalPoint: notionalPoint,
      calcType: calcType,
    };
  } else {
    //get the nearestpoint on the site/zone boundary. Will find a LineString first.
    var shortestLineGeom = getShortestLine(zoneFeature.getGeometry(), zoneCentroid.getGeometry());
    var firstCoord = shortestLineGeom.getFirstCoordinate();
    var lastCoord = shortestLineGeom.getLastCoordinate();
    var pointAtSiteBoundaryCoord;
    if (toStringXY(firstCoord, 4) === toStringXY(zoneCentroid.getGeometry().getCoordinates(), 4)) {
      pointAtSiteBoundaryCoord = lastCoord;
    } else {
      pointAtSiteBoundaryCoord = firstCoord;
    }
    notionalPoint = new Point(pointAtSiteBoundaryCoord);

    // save to global var
    outPointAtBorder = new Feature({
      geometry: notionalPoint,
    });

    //outPointAtBorder = outPointAtBorder.geometry.coordinates;

    return {
      notionalPoint: notionalPoint,
      calcType: calcType,
    };
  }
}
//Alex Modified above

function isTwoDatesOverlaped(startA, endA, startB, endB) {
  return (startA < endB || isSameDay(startA, endB)) && (endA > startB || isSameDay(endA, startB));
}

function isSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

/**
 * @returns {Array<Array<{ taskZoneId: string; taskid: string }>>}
 */
function getCombinedZoneTaskListArrayPerProjectid(projectid, startDate, endDate, projectTaskObjArr) {
  /**
   * @type {Array<Array<{ taskZoneId: string; taskid: string }>>}
   */
  var combinedZoneTaskListArr = [];
  var alreadyAdded = new Map();

  //var currentStartDateCheckOverlap = startDate;
  var currentStartDateCheckOverlap = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

  while (currentStartDateCheckOverlap <= endDate) {
    // do we use dates in PME? or do we use tasks dates? Below is assume we use tasks dates. We assume PME dates do not exist.
    /**
     * @type {Array<{ taskZoneId: string; taskid: string }>}
     */
    var zoneTaskToCombine = [];
    for (let i = 0; i < projectTaskObjArr.length; i++) {
      var currentTask = projectTaskObjArr[i];
      //console.log(currentTask);
      if (currentTask.projectId !== projectid) {
        continue;
      }
      var taskStartDate = new Date(currentTask.start);
      var taskEndDate = new Date(currentTask.end);
      var taskZoneId = currentTask.zone;
      var taskid = parseInt(currentTask.id);

      if (
        isTwoDatesOverlaped(currentStartDateCheckOverlap, currentStartDateCheckOverlap, taskStartDate, taskEndDate) &&
        !alreadyAdded.has(taskZoneId) &&
        !alreadyAdded.get(taskZoneId)?.hash(taskid)
      ) {
        zoneTaskToCombine.push({
          taskZoneId: taskZoneId.toString(),
          taskid: taskid.toString(),
        });
        const inner = new Set();
        inner.add(taskid);
        alreadyAdded.set(taskZoneId, inner);
      }
    }

    if (zoneTaskToCombine.length > 0) {
      combinedZoneTaskListArr.push(zoneTaskToCombine);
    }

    var beginingMonthDate = new Date(
      currentStartDateCheckOverlap.getFullYear(),
      currentStartDateCheckOverlap.getMonth(),
      currentStartDateCheckOverlap.getDate()
    );
    //set the date to the beginning of next month
    currentStartDateCheckOverlap = new Date(beginingMonthDate.setDate(beginingMonthDate.getDate() + 1));
  }

  return combinedZoneTaskListArr;
}

// ### the main noise calculation function
function calculateNoise6(projectId, approvedData, callback) {
  // var siteCentroid = getCenterOfMass(globalCurrentSiteFeature);
  // var siteLine = new LineString(globalCurrentSiteFeature.getGeometry().getCoordinates()[0], 'XY');;
  // var siteLineFeat = new Feature({
  //     geometry: siteLine
  // });
  console.log("enter calculateNoise6");
  console.log("calculateNoise6 selectedNSRFeatures", selectedNSRFeatures);
  console.log("calculateNoise6 selectedNSRPointIds", selectedNSRPointIds);
  console.log("calculateNoise6 selectedNSRPoints", selectedNSRPoints);
  let minDistance = 999999;

  let labelThreshold = 68;

  //vecTestSource.clear();
  let thisLayer = getLayerByTitle("calculatedNSRPointsLayer");
  thisLayer.setVisible(true);
  thisLayer.getSource().clear();
  //thisLayer.getSource().addFeature(distanceLineFeat);"endd"

  // get the zone-task group first
  let zoneTaskIds = [...new Set(thisProjectCalculatedPMEFeats.map((f) => `${f.get("zone")}-${f.get("taskid")}`))];
  let minStartDate = new Date(projectObj.commencementDate);
  let maxEndDate = new Date(projectObj.completionDate);

  // console.log(projectObj.commencementDate);
  // console.log(projectObj.completionDate);
  // get overlapped dates for every zonetasks
  var combinedZoneTaskListArr = [];
  var combinedZoneTaskWithApprovedSitesArr = [];
  var currentStartDateCheckOverlap = minStartDate;
  var beginingMonthDate = new Date(
    currentStartDateCheckOverlap.getFullYear(),
    currentStartDateCheckOverlap.getMonth(),
    currentStartDateCheckOverlap.getDate()
  );
  while (currentStartDateCheckOverlap <= maxEndDate) {
    // do we use dates in PME? or do we use tasks dates? Below is assume we use tasks dates. We assume PME dates do not exist.
    var zoneTaskToCombine = [];
    for (const currentTask of thisProjectCalculateTask) {
      if (isTwoDatesOverlaped(currentStartDateCheckOverlap, currentStartDateCheckOverlap, new Date(currentTask.start), new Date(currentTask.end))) {
        zoneTaskToCombine.push(`${currentTask.zone}-${currentTask.id}`);
      }
    }

    //check approved neighbour sites
    var approvedZoneTaskCombined = [];
    for (const curProjId of approvedProjectIDs) {
      for (const curProjTask of approvedProjectScheduleTasks) {
        if (curProjTask.projectId != curProjId) {
          continue;
        }
        if (isTwoDatesOverlaped(currentStartDateCheckOverlap, currentStartDateCheckOverlap, new Date(curProjTask.start), new Date(curProjTask.end))) {
          approvedZoneTaskCombined.push(`${curProjId}#${curProjTask.zone}-${curProjTask.id}`);
        }
      }
    }
    if (approvedProjectIDs.length > 0) {
      approvedZoneTaskCombined.push(...zoneTaskToCombine);
    }
    // console.log("approvedZoneTaskCombined");
    // console.log(approvedZoneTaskCombined);

    let combinedZoneTaskId = zoneTaskToCombine.sort().join("+");
    if (!combinedZoneTaskListArr.includes(combinedZoneTaskId) && combinedZoneTaskId !== "") {
      combinedZoneTaskListArr.push(combinedZoneTaskId);
    }

    let approvedcombinedZoneTaskId = approvedZoneTaskCombined.sort().join("+");

    if (!combinedZoneTaskWithApprovedSitesArr.includes(approvedcombinedZoneTaskId) && approvedcombinedZoneTaskId !== "") {
      combinedZoneTaskWithApprovedSitesArr.push(approvedcombinedZoneTaskId);
    }

    beginingMonthDate = new Date(
      currentStartDateCheckOverlap.getFullYear(),
      currentStartDateCheckOverlap.getMonth(),
      currentStartDateCheckOverlap.getDate()
    );
    //set the date to the next day
    currentStartDateCheckOverlap = new Date(beginingMonthDate.setDate(beginingMonthDate.getDate() + 1));
  }

  //split type B zonetasks
  let combinedZoneTaskListArrSplit = [];
  let combinedZoneTaskWithApprovedSitesArrSplit = [];

  for (const combinedZoneTaskList of combinedZoneTaskListArr) {
    const zoneTask = combinedZoneTaskList.split("+");
    const typeAZoneTasks = [];
    const typeBZoneTasks = [];

    for (const zt of zoneTask) {
      const zoneId = parseInt(zt.split("-")[0]);
      if (getZoneFeatFromArray(zoneId)?.get("calculationtype") == "B") {
        typeBZoneTasks.push(zt);
      } else {
        typeAZoneTasks.push(zt);
      }
    }

    for (const zt of typeBZoneTasks) {
      combinedZoneTaskListArrSplit.push([...typeAZoneTasks, zt].sort().join("+"));
    }
    if (typeBZoneTasks.length == 0) {
      combinedZoneTaskListArrSplit.push(typeAZoneTasks.sort().join("+"));
    }
  }
  // combinedZoneTaskListArr = combinedZoneTaskListArrSplit;

  //to check
  combinedZoneTaskListArr = combinedZoneTaskListArrSplit.filter((c) => c.includes("+"));

  for (const combinedZoneTaskList of combinedZoneTaskWithApprovedSitesArr) {
    const zoneTask = combinedZoneTaskList.split("+");
    const typeAZoneTasks = [];
    const typeBZoneTasks = [];

    for (const zt of zoneTask) {
      const zoneId = parseInt(zt.split("-")[0]);
      if (getZoneFeatFromArray(zoneId)?.get("calculationtype") == "B") {
        typeBZoneTasks.push(zt);
      } else {
        typeAZoneTasks.push(zt);
      }
    }

    for (const zt of typeBZoneTasks) {
      combinedZoneTaskWithApprovedSitesArrSplit.push([...typeAZoneTasks, zt].sort().join("+"));
    }
    if (typeBZoneTasks.length == 0) {
      combinedZoneTaskWithApprovedSitesArrSplit.push(typeAZoneTasks.sort().join("+"));
    }
  }
  // combinedZoneTaskWithApprovedSitesArr =
  //   combinedZoneTaskWithApprovedSitesArrSplit;
  // to check
  combinedZoneTaskWithApprovedSitesArr = combinedZoneTaskWithApprovedSitesArrSplit.filter((c) => c.includes("+"));

  // array for insert into calculation result detail database
  var calculationResultOriginalDetailArray = [];
  var calculationResultMitigatedDetailArray = [];
  var calculationResultDetailArray = [];
  // array for insert into calculation result detail database - end

  var totalCNLOriginalInZoneTask = [];
  var totalCNLMitigatedInZoneTask = [];
  var exclGroupNamesOriginalInZoneTask = [];
  var exclGroupNamesMitigatedInZoneTask = [];
  var pmeArrayForZoneTaskFromMaxExcGroup = [];

  //variable for considering the fixed location pme
  var zoneTask_ExclusiveGroupList = [];
  const projectPMEFeatsByZoneTask = new Map();
  for (const pmeFeat of thisProjectCalculatedPMEFeats) {
    const zoneTaskKey = `${pmeFeat.get("zone")}-${pmeFeat.get("taskid")}`;
    if (!projectPMEFeatsByZoneTask.has(zoneTaskKey)) {
      projectPMEFeatsByZoneTask.set(zoneTaskKey, []);
    }
    projectPMEFeatsByZoneTask.get(zoneTaskKey).push(pmeFeat);
  }
  console.log("zoneTaskIds", zoneTaskIds);

  for (const currentZoneTaskId of zoneTaskIds) {
    const currentZoneTaskFeats = projectPMEFeatsByZoneTask.get(currentZoneTaskId) || [];
    var oriCalculatonResultDetailGroupArr = [];
    var mitCalculatonResultDetailGroupArr = [];

    var fixedLocationExist = false;
    // list the exclusive group first
    var excGroupNames = [];
    var excGroupNamesMain = [];
    var bothExcGroupVersion = [];

    currentZoneTaskFeats.forEach((currentFeat) => {
      let currentExclusiveGroup = currentFeat.get("exclusivegroup") == null ? "" : currentFeat.get("exclusivegroup").trim();
      if (!excGroupNamesMain.includes(currentExclusiveGroup) && currentExclusiveGroup != "") {
        excGroupNamesMain.push(currentExclusiveGroup);
      }

      let currentIsNotional = currentFeat.get("isnotional");
      if (currentIsNotional.toLowerCase().includes("fix")) {
        fixedLocationExist = true;
        //update currentExclusiveGroup for fix location equipment
        currentExclusiveGroup = `${currentExclusiveGroup}#${currentFeat.id_.split(".")[1]}`;
      }

      if (!excGroupNames.includes(currentExclusiveGroup) && currentExclusiveGroup != "") {
        excGroupNames.push(currentExclusiveGroup);
      }
    });
    if (excGroupNames.length > 0 && excGroupNamesMain.length === 0) {
      excGroupNames.push("");
      excGroupNamesMain.push("");
    }
    bothExcGroupVersion.push(excGroupNames);
    bothExcGroupVersion.push(excGroupNamesMain);
    // console.log("bothExcGroupVersion");
    // console.log(bothExcGroupVersion);

    var zoneTask_ExcGrpDict = new CustDictionary(currentZoneTaskId, bothExcGroupVersion, fixedLocationExist);
    zoneTask_ExclusiveGroupList.push(zoneTask_ExcGrpDict);
    // console.log("zoneTask_ExclusiveGroupList");
    // console.log(zoneTask_ExclusiveGroupList);

    var totalCNLOriginalInExcGroup = [];
    var totalCNLMitigatedInExcGroup = [];
    //put var array of pme here......
    var pmeArrayForAllExcGroups = [];

    // console.log("currentZoneTaskId");
    // console.log(currentZoneTaskId);

    for (const excGroupName of excGroupNames) {
      var exclGroupOriNoiseTotal = 0;
      var exclGroupMitNoiseTotal = 0;
      var pmeOriginalSWLForThisExcGroup = [];
      var pmeMitigatedSWLForThisExcGroup = [];
      var pmeArrayForCurrentExcGroup = [];

      var oriCalculatonResultDetailOneExcGroupArr = [];
      var mitCalculatonResultDetailOneExcGroupArr = [];

      for (const currentFeat of currentZoneTaskFeats) {
        var currentZone = currentFeat.get("zone");
        var currenttaskid = parseInt(currentFeat.get("taskid"));

        var currentExclusiveGroup = currentFeat.get("exclusivegroup") == null ? "" : currentFeat.get("exclusivegroup").trim();
        if (excGroupName.includes("#")) {
          // var currentPMEId = currentFeat.get('pmeid');
          var currentPMEId_0 = currentFeat.id_.split(".")[1];
          var currentFixedLocationExclusiveGroup = currentExclusiveGroup + "#" + currentPMEId_0.toString();
          if (excGroupName === currentFixedLocationExclusiveGroup) {
            if (currentFeat.get("isnotional").toLowerCase().includes("notional")) {
              continue;
            }
          } else {
            continue;
          }
        } else {
          // special for notional source
          if (excGroupName === currentExclusiveGroup || currentExclusiveGroup === "") {
            if (currentFeat.get("isnotional").toLowerCase().includes("fix")) {
              continue;
            }
          } else {
            continue;
          }
        }
        var currStartDate = new Date(getHKDateStringFromZulu(currentFeat.get("startt")));
        var currEndDate = new Date(getHKDateStringFromZulu(currentFeat.get("endd")));
        var currPMEid = currentFeat.get("pmeid");
        var currPMEName = currentFeat.get("othername");
        var currOfficialid = currentFeat.get("officialid") == null ? "" : currentFeat.get("officialid");
        var combinedMitPMEName = currentFeat.get("qpmename") == null ? "" : currentFeat.get("qpmename");
        var currMitPMeName = combinedMitPMEName;
        var currMitOfficialid = "";
        if (combinedMitPMEName.toUpperCase().indexOf("CNP") > -1) {
          var tempNameArr = combinedMitPMEName.split(" - ");
          currMitOfficialid = tempNameArr[0];
          currMitPMeName = tempNameArr[1];
        }

        var timePecentage = currentFeat.get("timepercent");
        // var isNotional = currentFeat.get('isnotional');
        var qty = currentFeat.get("qty");
        var swl = currentFeat.get("swl");
        // combined with mitigation + qpme
        var qpmeswl = currentFeat.get("qpmeswl") == null ? 0 : currentFeat.get("qpmeswl");

        //if pme not replaced by mitigation pme (like qpme or othe mitigated pme)
        if (!currMitPMeName || currMitPMeName?.trim() === "") {
          currMitPMeName = currPMEName;
          currMitOfficialid = currOfficialid;
          qpmeswl = swl;
        }

        const isQCM = currentFeat.get("isqcm") || false;

        var enclosureMit = currentFeat.get("enclosuredba") == null ? 0 : currentFeat.get("enclosuredba");
        var barrierMit = currentFeat.get("barrierdba") == null ? 0 : currentFeat.get("barrierdba");
        var hammerMit = currentFeat.get("hammerdba") == null ? 0 : currentFeat.get("hammerdba");
        var customMit = currentFeat.get("custommethoddba") == null ? 0 : currentFeat.get("custommethoddba");
        var customName = currentFeat.get("custommethodname") == null ? "" : currentFeat.get("custommethodname");
        var mitMeasure = "";
        var minMit = 0;
        if (minMit > customMit) {
          mitMeasure = customName;
          minMit = customMit;
        }
        if (minMit > hammerMit) {
          mitMeasure = "Hammer Bracket";
          minMit = hammerMit;
        }
        if (minMit > barrierMit) {
          mitMeasure = "Barrier";
          minMit = barrierMit;
        }
        if (minMit > enclosureMit) {
          mitMeasure = "Enclosure";
          minMit = enclosureMit;
        }
        // console.log("mitMeasure");
        // console.log(mitMeasure);
        // console.log(enclosureMit);
        // console.log(barrierMit);
        // console.log(hammerMit);
        // console.log(customMit);

        var timePercentageCorrection = 10 * Math.log10(timePecentage / 100);
        var oriCorrectedSWL = (swl <= 0 ? qpmeswl : swl) + timePercentageCorrection;
        var mitCorrectedSWL =
          qpmeswl <= 0 && !isQCM ? swl + timePercentageCorrection : (swl <= 0 ? qpmeswl : Math.min(swl, qpmeswl)) + timePercentageCorrection;
        mitCorrectedSWL = mitCorrectedSWL <= 0 ? 0 : mitCorrectedSWL;
        var swlAfterQTYMitigated = mitCorrectedSWL;
        var swlAfterQTYOriginal = oriCorrectedSWL;
        if (qty > 0) {
          //swlAfterQTY = unmitigatedSWL + (10 * Math.log10(qty));
          swlAfterQTYOriginal = oriCorrectedSWL + 10 * Math.log10(qty);
          swlAfterQTYMitigated = mitCorrectedSWL + (mitCorrectedSWL ? 10 * Math.log10(qty) : 0);
        }
        swlAfterQTYMitigated = swlAfterQTYMitigated <= 0 ? 0 : swlAfterQTYMitigated;
        var totalReduction = Math.min(enclosureMit, barrierMit, hammerMit);
        var mitigatedSWL = swlAfterQTYMitigated + totalReduction;
        mitigatedSWL = mitigatedSWL <= 0 ? 0 : mitigatedSWL;
        pmeOriginalSWLForThisExcGroup.push(swlAfterQTYOriginal);
        pmeMitigatedSWLForThisExcGroup.push(mitigatedSWL);
        pmeArrayForCurrentExcGroup.push(currentFeat);

        // var for insert into calculation result detail database
        // console.log("excGroupName for detail");
        // console.log(excGroupName);
        var aOriCalResDet = new CalculationResultDetail(
          0,
          projectId,
          false,
          currentZone,
          currenttaskid,
          excGroupName,
          currStartDate,
          currEndDate,
          currPMEid,
          currPMEName,
          currOfficialid,
          swl,
          timePecentage,
          timePercentageCorrection,
          qty,
          swlAfterQTYOriginal,
          "",
          0,
          0,
          0,
          0
        );
        var aMitCalResDet = new CalculationResultDetail(
          0,
          projectId,
          true,
          currentZone,
          currenttaskid,
          excGroupName,
          currStartDate,
          currEndDate,
          currPMEid,
          currMitPMeName,
          currMitOfficialid,
          qpmeswl,
          timePecentage,
          timePercentageCorrection,
          qty,
          swlAfterQTYMitigated,
          mitMeasure,
          totalReduction,
          mitigatedSWL,
          0,
          0
        );
        //console.log(aMitCalResDet);
        oriCalculatonResultDetailOneExcGroupArr.push(aOriCalResDet);
        mitCalculatonResultDetailOneExcGroupArr.push(aMitCalResDet);
      }
      // console.log("pmeOriginalSWLForThisExcGroup for "+ excGroupName);
      // console.log(pmeOriginalSWLForThisExcGroup);
      // console.log("oriCalculatonResultDetailOneExcGroupArr for " + excGroupName);
      // console.log(oriCalculatonResultDetailOneExcGroupArr);
      // console.log("oriCalculatonResultDetailOneExcGroupArr");
      // console.log(oriCalculatonResultDetailOneExcGroupArr);
      // console.log("thisProjectCalculatedPMEFeats");
      // console.log(thisProjectCalculatedPMEFeats);
      exclGroupOriNoiseTotal = getCombinedNoiseLevel(pmeOriginalSWLForThisExcGroup);
      exclGroupMitNoiseTotal = getCombinedNoiseLevel(pmeMitigatedSWLForThisExcGroup);
      for (const [k, oriCalc] of oriCalculatonResultDetailOneExcGroupArr.entries()) {
        var mitCalc = mitCalculatonResultDetailOneExcGroupArr[k];
        oriCalc.groupswl = exclGroupOriNoiseTotal;
        mitCalc.groupswl = exclGroupMitNoiseTotal;

        oriCalculatonResultDetailGroupArr.push(oriCalc);
        mitCalculatonResultDetailGroupArr.push(mitCalc);
      }

      totalCNLOriginalInExcGroup.push(exclGroupOriNoiseTotal);
      totalCNLMitigatedInExcGroup.push(exclGroupMitNoiseTotal);
      pmeArrayForAllExcGroups.push(pmeArrayForCurrentExcGroup);
    }
    // exactly the same as above steps but without exc group
    if (excGroupNames.length == 0) {
      var excGroupName = "";

      var exclGroupOriNoiseTotal = 0;
      var exclGroupMitNoiseTotal = 0;
      var pmeOriginalSWLForThisExcGroup = [];
      var pmeMitigatedSWLForThisExcGroup = [];
      var pmeArrayForCurrentExcGroup = [];

      var oriCalculatonResultDetailOneExcGroupArr = [];
      var mitCalculatonResultDetailOneExcGroupArr = [];

      for (let k = 0; k < currentZoneTaskFeats.length; k++) {
        var currentFeat = currentZoneTaskFeats[k];
        var currentZone = currentFeat.get("zone");
        var currenttaskid = parseInt(currentFeat.get("taskid"));

        var currentExclusiveGroup = currentFeat.get("exclusivegroup") == null ? "" : currentFeat.get("exclusivegroup").trim();
        if (excGroupName === currentExclusiveGroup || currentExclusiveGroup === "") {
          var currStartDate = new Date(getHKDateStringFromZulu(currentFeat.get("startt")));
          var currEndDate = new Date(getHKDateStringFromZulu(currentFeat.get("endd")));
          var currPMEid = currentFeat.get("pmeid");
          var currPMEName = currentFeat.get("othername");
          var currOfficialid = currentFeat.get("officialid") == null ? "" : currentFeat.get("officialid");
          var combinedMitPMEName = currentFeat.get("qpmename") == null ? "" : currentFeat.get("qpmename");
          var currMitPMeName = combinedMitPMEName;
          var currMitOfficialid = "";
          if (combinedMitPMEName.toUpperCase().indexOf("CNP") > -1) {
            var tempNameArr = combinedMitPMEName.split(" - ");
            currMitOfficialid = tempNameArr[0];
            currMitPMeName = tempNameArr[1];
          }

          var timePecentage = currentFeat.get("timepercent");
          // var isNotional = currentFeat.get('isnotional');
          var qty = currentFeat.get("qty");
          var swl = currentFeat.get("swl");
          // combined with mitigation + qpme
          var qpmeswl = currentFeat.get("qpmeswl") == null ? 0 : currentFeat.get("qpmeswl");
          //if pme not replaced by mitigation pme (like qpme or othe mitigated pme)
          if (!currMitPMeName || currMitPMeName?.trim() === "") {
            currMitPMeName = currPMEName;
            currMitOfficialid = currOfficialid;
            qpmeswl = swl;
          }

          const isQCM = currentFeat.get("isqcm") || false;

          var enclosureMit = currentFeat.get("enclosuredba") == null ? 0 : currentFeat.get("enclosuredba");
          var barrierMit = currentFeat.get("barrierdba") == null ? 0 : currentFeat.get("barrierdba");
          var hammerMit = currentFeat.get("hammerdba") == null ? 0 : currentFeat.get("hammerdba");
          var customMit = currentFeat.get("custommethoddba") == null ? 0 : currentFeat.get("custommethoddba");
          var customName = currentFeat.get("custommethodname") == null ? "" : currentFeat.get("custommethodname");
          var mitMeasure = "";
          var minMit = 0;
          if (minMit > customMit) {
            mitMeasure = customName;
            minMit = customMit;
          }
          if (minMit > hammerMit) {
            mitMeasure = "Hammer Bracket";
            minMit = hammerMit;
          }
          if (minMit > barrierMit) {
            mitMeasure = "Barrier";
            minMit = barrierMit;
          }
          if (minMit > enclosureMit) {
            mitMeasure = "Enclosure";
            minMit = enclosureMit;
          }
          var timePercentageCorrection = 10 * Math.log10(timePecentage / 100);
          var oriCorrectedSWL = (swl <= 0 ? qpmeswl : swl) + timePercentageCorrection;
          var mitCorrectedSWL =
            qpmeswl <= 0 && !isQCM ? swl + timePercentageCorrection : (swl <= 0 ? qpmeswl : Math.min(swl, qpmeswl)) + timePercentageCorrection;
          mitCorrectedSWL = mitCorrectedSWL <= 0 ? 0 : mitCorrectedSWL;
          var swlAfterQTYMitigated = mitCorrectedSWL;
          var swlAfterQTYOriginal = oriCorrectedSWL;
          if (qty > 0) {
            //swlAfterQTY = unmitigatedSWL + (10 * Math.log10(qty));
            swlAfterQTYOriginal = oriCorrectedSWL + 10 * Math.log10(qty);
            swlAfterQTYMitigated = mitCorrectedSWL + (mitCorrectedSWL ? 10 * Math.log10(qty) : 0);
          }
          swlAfterQTYMitigated = swlAfterQTYMitigated <= 0 ? 0 : swlAfterQTYMitigated;
          var totalReduction = Math.min(enclosureMit, barrierMit, hammerMit, customMit);
          var mitigatedSWL = swlAfterQTYMitigated + totalReduction;
          mitigatedSWL = mitigatedSWL <= 0 ? 0 : mitigatedSWL;
          pmeOriginalSWLForThisExcGroup.push(swlAfterQTYOriginal);
          pmeMitigatedSWLForThisExcGroup.push(mitigatedSWL);
          pmeArrayForCurrentExcGroup.push(currentFeat);

          // var for insert into calculation result detail database
          var aOriCalResDet = new CalculationResultDetail(
            0,
            projectId,
            false,
            currentZone,
            currenttaskid,
            currentExclusiveGroup,
            currStartDate,
            currEndDate,
            currPMEid,
            currPMEName,
            currOfficialid,
            swl,
            timePecentage,
            timePercentageCorrection,
            qty,
            swlAfterQTYOriginal,
            "",
            0,
            0,
            0,
            0
          );
          var aMitCalResDet = new CalculationResultDetail(
            0,
            projectId,
            true,
            currentZone,
            currenttaskid,
            currentExclusiveGroup,
            currStartDate,
            currEndDate,
            currPMEid,
            currMitPMeName,
            currMitOfficialid,
            qpmeswl,
            timePecentage,
            timePercentageCorrection,
            qty,
            swlAfterQTYMitigated,
            mitMeasure,
            totalReduction,
            mitigatedSWL,
            0,
            0
          );
          oriCalculatonResultDetailOneExcGroupArr.push(aOriCalResDet);
          mitCalculatonResultDetailOneExcGroupArr.push(aMitCalResDet);
        }
      }
      // console.log("oriCalculatonResultDetailOneExcGroupArr");
      // console.log(oriCalculatonResultDetailOneExcGroupArr);
      // console.log("thisProjectCalculatedPMEFeats");
      // console.log(thisProjectCalculatedPMEFeats);
      exclGroupOriNoiseTotal = getCombinedNoiseLevel(pmeOriginalSWLForThisExcGroup);
      exclGroupMitNoiseTotal = getCombinedNoiseLevel(pmeMitigatedSWLForThisExcGroup);
      for (let k = 0; k < oriCalculatonResultDetailOneExcGroupArr.length; k++) {
        var oriCalc = oriCalculatonResultDetailOneExcGroupArr[k];
        var mitCalc = mitCalculatonResultDetailOneExcGroupArr[k];
        oriCalc.groupswl = exclGroupOriNoiseTotal;
        mitCalc.groupswl = exclGroupMitNoiseTotal;

        oriCalculatonResultDetailGroupArr.push(oriCalc);
        mitCalculatonResultDetailGroupArr.push(mitCalc);
      }

      totalCNLOriginalInExcGroup.push(exclGroupOriNoiseTotal);
      totalCNLMitigatedInExcGroup.push(exclGroupMitNoiseTotal);
      pmeArrayForAllExcGroups.push(pmeArrayForCurrentExcGroup);
    }

    var maxExclusiveGroupNameOriginal = "";
    var maxExclusiveGroupNameMitigated = "";
    var maxExclusiveGroupSNLOriginal = 0;
    var maxExclusiveGroupSNLMitigated = 0;
    var maxExclusiveGroupPMESet = [];
    var listExclusiveGroupSNLOriginal = [];
    var listExclusiveGroupSNLMitigated = [];
    var listExclusiveGroupPMESet = [];
    //find the maximum swl between exclusive groups
    if (fixedLocationExist) {
      for (let j = 0; j < excGroupNames.length; j++) {
        var currentExcGroupName = excGroupNames[j];
        var currentExclusiveGroupSNLOriginal = totalCNLOriginalInExcGroup[j];
        var currentExclusiveGroupSNLMitigated = totalCNLMitigatedInExcGroup[j];
        var currentExclusiveGroupPMESet = pmeArrayForAllExcGroups[j];

        var dictOriginal = new CustDictionary(currentExcGroupName, currentExclusiveGroupSNLOriginal, null);
        var dictMitigated = new CustDictionary(currentExcGroupName, currentExclusiveGroupSNLMitigated, null);
        var dictPMESet = new CustDictionary(currentExcGroupName, currentExclusiveGroupPMESet, null);

        listExclusiveGroupSNLOriginal.push(dictOriginal);
        listExclusiveGroupSNLMitigated.push(dictMitigated);
        listExclusiveGroupPMESet.push(dictPMESet);
      }
    } else {
      for (let j = 0; j < excGroupNames.length; j++) {
        var currentExclusiveGroupSNLOriginal = totalCNLOriginalInExcGroup[j];
        var currentExclusiveGroupSNLMitigated = totalCNLMitigatedInExcGroup[j];
        var currentExclusiveGroupPMESet = pmeArrayForAllExcGroups[j];

        if (maxExclusiveGroupSNLOriginal < currentExclusiveGroupSNLOriginal) {
          maxExclusiveGroupSNLOriginal = currentExclusiveGroupSNLOriginal;
          maxExclusiveGroupNameOriginal = excGroupNames[j];
          maxExclusiveGroupPMESet = currentExclusiveGroupPMESet;
        }
        if (maxExclusiveGroupSNLMitigated < currentExclusiveGroupSNLMitigated) {
          maxExclusiveGroupSNLMitigated = currentExclusiveGroupSNLMitigated;
          maxExclusiveGroupNameMitigated = excGroupNames[j];
          maxExclusiveGroupPMESet = currentExclusiveGroupPMESet;
        }
      }
    }
    // console.log("listExclusiveGroupSNLOriginal");
    // console.log(listExclusiveGroupSNLOriginal);
    //if no exclusive group, instead one anonimous group only
    if (excGroupNames.length === 0) {
      maxExclusiveGroupSNLOriginal = totalCNLOriginalInExcGroup[0];
      maxExclusiveGroupNameOriginal = "";
      maxExclusiveGroupSNLMitigated = totalCNLMitigatedInExcGroup[0];
      maxExclusiveGroupNameMitigated = "";
      maxExclusiveGroupPMESet = pmeArrayForAllExcGroups[0];
    }

    if (fixedLocationExist) {
      totalCNLOriginalInZoneTask.push(listExclusiveGroupSNLOriginal);
      exclGroupNamesOriginalInZoneTask.push("#");
      totalCNLMitigatedInZoneTask.push(listExclusiveGroupSNLMitigated);
      exclGroupNamesMitigatedInZoneTask.push("#");
      pmeArrayForZoneTaskFromMaxExcGroup.push(listExclusiveGroupPMESet);
    } else {
      totalCNLOriginalInZoneTask.push(maxExclusiveGroupSNLOriginal);
      exclGroupNamesOriginalInZoneTask.push(maxExclusiveGroupNameOriginal);
      totalCNLMitigatedInZoneTask.push(maxExclusiveGroupSNLMitigated);
      exclGroupNamesMitigatedInZoneTask.push(maxExclusiveGroupNameMitigated);
      pmeArrayForZoneTaskFromMaxExcGroup.push(maxExclusiveGroupPMESet);
    }

    for (let j = 0; j < oriCalculatonResultDetailGroupArr.length; j++) {
      var oriCalc = oriCalculatonResultDetailGroupArr[j];
      var mitCalc = mitCalculatonResultDetailGroupArr[j];
      if (!fixedLocationExist) {
        oriCalc.highestswl = maxExclusiveGroupSNLOriginal;
        mitCalc.highestswl = maxExclusiveGroupSNLMitigated;
      }
      calculationResultOriginalDetailArray.push(oriCalc);
      calculationResultMitigatedDetailArray.push(mitCalc);
      calculationResultDetailArray.push(oriCalc);
      calculationResultDetailArray.push(mitCalc);
    }
  }
  // console.log("calculationResultDetailArray");
  // console.log(calculationResultDetailArray);
  //return;
  // array for insert into calculation result detail database
  var calculationResultOriginalNSRArray = [];
  var calculationResultMitigatedNSRArray = [];
  var calculationResultNSRArray = [];
  notionalPointsFeatArr = [];
  allBuildingsHeight = [];
  zoneNSRNotionalInfo = {};
  // array for insert into calculation result detail database - end
  // console.log("thisProjectCalculatedNSRPointFeats");
  // console.log(thisProjectCalculatedNSRPointFeats);
  // console.log("zoneTask_ExclusiveGroupList");
  // console.log(zoneTask_ExclusiveGroupList);

  let zoneIds = [...new Set(zoneTaskIds.map((z) => parseInt(z.split("-")[0])))];

  console.log("calculateNoise6 globalCurrentZoneFeatures", globalCurrentZoneFeatures);
  console.log("calculateNoise6 zoneIds", zoneIds);

  // check whether there is nsr point that fall inside the zone area
  var nsrFallInsideZone = false;
  for (const nsrPointFeat of thisProjectCalculatedNSRPointFeats) {
    for (const currentZoneIndex of zoneIds) {
      var zoneFeature = getZoneFeatFromArray(currentZoneIndex);
      if (isIntersect(nsrPointFeat, zoneFeature)) {
        nsrFallInsideZone = true;
        nsrPointFeat.ignore = true;
        break;
      }
      nsrPointFeat.ignore = false;
    }
  }
  // get notional information
  for (const nsrPointFeat of thisProjectCalculatedNSRPointFeats) {
    if (nsrPointFeat.ignore !== false) {
      continue;
    }
    let currentPointId = nsrPointFeat.get("id");
    for (const currentZoneIndex of zoneIds) {
      let notionalPoint;
      let notionalDistance;
      let calcType;

      if (zoneNSRNotionalInfo[currentPointId]) {
        if (!zoneNSRNotionalInfo[currentPointId][currentZoneIndex]) {
          ({ notionalPoint, notionalDistance, calcType } = getNotionalInfo(currentZoneIndex, nsrPointFeat));
        } else {
          notionalPoint = zoneNSRNotionalInfo[currentPointId][currentZoneIndex].notionalPoint;
          notionalDistance = zoneNSRNotionalInfo[currentPointId][currentZoneIndex].notionalDistance;
          calcType = zoneNSRNotionalInfo[currentPointId][currentZoneIndex].calcType;
        }
      } else {
        ({ notionalPoint, notionalDistance, calcType } = getNotionalInfo(currentZoneIndex, nsrPointFeat));
      }
      if (!notionalPoint) {
        nsrPointFeat.ignore = true;
      }
      //var notionalDistance = notionalDistanceLine.getLength();

      // console.log(notionalPoint.getCoordinates());
      // console.log(outPointAtBorder);

      //store zone-nsr information for type B calculation
      if (!zoneNSRNotionalInfo[currentPointId]) {
        zoneNSRNotionalInfo[currentPointId] = {
          buildingid: nsrPointFeat.get("buildingid"),
          nsrname: nsrPointFeat.get("nsrname") ? nsrPointFeat.get("nsrname") : "",
          buildingname: nsrPointFeat.get("BldName_E") ? nsrPointFeat.get("BldName_E") : "",
        };
      }
      zoneNSRNotionalInfo[currentPointId][currentZoneIndex] = {
        notionalPoint: notionalPoint,
        notionalDistance: notionalDistance,
        calcType: calcType,
      };
      if (!zoneNSRNotionalInfo[currentPointId].closestDistance && calcType == "B") {
        zoneNSRNotionalInfo[currentPointId].closestDistance = notionalDistance;
        zoneNSRNotionalInfo[currentPointId].closestZone = currentZoneIndex;
      }
      if (zoneNSRNotionalInfo[currentPointId].closestDistance > notionalDistance && calcType == "B") {
        zoneNSRNotionalInfo[currentPointId].closestDistance = notionalDistance;
        zoneNSRNotionalInfo[currentPointId].closestZone = currentZoneIndex;
      }
    }
  }

  // if(nsrFallInsideZone) {
  //     showModal("At least an NSR point that is located inside the Zone/Site polygon is detected. These NSR points will be ignored and cannot be calculated.");
  // }

  var currentNSROtherNoiseCriteriaNameArr = [];
  var currentNSROtherNoiseCriteriaValueArr = [];
  var currentNSROtherNoiseCriteriaStartDateArr = [];
  var currentNSROtherNoiseCriteriaEndDateArr = [];
  var currentNSROtherNoiseCriteriaSentenceArr = [];
  var currentNSROtherNoiseCriteriaExceedUnMitArr = [];
  var currentNSROtherNoiseCriteriaExceedUnMitMax = "";
  var currentNSROtherNoiseCriteriaExceedMitArr = [];
  var currentNSROtherNoiseCriteriaExceedMitMax = "";
  const selectedNSRPointIdStringsSet = new Set(selectedNSRPointIds.map((id) => id.toString()));

  for (const nsrPointFeat of thisProjectCalculatedNSRPointFeats) {
    if (nsrPointFeat.ignore !== false) {
      continue;
    }
    // console.log('nsrPointFeat');
    // console.log(nsrPointFeat);
    currentNSROtherNoiseCriteriaNameArr = [];
    currentNSROtherNoiseCriteriaValueArr = [];
    currentNSROtherNoiseCriteriaStartDateArr = [];
    currentNSROtherNoiseCriteriaEndDateArr = [];
    currentNSROtherNoiseCriteriaSentenceArr = [];
    currentNSROtherNoiseCriteriaExceedUnMitArr = [];
    currentNSROtherNoiseCriteriaExceedUnMitMax = "";
    currentNSROtherNoiseCriteriaExceedMitArr = [];
    currentNSROtherNoiseCriteriaExceedMitMax = "";
    var floorHeightAssumption = 3; // 1 floor height = 3 meters.
    var currentBuildingId = nsrPointFeat.get("buildingid");
    var currentNoiseCriteria = nsrPointFeat.get("noisecriteria") ? nsrPointFeat.get("noisecriteria") : 75;
    var currentOtherNoiseCriteria = nsrPointFeat.get("othernoisecriteria") ? nsrPointFeat.get("othernoisecriteria") : null;
    var currentlBuildingHeight = nsrPointFeat.get("Bld_Ht");
    //var currentBuildingName = nsrPointFeat.get("BldName_E") ? nsrPointFeat.get("BldName_E") : "";
    var currentNSRName = nsrPointFeat.get("nsrname") ? nsrPointFeat.get("nsrname") : "";
    var currentBuildingName = nsrPointFeat.get("BldName_E") ? nsrPointFeat.get("BldName_E") : "";
    var currentPointId = nsrPointFeat.get("id");
    var currentlBuildingTotalFloor = Math.floor(currentlBuildingHeight / floorHeightAssumption);

    if (currentOtherNoiseCriteria) {
      var otherCriteriaArr = currentOtherNoiseCriteria.split("#");

      for (const aCritSentence of otherCriteriaArr) {
        var aCritWords = aCritSentence.split(": ");
        var aCritValue = parseFloat(aCritWords[1]);
        var aCritName = aCritWords[0].split("@")[0];
        var aCritDates = aCritWords[0].split("@")[1].split(" ~ ");
        var aCritStartDate = new Date(aCritDates[0]);
        var aCritEndDate = new Date(aCritDates[1]);
        currentNSROtherNoiseCriteriaNameArr.push(aCritName);
        currentNSROtherNoiseCriteriaValueArr.push(aCritValue);
        currentNSROtherNoiseCriteriaStartDateArr.push(aCritStartDate);
        currentNSROtherNoiseCriteriaEndDateArr.push(aCritEndDate);
        currentNSROtherNoiseCriteriaSentenceArr.push(aCritSentence);
      }
    }

    var buldHeghtObj = new CustDictionary(currentBuildingId, currentlBuildingHeight, null);
    allBuildingsHeight.push(buldHeghtObj); // ==>put in global var

    var originalCNLForCurrentNSR = {};
    var mitigatedCNLForCurrentNSR = {};

    var calculationResultNSROriginalForOneNSRArray = [];
    var calculationResultNSRMitigatedForOneNSRArray = [];

    var calcValArr = []; // for popup
    for (let j = 0; j < zoneTaskIds.length; j++) {
      var currentZoneTaskId = zoneTaskIds[j];
      var currentZoneIndex = parseInt(currentZoneTaskId.split("-")[0]);
      var currentTaskid = parseInt(currentZoneTaskId.split("-")[1]);

      var notionalPoint = zoneNSRNotionalInfo[currentPointId][currentZoneIndex].notionalPoint;
      var notionalDistance = zoneNSRNotionalInfo[currentPointId][currentZoneIndex].notionalDistance;

      //border to notional point distance
      var borderNotionalPointArr = [
        notionalPoint.getCoordinates(),
        //outPointAtBorder.getGeometry().getCoordinates(), //Feb 22 Alex deleted
        outPointAtBorder, //Feb 22 Alex modified
      ];

      //var borderNotionalDistanceLine = new LineString(borderNotionalPointArr);
      var borderNotionalDistanceLine = new LineString(notionalPoint.getCoordinates(), outPointAtBorder);
      var borderNotionalDistance = getLength(borderNotionalDistanceLine);
      //var borderNotionalDistance = borderNotionalDistanceLine.getLength();
      //border to nsr distance
      var borderNSRPointArr = [
        //outPointAtBorder.getGeometry().getCoordinates(), //Alex deleted
        outPointAtBorder, //Feb 22 Alex Modified
        nsrPointFeat.getGeometry().getCoordinates(),
      ];
      var borderNSRDistanceLine = new LineString(borderNSRPointArr);
      var borderNSRDistance = getLength(borderNSRDistanceLine);
      //var borderNSRDistance = borderNSRDistanceLine.getLength();
      //Alex modified above

      // if(currentNSRName)
      // {
      //     console.log(currentNSRName);
      //     console.log(notionalDistance);
      //     console.log(notionalDistanceLine.getLength());
      //     console.log("Border to notional");
      //     console.log(borderNotionalDistance);
      //     console.log(borderNotionalDistanceLine.getLength());
      //     console.log("Border to NSR");
      //     console.log(borderNSRDistance);
      //     console.log(borderNSRDistanceLine.getLength());
      // }

      // populate all notionalPoints with attributes
      var notionalPointFeat = new Feature({
        geometry: notionalPoint,
        projectid: projectId,
        buildingid: currentBuildingId,
        zonetaskid: currentZoneTaskId,
        nsrname: currentNSRName,
        distance: notionalDistance,
        remark: "notional",
        calculationtype: getZoneFeatFromArray(currentZoneIndex)?.get("calculationtype"),
      });
      // console.log("notionalPointFeat");
      // console.log(notionalPointFeat);
      // if (currentNSRName) {
      notionalPointsFeatArr.push(notionalPointFeat);
      // }
      // notionalPointFeat = new Feature({
      //     geometry: outPointAtBorder.getGeometry(),
      //     projectid: projectId,
      //     buildingid: currentBuildingId,
      //     zonetaskid: currentZoneTaskId,
      //     nsrname:currentNSRName,
      //     distance:borderNSRDistance,
      //     remark: "zoneborder",
      // });
      // if(currentNSRName){
      //     notionalPointsFeatArr.push(notionalPointFeat);
      // }
      // notionalPointFeat = new Feature({
      //     geometry: zoneCentroidTest.getGeometry(),
      //     projectid: projectId,
      //     buildingid: currentBuildingId,
      //     zonetaskid: currentZoneTaskId,
      //     nsrname:currentNSRName,
      //     distance:borderNSRDistance,
      //     remark: "zonecenterofmass",
      // });
      // if(currentNSRName){
      //     notionalPointsFeatArr.push(notionalPointFeat);
      // }
      // notionalPointFeat = new Feature({
      //     geometry: zoneCentroidTest2.getGeometry(),
      //     projectid: projectId,
      //     buildingid: currentBuildingId,
      //     zonetaskid: currentZoneTaskId,
      //     nsrname:currentNSRName,
      //     distance:borderNSRDistance,
      //     remark: "zonecentroid",
      // });
      // if(currentNSRName){
      //     notionalPointsFeatArr.push(notionalPointFeat);
      // }
      // notionalPointFeat = new Feature({
      //     geometry: zoneCentroidTest3.getGeometry(),
      //     projectid: projectId,
      //     buildingid: currentBuildingId,
      //     zonetaskid: currentZoneTaskId,
      //     nsrname:currentNSRName,
      //     distance:borderNSRDistance,
      //     remark: "zonecenter",
      // });
      // if(currentNSRName){
      //     notionalPointsFeatArr.push(notionalPointFeat);
      // }

      // check if it's closest type B zone
      if (
        zoneNSRNotionalInfo[currentPointId].closestZone != currentZoneIndex &&
        getZoneFeatFromArray(currentZoneIndex)?.get("calculationtype") == "B"
      ) {
        continue;
      }

      // check one by one pme for this zone task whether they are at notional location
      var currentZoneTask_ExclusiveGroup = zoneTask_ExclusiveGroupList[j];
      var currentZoneTaskIdHaveFixedLocationPME = currentZoneTask_ExclusiveGroup.remark;

      if (currentZoneTaskIdHaveFixedLocationPME) {
        var listExclusiveGroupSNLOriginal = totalCNLOriginalInZoneTask[j];
        var listExclusiveGroupSNLMitigated = totalCNLMitigatedInZoneTask[j];
        var listExclusiveGroupPMESet = pmeArrayForZoneTaskFromMaxExcGroup[j];

        var maxExclusiveGroupSNLOriginal = 0;
        var maxExclusiveGroupNameOriginal = "";
        var maxExclusiveGroupSNLMitigated = 0;
        var maxExclusiveGroupNameMitigated = "";

        var allOriSPLOfMainExcGroup = [];
        var allMitSPLOfMainExcGroup = [];

        var aOriCalResNSR = null;
        var aMitCalResNSR = null;

        var curOriNSRForDBParent = [];
        var curMitNSRForDBParent = [];
        //get the list of main exclusive group names (the one without '#')
        var mainExcGroupArray = currentZoneTask_ExclusiveGroup.item[1];
        for (let k = 0; k < mainExcGroupArray.length; k++) {
          var currentMainExcGroup = mainExcGroupArray[k];

          var oriSPLOfMainExcGroup = [];
          var mitSPLOfMainExcGroup = [];

          var curOriNSRForDB = [];
          var curMitNSRForDB = [];
          // console.log("currentMainExcGroup for NSR");
          // console.log(currentMainExcGroup);
          // console.log("listExclusiveGroupSNLOriginal for NSR");
          // console.log(listExclusiveGroupSNLOriginal);
          for (let m = 0; m < listExclusiveGroupSNLOriginal.length; m++) {
            var dictOriginal = listExclusiveGroupSNLOriginal[m];
            var dictMitigated = listExclusiveGroupSNLMitigated[m];
            var dictPMESet = listExclusiveGroupPMESet[m];
            var currentExcGroupName = dictOriginal.key;
            var totOriginalSWLForCurrentExclGroup = dictOriginal.item;
            var totMitigatedSWLForCurrentExclGroup = dictMitigated.item;
            var pmeListForCurrentExclGroup = dictPMESet.item;
            if (currentExcGroupName.includes(currentMainExcGroup)) {
              var currentExcGroupDistance = 0;
              if (currentExcGroupName.includes("#")) {
                // this is fixed location PME, need to gt it's geometry
                var thisPMEId_0 = currentExcGroupName.split("#")[1];
                var thisPointFeat = null;
                for (let n = 0; n < pmeListForCurrentExclGroup.length; n++) {
                  var curPMEFeat = pmeListForCurrentExclGroup[n];
                  if (curPMEFeat.id_.includes(thisPMEId_0)) {
                    thisPointFeat = curPMEFeat;
                    break;
                  }
                }

                //get fixed point and the distance
                var fixedPoint = thisPointFeat.getGeometry();
                currentExcGroupDistance = 0;
                if (fixedPoint) {
                  var fixedDistancePointArr = [fixedPoint.getCoordinates(), nsrPointFeat.getGeometry().getCoordinates()];
                  var fixedDistanceLine = new LineString(fixedDistancePointArr);
                  //var fixedDistance = getLength(fixedDistanceLine);
                  var fixedDistance = fixedDistanceLine.getLength();
                  currentExcGroupDistance = fixedDistance;
                }
                // console.log("currentExcGroupDistance for "+ currentExcGroupName + "; zonetask: " + currentZoneTaskId);
                // console.log(currentExcGroupDistance);
              } else {
                currentExcGroupDistance = notionalDistance;
                // console.log("currentExcGroupDistance notional for "+ currentExcGroupName + "; zonetask: " + currentZoneTaskId);
                // console.log(currentExcGroupDistance);
              }
              var verticalDistance = 0;
              var slantDistance = Math.pow(Math.pow(currentExcGroupDistance, 2) + Math.pow(verticalDistance, 2), 0.5);
              var hemisphericalPropagation = -1 * (20 * Math.log10(slantDistance) + 8);
              var facadeCorrection = 3;

              var totalCNLOriginal =
                totOriginalSWLForCurrentExclGroup + hemisphericalPropagation + facadeCorrection > 0
                  ? totOriginalSWLForCurrentExclGroup + hemisphericalPropagation + facadeCorrection
                  : 0;
              var totalCNLMitigated =
                totMitigatedSWLForCurrentExclGroup + hemisphericalPropagation + facadeCorrection > 0
                  ? totMitigatedSWLForCurrentExclGroup + hemisphericalPropagation + facadeCorrection
                  : 0;
              // console.log("mainExclGroupOriNoiseTotal for "+ currentExcGroupName + "; zonetask: " + currentZoneTaskId);
              // console.log(totalCNLOriginal);
              oriSPLOfMainExcGroup.push(totalCNLOriginal);
              mitSPLOfMainExcGroup.push(totalCNLMitigated);

              // var for insert into calculation result nsr database
              // console.log("currentExcGroupName for NSR");
              // console.log(currentExcGroupName);
              aOriCalResNSR = new CalculationResultNSR(
                0,
                projectId,
                false,
                currentBuildingId,
                currentBuildingName,
                currentPointId,
                currentNSRName,
                currentZoneTaskId,
                currentExcGroupName,
                totOriginalSWLForCurrentExclGroup,
                currentExcGroupDistance,
                hemisphericalPropagation,
                facadeCorrection,
                totalCNLOriginal,
                0,
                0,
                currentNoiseCriteria,
                "",
                0,
                0,
                currentlBuildingTotalFloor
              );
              aMitCalResNSR = new CalculationResultNSR(
                0,
                projectId,
                true,
                currentBuildingId,
                currentBuildingName,
                currentPointId,
                currentNSRName,
                currentZoneTaskId,
                currentExcGroupName,
                totMitigatedSWLForCurrentExclGroup,
                currentExcGroupDistance,
                hemisphericalPropagation,
                facadeCorrection,
                totalCNLMitigated,
                0,
                0,
                currentNoiseCriteria,
                "",
                0,
                0,
                currentlBuildingTotalFloor
              );
              // calculationResultNSROriginalForOneNSRArray.push(aOriCalResNSR);
              // calculationResultNSRMitigatedForOneNSRArray.push(aMitCalResNSR);
              curOriNSRForDB.push(aOriCalResNSR);
              curMitNSRForDB.push(aMitCalResNSR);
            }
          }

          var mainExclGroupOriNoiseTotal = getCombinedNoiseLevel(oriSPLOfMainExcGroup);
          var mainExclGroupMitNoiseTotal = getCombinedNoiseLevel(mitSPLOfMainExcGroup);
          allOriSPLOfMainExcGroup.push(mainExclGroupOriNoiseTotal);
          allMitSPLOfMainExcGroup.push(mainExclGroupMitNoiseTotal);
          // console.log("mainExclGroupOriNoiseTotal for "+ currentMainExcGroup + "; zonetask: " + currentZoneTaskId);
          // console.log(mainExclGroupOriNoiseTotal);

          //update var for insert into calculation result nsr database
          for (const [m, aCalculationResultNSROri] of curOriNSRForDB.entries()) {
            var aCalculationResultNSRMit = curMitNSRForDB[m];
            aCalculationResultNSROri.totalspl = mainExclGroupOriNoiseTotal;
            aCalculationResultNSRMit.totalspl = mainExclGroupMitNoiseTotal;

            curOriNSRForDBParent.push(aCalculationResultNSROri);
            curMitNSRForDBParent.push(aCalculationResultNSRMit);
          }
        }

        //get the maximum cnl between main Exclusive group swl.
        for (const [k, currentMainExcGroup] of mainExcGroupArray.entries()) {
          var currentExclusiveGroupSNLOriginal = allOriSPLOfMainExcGroup[k];
          var currentExclusiveGroupSNLMitigated = allMitSPLOfMainExcGroup[k];

          if (maxExclusiveGroupSNLOriginal < currentExclusiveGroupSNLOriginal) {
            maxExclusiveGroupSNLOriginal = currentExclusiveGroupSNLOriginal;
            maxExclusiveGroupNameOriginal = currentMainExcGroup;
          }
          if (maxExclusiveGroupSNLMitigated < currentExclusiveGroupSNLMitigated) {
            maxExclusiveGroupSNLMitigated = currentExclusiveGroupSNLMitigated;
            maxExclusiveGroupNameMitigated = currentMainExcGroup;
          }
        }

        originalCNLForCurrentNSR[currentZoneTaskId] = maxExclusiveGroupSNLOriginal;
        mitigatedCNLForCurrentNSR[currentZoneTaskId] = maxExclusiveGroupSNLMitigated;

        //update var for insert into calculation result nsr database
        for (const [k, aCalculationResultNSROri] of curOriNSRForDBParent.entries()) {
          var aCalculationResultNSRMit = curMitNSRForDBParent[k];
          aCalculationResultNSROri.cnl = maxExclusiveGroupSNLOriginal;
          aCalculationResultNSRMit.cnl = maxExclusiveGroupSNLMitigated;

          calculationResultNSROriginalForOneNSRArray.push(aCalculationResultNSROri);
          calculationResultNSRMitigatedForOneNSRArray.push(aCalculationResultNSRMit);
        }

        // var for pop up
        var calculatedPopup = new CalculatedValuesPopup(0, currentZoneTaskId, maxExclusiveGroupSNLOriginal);
        calcValArr.push(calculatedPopup);
        calculatedPopup = new CalculatedValuesPopup(1, currentZoneTaskId, maxExclusiveGroupSNLMitigated);
        calcValArr.push(calculatedPopup);
      } else {
        var isNotional = "Notional Source";

        var distance = 0;
        if (isNotional.toLowerCase().indexOf("notional") >= 0) {
          //use notional distance
          distance = notionalDistance;
        } // use geometry
        else {
          // var realDistancePointArr = [currentFeat.getGeometry().getCoordinates(),nsrPointFeat.getGeometry().getCoordinates()]
          // var realDistanceLine = new LineString(realDistancePointArr);
          // var realDistance = getLength(realDistanceLine);
          // distance = realDistance;
          // // console.log('realDistance', realDistance);
        }
        var verticalDistance = 0;
        var slantDistance = Math.pow(Math.pow(distance, 2) + Math.pow(verticalDistance, 2), 0.5);
        var hemisphericalPropagation = -1 * (20 * Math.log10(slantDistance) + 8);
        var facadeCorrection = 3;

        //get current total swl for the zone-task
        var currentSWLOriginal = totalCNLOriginalInZoneTask[j];
        var currentSWLMitigated = totalCNLMitigatedInZoneTask[j];
        var totalCNLOriginal =
          currentSWLOriginal + hemisphericalPropagation + facadeCorrection > 0 ? currentSWLOriginal + hemisphericalPropagation + facadeCorrection : 0;
        var totalCNLMitigated =
          currentSWLMitigated + hemisphericalPropagation + facadeCorrection > 0
            ? currentSWLMitigated + hemisphericalPropagation + facadeCorrection
            : 0;

        originalCNLForCurrentNSR[currentZoneTaskId] = totalCNLOriginal;
        mitigatedCNLForCurrentNSR[currentZoneTaskId] = totalCNLMitigated;

        // var for insert into calculation result nsr database
        var aOriCalResNSR = new CalculationResultNSR(
          0,
          projectId,
          false,
          currentBuildingId,
          currentBuildingName,
          currentPointId,
          currentNSRName,
          currentZoneTaskId,
          "",
          currentSWLOriginal,
          distance,
          hemisphericalPropagation,
          facadeCorrection,
          0,
          0,
          totalCNLOriginal,
          currentNoiseCriteria,
          "",
          0,
          0,
          currentlBuildingTotalFloor
        );
        var aMitCalResNSR = new CalculationResultNSR(
          0,
          projectId,
          true,
          currentBuildingId,
          currentBuildingName,
          currentPointId,
          currentNSRName,
          currentZoneTaskId,
          "",
          currentSWLMitigated,
          distance,
          hemisphericalPropagation,
          facadeCorrection,
          0,
          0,
          totalCNLMitigated,
          currentNoiseCriteria,
          "",
          0,
          0,
          currentlBuildingTotalFloor
        );
        calculationResultNSROriginalForOneNSRArray.push(aOriCalResNSR);
        calculationResultNSRMitigatedForOneNSRArray.push(aMitCalResNSR);

        // var for pop up
        var calculatedPopup = new CalculatedValuesPopup(0, currentZoneTaskId, totalCNLOriginal);
        calcValArr.push(calculatedPopup);
        calculatedPopup = new CalculatedValuesPopup(1, currentZoneTaskId, totalCNLMitigated);
        calcValArr.push(calculatedPopup);
      }
    }

    //now loop for each combined zone-task. Processing the combined Zone task.
    var originalCNLForCurrentCombinedNSR = [];
    var mitigatedCNLForCurrentCombinedNSR = [];
    // console.log("combinedZoneTaskWithApprovedSitesArr");
    // console.log(combinedZoneTaskWithApprovedSitesArr);

    if (approvedProjectIDs.length > 0) {
      // if approved neighbour site(s) exist
      // if (nsrPointFeat.get("nsrname") === "N6")
      // {
      //     console.log("combinedZoneTaskWithApprovedSitesArr.length");
      //     console.log(combinedZoneTaskWithApprovedSitesArr.length);
      // }

      for (const currentCombinedZoneTask of combinedZoneTaskWithApprovedSitesArr) {
        var isEntryFound = false; //whether projectid, zonetask, and building id are found on the approved site
        var combinationHasHash = false;

        // if (nsrPointFeat.get("nsrname") === "N6")
        // {
        //     console.log("currentCombinedZoneTask");
        //     console.log(currentCombinedZoneTask);
        // }

        var individualZoneTaskArr = currentCombinedZoneTask.split("+");

        //check if it's closest type b zone
        if (
          individualZoneTaskArr.some((zt) => {
            let currentZoneIndex = parseInt(zt.split("-")[0]);
            return (
              zoneNSRNotionalInfo[currentPointId].closestZone != currentZoneIndex &&
              getZoneFeatFromArray(currentZoneIndex)?.get("calculationtype") == "B"
            );
          })
        ) {
          continue;
        }

        var individualZoneTaskOriginalCNLArr = [];
        var individualZoneTaskMitigatedCNLArr = [];
        var currentCombinedZoneTaskForFoundBuilding = "";
        var currentCombinedZoneTaskForFoundBuildingArr = [];
        for (const curProjZoneTask of individualZoneTaskArr) {
          // if (nsrPointFeat.get("nsrname") === "N6")
          // {
          //     console.log("curProjZoneTask");
          //     console.log(curProjZoneTask);
          // }
          // console.log("curZoneTask");
          // console.log(curProjZoneTask);
          var originalCNLForCurrentZoneTask = 0;
          var mitigatedCNLForCurrentZoneTask = 0;
          var buildingFound = false;
          // console.log("curProjZoneTask");
          // console.log(curProjZoneTask);
          if (curProjZoneTask.includes("#")) {
            // from neighbour approved sites
            combinationHasHash = true;
            var projIdAndRemaining = curProjZoneTask.split("#");
            var curProjId = parseInt(projIdAndRemaining[0]);
            var curZoneTask = projIdAndRemaining[1];
            // if (nsrPointFeat.get("nsrname") === "N6")
            // {
            //     console.log("approvedProjectCalculationResultNSR.length");
            //     console.log(approvedProjectCalculationResultNSR.length);
            // }
            for (const curResultNSR of approvedProjectCalculationResultNSR) {
              // if (nsrPointFeat.get("nsrname") === "N6")
              // {
              //     console.log("# curResultNSR");
              //     console.log(curResultNSR);

              //     console.log("curResultNSR.projectid");
              //     console.log(curResultNSR.projectId);
              //     console.log("curProjId");
              //     console.log(curProjId);
              //     console.log("curZoneTask");
              //     console.log(curZoneTask);
              //     console.log("curResultNSR.zonetaskorcombined");
              //     console.log(curResultNSR.zonetaskorcombined);
              //     console.log("curResultNSR.buildingid");
              //     console.log(curResultNSR.buildingid);
              //     console.log("currentBuildingId");
              //     console.log(currentBuildingId);
              //     console.log("curResultNSR.ismitigated");
              //     console.log(curResultNSR.ismitigated);
              // }

              if (
                curResultNSR.projectId === curProjId &&
                curResultNSR.zonetaskorcombined === curZoneTask &&
                curResultNSR.buildingid === currentBuildingId &&
                curResultNSR.ismitigated === false
              ) {
                originalCNLForCurrentZoneTask = curResultNSR.cnl;
              } else if (
                curResultNSR.projectId === curProjId &&
                curResultNSR.zonetaskorcombined === curZoneTask &&
                curResultNSR.buildingid === currentBuildingId &&
                curResultNSR.ismitigated === true
              ) {
                mitigatedCNLForCurrentZoneTask = curResultNSR.cnl;
              }
              if (originalCNLForCurrentZoneTask > 0 && mitigatedCNLForCurrentZoneTask > 0) {
                currentCombinedZoneTaskForFoundBuildingArr.push(curProjZoneTask);
                buildingFound = true;
                isEntryFound = true;
                break;
              }
            }
            // if (nsrPointFeat.get("nsrname") === "N6")
            // {
            //     console.log("buildingFound");
            //     console.log(buildingFound);
            // }
            // console.log("originalCNLForCurrentZoneTask from curProjZoneTask.includes('#')");
            // console.log(originalCNLForCurrentZoneTask);
            // console.log("mitigatedCNLForCurrentZoneTask from curProjZoneTask.includes('#')");
            // console.log(mitigatedCNLForCurrentZoneTask);
          } // from main sites
          else {
            buildingFound = true;
            currentCombinedZoneTaskForFoundBuildingArr.push(curProjZoneTask);
            // var curZoneTaskIndex = zoneTaskIds.indexOf(curProjZoneTask);
            //get this zone task index
            // console.log("zoneTaskIds");
            // console.log(zoneTaskIds);

            // if (curZoneTaskIndex < 0) {
            //   //alert("zone task index not found");
            //   //console.log("zone task index not found")
            //   continue;
            // }

            originalCNLForCurrentZoneTask = originalCNLForCurrentNSR[curProjZoneTask];
            mitigatedCNLForCurrentZoneTask = mitigatedCNLForCurrentNSR[curProjZoneTask];
          }
          // console.log("originalCNLForCurrentZoneTask");
          // console.log(originalCNLForCurrentZoneTask);
          // console.log("mitigatedCNLForCurrentZoneTask");
          // console.log(mitigatedCNLForCurrentZoneTask);

          if (buildingFound) {
            individualZoneTaskOriginalCNLArr.push(originalCNLForCurrentZoneTask);
            individualZoneTaskMitigatedCNLArr.push(mitigatedCNLForCurrentZoneTask);
          }
        }
        // if ((combinationHasHash && isEntryFound) || (!combinationHasHash))
        // {

        // }
        // this is for fixing currentCombinedZoneTask -> not all nsr has the same combination for approved sites. Approved sites only cover 300m from that site.
        currentCombinedZoneTaskForFoundBuilding = currentCombinedZoneTaskForFoundBuildingArr.sort().join("+");

        var combinedZoneTaskOriginalCNL = getCombinedNoiseLevel(individualZoneTaskOriginalCNLArr);
        var combinedZoneTaskMitigatedCNL = getCombinedNoiseLevel(individualZoneTaskMitigatedCNLArr);

        originalCNLForCurrentCombinedNSR.push(combinedZoneTaskOriginalCNL);
        mitigatedCNLForCurrentCombinedNSR.push(combinedZoneTaskMitigatedCNL);

        // var for insert into calculation result nsr database
        // var aOriCalResNSR = new CalculationResultNSR(0,projectId,false,currentBuildingId,currentBuildingName,currentPointId,currentCombinedZoneTask,0,0,0,0,combinedZoneTaskOriginalCNL,currentNoiseCriteria,"",0,0);
        // var aMitCalResNSR = new CalculationResultNSR(0,projectId,true,currentBuildingId,currentBuildingName,currentPointId,currentCombinedZoneTask,0,0,0,0,combinedZoneTaskMitigatedCNL,currentNoiseCriteria,"",0,0);
        var aOriCalResNSR = new CalculationResultNSR(
          0,
          projectId,
          false,
          currentBuildingId,
          currentBuildingName,
          currentPointId,
          currentNSRName,
          currentCombinedZoneTaskForFoundBuilding,
          "",
          0,
          0,
          0,
          0,
          0,
          0,
          combinedZoneTaskOriginalCNL,
          currentNoiseCriteria,
          "",
          0,
          0,
          currentlBuildingTotalFloor
        );
        var aMitCalResNSR = new CalculationResultNSR(
          0,
          projectId,
          true,
          currentBuildingId,
          currentBuildingName,
          currentPointId,
          currentNSRName,
          currentCombinedZoneTaskForFoundBuilding,
          "",
          0,
          0,
          0,
          0,
          0,
          0,
          combinedZoneTaskMitigatedCNL,
          currentNoiseCriteria,
          "",
          0,
          0,
          currentlBuildingTotalFloor
        );
        calculationResultNSROriginalForOneNSRArray.push(aOriCalResNSR);
        calculationResultNSRMitigatedForOneNSRArray.push(aMitCalResNSR);

        // var for pop up
        // var calculatedPopup = new CalculatedValuesPopup(0, currentCombinedZoneTask, combinedZoneTaskOriginalCNL);
        var calculatedPopup = new CalculatedValuesPopup(0, currentCombinedZoneTaskForFoundBuilding, combinedZoneTaskOriginalCNL);
        calcValArr.push(calculatedPopup);
        // calculatedPopup = new CalculatedValuesPopup(1, currentCombinedZoneTask, combinedZoneTaskMitigatedCNL);
        calculatedPopup = new CalculatedValuesPopup(1, currentCombinedZoneTaskForFoundBuilding, combinedZoneTaskMitigatedCNL);
        calcValArr.push(calculatedPopup);
      }
    } else {
      // console.log("zoneTaskIds");
      // console.log(zoneTaskIds);

      for (const currentCombinedZoneTask of combinedZoneTaskListArr) {
        var individualZoneTaskArr = currentCombinedZoneTask.split("+");
        var individualZoneTaskOriginalCNLArr = [];
        var individualZoneTaskMitigatedCNLArr = [];

        //check if it's closest type b zone
        if (
          individualZoneTaskArr.some((zt) => {
            let currentZoneIndex = parseInt(zt.split("-")[0]);
            return (
              zoneNSRNotionalInfo[currentPointId].closestZone != currentZoneIndex &&
              getZoneFeatFromArray(currentZoneIndex)?.get("calculationtype") == "B"
            );
          })
        ) {
          if (selectedNSRPointIdStringsSet.has(currentPointId.toString())) {
            console.log("didn't pass");
          }
          continue;
        }

        for (const curZoneTask of individualZoneTaskArr) {
          // var curZoneTaskIndex = zoneTaskIds.indexOf(curZoneTask);

          // if (curZoneTaskIndex < 0) {
          //   console.log("zone task index not found");
          //   continue;
          // }

          var originalCNLForCurrentZoneTask = originalCNLForCurrentNSR[curZoneTask];
          var mitigatedCNLForCurrentZoneTask = mitigatedCNLForCurrentNSR[curZoneTask];

          individualZoneTaskOriginalCNLArr.push(originalCNLForCurrentZoneTask);
          individualZoneTaskMitigatedCNLArr.push(mitigatedCNLForCurrentZoneTask);
        }

        var combinedZoneTaskOriginalCNL = getCombinedNoiseLevel(individualZoneTaskOriginalCNLArr);
        var combinedZoneTaskMitigatedCNL = getCombinedNoiseLevel(individualZoneTaskMitigatedCNLArr);

        originalCNLForCurrentCombinedNSR.push(combinedZoneTaskOriginalCNL);
        mitigatedCNLForCurrentCombinedNSR.push(combinedZoneTaskMitigatedCNL);

        // var for insert into calculation result nsr database
        var aOriCalResNSR = new CalculationResultNSR(
          0,
          projectId,
          false,
          currentBuildingId,
          currentBuildingName,
          currentPointId,
          currentNSRName,
          currentCombinedZoneTask,
          "",
          0,
          0,
          0,
          0,
          0,
          0,
          combinedZoneTaskOriginalCNL,
          currentNoiseCriteria,
          "",
          0,
          0,
          currentlBuildingTotalFloor
        );
        var aMitCalResNSR = new CalculationResultNSR(
          0,
          projectId,
          true,
          currentBuildingId,
          currentBuildingName,
          currentPointId,
          currentNSRName,
          currentCombinedZoneTask,
          "",
          0,
          0,
          0,
          0,
          0,
          0,
          combinedZoneTaskMitigatedCNL,
          currentNoiseCriteria,
          "",
          0,
          0,
          currentlBuildingTotalFloor
        );
        calculationResultNSROriginalForOneNSRArray.push(aOriCalResNSR);
        calculationResultNSRMitigatedForOneNSRArray.push(aMitCalResNSR);

        // var for pop up
        var calculatedPopup = new CalculatedValuesPopup(0, currentCombinedZoneTask, combinedZoneTaskOriginalCNL);
        calcValArr.push(calculatedPopup);
        calculatedPopup = new CalculatedValuesPopup(1, currentCombinedZoneTask, combinedZoneTaskMitigatedCNL);
        calcValArr.push(calculatedPopup);
      }
    }

    //get the maximum cnl
    var maxOriginalCNL = 0;
    var maxOriginalCNLZoneTaskId = "";
    var maxMitigatedCNL = 0;
    var maxMitigatedCNLZoneTaskId = "";
    for (const key of Object.keys(originalCNLForCurrentNSR)) {
      var curCNL = originalCNLForCurrentNSR[key];
      if (maxOriginalCNL < curCNL) {
        maxOriginalCNL = curCNL;
        maxOriginalCNLZoneTaskId = key;
      }
    }
    for (const [j, curCNL] of originalCNLForCurrentCombinedNSR.entries()) {
      if (maxOriginalCNL < curCNL) {
        maxOriginalCNL = curCNL;
        maxOriginalCNLZoneTaskId = combinedZoneTaskListArr[j];
      }
    }

    for (const key of Object.keys(mitigatedCNLForCurrentNSR)) {
      var curCNL = mitigatedCNLForCurrentNSR[key];
      if (maxMitigatedCNL < curCNL) {
        maxMitigatedCNL = curCNL;
        maxMitigatedCNLZoneTaskId = key;
      }
    }

    for (const [j, curCNL] of mitigatedCNLForCurrentCombinedNSR.entries()) {
      if (maxMitigatedCNL < curCNL) {
        maxMitigatedCNL = curCNL;
        maxMitigatedCNLZoneTaskId = combinedZoneTaskListArr[j];
      }
    }

    //check the othernoisecriteria
    var maxOtherCritUnMit = 999;
    var maxOtherCritMit = 999;
    for (const [j, aCritValue] of currentNSROtherNoiseCriteriaValueArr.entries()) {
      var aCritName = currentNSROtherNoiseCriteriaNameArr[j];
      var aCritStartDate = currentNSROtherNoiseCriteriaStartDateArr[j];
      var aCritEndDate = currentNSROtherNoiseCriteriaEndDateArr[j];
      var aCritSentence = currentNSROtherNoiseCriteriaSentenceArr[j];

      // if(aCritValue < maxOriginalCNL)
      // {
      currentNSROtherNoiseCriteriaExceedUnMitArr.push(aCritSentence);
      if (maxOtherCritUnMit > aCritValue) {
        currentNSROtherNoiseCriteriaExceedUnMitMax = aCritSentence;
        maxOtherCritUnMit = aCritValue;
      }
      // }

      // if(aCritValue < maxMitigatedCNL){
      currentNSROtherNoiseCriteriaExceedMitArr.push(aCritSentence);
      if (maxOtherCritMit > aCritValue) {
        currentNSROtherNoiseCriteriaExceedMitMax = aCritSentence;
        maxOtherCritMit = aCritValue;
      }
      // }
    }

    //update variables for db
    for (const aOriCalResNSR of calculationResultNSROriginalForOneNSRArray) {
      aOriCalResNSR.highestnoiselevel = maxOriginalCNL;
      aOriCalResNSR.othernoisecriteriaexceed = currentNSROtherNoiseCriteriaExceedUnMitArr.join("#");
      aOriCalResNSR.othernoisecriteriaexceedmax = currentNSROtherNoiseCriteriaExceedUnMitMax;

      calculationResultOriginalNSRArray.push(aOriCalResNSR);
      calculationResultNSRArray.push(aOriCalResNSR);
    }

    for (const aMitCalResNSR of calculationResultNSRMitigatedForOneNSRArray) {
      aMitCalResNSR.highestnoiselevel = maxMitigatedCNL;
      aMitCalResNSR.othernoisecriteriaexceed = currentNSROtherNoiseCriteriaExceedMitArr.join("#");
      aMitCalResNSR.othernoisecriteriaexceedmax = currentNSROtherNoiseCriteriaExceedMitMax;
      aMitCalResNSR.highestnoiselevelwithneighbour = nsrPointFeat.get("totalcnlwithneighbor") ? nsrPointFeat.get("totalcnlwithneighbor") : 0;

      calculationResultMitigatedNSRArray.push(aMitCalResNSR);
      calculationResultNSRArray.push(aMitCalResNSR);
    }

    // if (calcTypeTemp == "B") {
    //   let buildingids = [
    //     ...new Set(calculationResultNSRArray.map((c) => c.buildingid)),
    //   ];

    //   let nsrMinDistance = [];

    //   buildingids.forEach((id) => {
    //     let nsrResult = calculationResultNSRArray.filter(
    //       (c) => c.buildingid == id && c.distance != 0
    //     );
    //     let minDistance = Math.min(...nsrResult.map((n) => n.distance));
    //     nsrMinDistance.push(
    //       ...nsrResult.filter((c) => c.distance == minDistance)
    //     );
    //   });

    //   calculationResultNSRArray = nsrMinDistance;
    //   let nsrHighestNoise = [];

    //   buildingids.forEach((id) => {
    //     let nsrResultUnmitigated = calculationResultNSRArray.filter(
    //       (c) => c.buildingid == id && !c.ismitigated
    //     );
    //     let highestNoiseUnmitigate = Math.max(
    //       ...nsrResultUnmitigated.map((n) => n.cnl)
    //     );
    //     let nsrResultmitigated = calculationResultNSRArray.filter(
    //       (c) => c.buildingid == id && c.ismitigated
    //     );
    //     let highestNoiseMitigate = Math.max(
    //       ...nsrResultmitigated.map((n) => n.cnl)
    //     );
    //     nsrHighestNoise.push(
    //       ...nsrResultUnmitigated.map((n) => {
    //         return {
    //           ...n,
    //           highestnoiselevel: highestNoiseUnmitigate,
    //         };
    //       })
    //     );
    //     nsrHighestNoise.push(
    //       ...nsrResultmitigated.map((n) => {
    //         return {
    //           ...n,
    //           highestnoiselevel: highestNoiseMitigate,
    //         };
    //       })
    //     );
    //   });

    //   calculationResultNSRArray = nsrHighestNoise;
    // }
    //update variables for db - end
    nsrPointFeat.set("totalcnl", maxOriginalCNL);
    nsrPointFeat.set("totalcnlmit", maxMitigatedCNL);
    nsrPointFeat.set("calcvalues", JSON.stringify(calcValArr));
    // if(currentBuildingId === 1111111020) {
    //     console.log("calcValArr for 1111111020");
    //     console.log(calcValArr);
    //     console.log("nsrPointFeat.get('calcvalues')");
    //     console.log(nsrPointFeat.get('calcvalues'));
    // }

    var useMitigated = false;
    if (maxMitigatedCNL > 0 && maxMitigatedCNL !== maxOriginalCNL) {
      useMitigated = true;
    }
    // console.log("useMitigated");
    // console.log(useMitigated);
    // console.log("maxOriginalCNL");
    // console.log(maxOriginalCNL);
    // console.log("maxMitigatedCNL");
    // console.log(maxMitigatedCNL);
    // console.log("currentNoiseCriteria");
    // console.log(currentNoiseCriteria);

    if (useMitigated) {
      if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
        // if the result is red
        nsrPointFeat.setStyle(redNSRPointMitStyleFunctionWithNSRName);
        //console.log("redNSRPointMitStyleFunctionWithNSRName");
        //test below between calculationResultMitigatedNSRArray or calculationResultNSRArray
        calculateBarrierHeight(
          calculationResultMitigatedNSRArray,
          currentNoiseCriteria,
          currentlBuildingTotalFloor,
          currentlBuildingHeight,
          floorHeightAssumption
        );
      } else {
        nsrPointFeat.setStyle(greenNSRPointStyleFunctionWithNSRName);
        //console.log("greenNSRPointStyleFunctionWithNSRName");
      }
    } else {
      if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
        // if the result is red
        nsrPointFeat.setStyle(redNSRPointUnmitStyleFunctionWithNSRName);
        //console.log("redNSRPointUnmitStyleFunctionWithNSRName");
      } else {
        nsrPointFeat.setStyle(greenNSRPointStyleFunctionWithNSRName);
        //console.log("greenNSRPointStyleFunctionWithNSRName");
      }
    }
    if (selectedNSRPoints.length) {
      let filter = selectedNSRPoints.filter((p) => p.buildingId === nsrPointFeat.get("buildingid"));
      if (filter.length) {
        console.log("calculateNoise6 filter", filter);
        // nsrPointFeat.set("nsrname", filter[0].get("nsrname"));
      } else {
        nsrPointFeat.setStyle(unselectedNSRPointStyle);
      }
    }
    // if (selectedNSRPointIds.length > 0) {
    //   var isThisNSRSelected = false;
    //   var isAllEmpty = true;
    //   for (const selNSRId of selectedNSRPointIds) {
    //     // console.log("selNSRId");
    //     // console.log("#" + selNSRId + "#");
    //     if (selNSRId !== "") {
    //       isAllEmpty = false;
    //       //continue;
    //     }
    //     // console.log("currentPointId");
    //     // console.log(currentPointId);
    //     // console.log("selNSRId");
    //     // console.log(selNSRId);
    //     // console.log("parseInt(currentPointId) === parseInt(selNSRId)");
    //     // console.log(parseInt(currentPointId) === parseInt(selNSRId));
    //     if (parseInt(currentPointId) === parseInt(selNSRId)) {
    //       isThisNSRSelected = true;
    //       break;
    //     }
    //   }
    //   if (!isThisNSRSelected && !isAllEmpty) {
    //     //change here
    //     nsrPointFeat.setStyle(unselectedNSRPointStyle);
    //   }
    // }
    // console.log("nsrPointFeat");
    // console.log(nsrPointFeat);
    // if (nsrPointFeat.get("nsrname") === "N6")
    // {
    //     console.log('nsrPointFeat');
    //     console.log(nsrPointFeat);
    //     console.log("calcValArr");
    //     console.log(calcValArr);

    // }

    thisLayer.getSource().addFeature(nsrPointFeat);
  }
  initSelectedNSRFeatures(false);
  calculationResultNSRGlobal = calculationResultNSRArray; // put to global var.
  // console.log("calculationResultNSRGlobal from noise calculation");
  // console.log(calculationResultNSRGlobal);
  console.log(projectObj);
  if (projectObj) {
    projectObj.calculationResultNSR = calculationResultNSRArray;
    console.log("projectObj.calculationResultNSR on calculatenose6");
    console.log(projectObj.calculationResultNSR);
  }
  saveCalculationResultDetail(projectId, calculationResultDetailArray, calculationResultNSRArray, callback);
  // console.log("notionalPointsFeatArr");
  // console.log(notionalPointsFeatArr);
  // saveNotionalPoints(notionalPointsFeatArr);

  console.log("End Calculation");
  // console.log(thisLayer.getSource().getFeatures());
  // console.log(testRedFeatures);
  isAfterCalculation = true;
}

function saveCalculationResult(projectId, calculationResultGroupArr, callback) {
  var deleteURL = SERVER_URL2 + "CalculationResultGroup/projectid/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      console.log("Finish delete in saveCalculationResult");
      saveCalculationResult2(projectId, calculationResultGroupArr, callback);
    });
}

function saveCalculationResult2(projectId, calculationResultGroupArr, callback) {
  console.log("calculationResultGroupArr");
  // calculationResultGroupArr.forEach(item => {
  //     console.log(item.buildingName);
  // })
  calculationResultGroupArray = calculationResultGroupArr; // ==> save to global so vue can get the value.
  //console.log(calculationResultGroupArr);
  var postURL = SERVER_URL2 + "CalculationResultGroup";
  //var postURL = 'https://localhost:44384/CalculationResultGroup';
  // console.log("calculationResultGroupArr");
  // console.log(calculationResultGroupArr);
  fetch(postURL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    //mode: 'no-cors',
    body: JSON.stringify(calculationResultGroupArr),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      console.log("Finish saveCalculationResult2");
      updateIsCalculated(projectId, 1, callback);
      console.log("Finish calculating");
      //alert("Finish calculating");
    });
}

function calculateBarrierHeight(
  calculationResultMitigatedNSRArray,
  currentNoiseCriteria,
  currentlBuildingTotalFloor,
  currentlBuildingHeight,
  heightPerFloor
) {
  // console.log("Entering calculateBarrierHeight");
  //use buildingid and zonetaskid from global var: buildingIdForMitigation , zoneTaskIdsForMitigation

  var combinedZoneTaskArr = [];
  var barrieredZoneTaskArr = [];
  var cnlPerFloor = [];
  var nonBarrierCNL = [];
  var horizontalDistance = 0;
  const zoneTaskIdsForMitigationSet = new Set(zoneTaskIdsForMitigation);
  // console.log("calculationResultMitigatedNSRArray")
  // console.log(calculationResultMitigatedNSRArray)
  // console.log("buildingIdForMitigation")
  // console.log(buildingIdForMitigation)
  for (const currentCalcResultNSR of calculationResultMitigatedNSRArray) {
    var currentBuildingId = currentCalcResultNSR.buildingid;
    var currentIsmitigated = currentCalcResultNSR.ismitigated;
    var currentZonetaskorcombined = currentCalcResultNSR.zonetaskorcombined;

    if (currentIsmitigated === true && currentBuildingId === buildingIdForMitigation) {
      if (currentZonetaskorcombined.includes("+")) {
        var zoneTaskDict = new CustDictionary(currentZonetaskorcombined, null, null);
        combinedZoneTaskArr.push(zoneTaskDict);
      } else {
        if (zoneTaskIdsForMitigationSet.has(currentZonetaskorcombined)) {
          var zoneTaskDict = new CustDictionary(currentZonetaskorcombined, null, null);
          barrieredZoneTaskArr.push(zoneTaskDict);
          var currentSWL = currentCalcResultNSR.highestswl;
          var currentHorDistance = currentCalcResultNSR.distance;
          horizontalDistance = currentCalcResultNSR.distance;

          var currentFloor = 1;
          var currentHeight = currentFloor * heightPerFloor;
          while (currentHeight <= currentlBuildingHeight) {
            var verticalDistance = currentHeight;
            var slantDistance = Math.pow(Math.pow(currentHorDistance, 2) + Math.pow(verticalDistance, 2), 0.5);
            var hemisphericalPropagation = -1 * (20 * Math.log10(slantDistance) + 8);
            var facadeCorrection = 3;
            var totalCNLMitigated =
              currentSWL + hemisphericalPropagation + facadeCorrection > 0 ? currentSWL + hemisphericalPropagation + facadeCorrection : 0;

            var barrierCNLPerFloor = new CustDictionary(currentZonetaskorcombined, currentFloor, totalCNLMitigated);
            cnlPerFloor.push(barrierCNLPerFloor);

            currentFloor = currentFloor + 1;
            currentHeight = currentFloor * heightPerFloor;
          }
        } else {
          var currentCNL = currentCalcResultNSR.cnl;
          var nonBarrierFixedCNL = new CustDictionary(currentZonetaskorcombined, null, currentCNL);
          nonBarrierCNL.push(nonBarrierFixedCNL);
        }
      }
    }
  }
  // console.log("combinedZoneTaskArr")
  // console.log(combinedZoneTaskArr)
  // console.log("barrieredZoneTaskArr")
  // console.log(barrieredZoneTaskArr)
  // console.log("nonBarrierCNL")
  // console.log(nonBarrierCNL)

  const cnlPerFloorByFloor = new Map();
  for (const cnlPerFloorObj of cnlPerFloor) {
    if (!cnlPerFloorByFloor.has(cnlPerFloorObj.item)) {
      cnlPerFloorByFloor.set(cnlPerFloorObj.item, new Map());
    }
    cnlPerFloorByFloor.get(cnlPerFloorObj.item).set(cnlPerFloorObj.key, cnlPerFloorObj.remark);
  }
  const combinedZoneTaskParts = combinedZoneTaskArr.map((zoneTaskObj) => ({
    key: zoneTaskObj.key,
    zoneTasks: zoneTaskObj.key.split("+"),
  }));

  //check floor by floor
  var currentFloor = 1;
  var currentHeight = currentFloor * heightPerFloor;
  var greenFound = false;
  while (currentHeight <= currentlBuildingHeight) {
    var thisFloorCNLs = [];
    const thisFloorCNLMap = new Map();

    //check the barriered activities first
    const currentFloorBarrierCNLs = cnlPerFloorByFloor.get(currentFloor);
    if (currentFloorBarrierCNLs) {
      for (const [currentZoneTask, currentFloorCNL] of currentFloorBarrierCNLs) {
        var thisFloorCNL = new CustDictionary(currentZoneTask, null, currentFloorCNL);
        thisFloorCNLs.push(thisFloorCNL);
        thisFloorCNLMap.set(currentZoneTask, currentFloorCNL);
      }
    }

    // add the non barriered activities
    for (const nonBarrierCNLObj of nonBarrierCNL) {
      var thisFloorCNL = new CustDictionary(nonBarrierCNLObj.key, null, nonBarrierCNLObj.remark);
      thisFloorCNLs.push(thisFloorCNL);
      thisFloorCNLMap.set(nonBarrierCNLObj.key, nonBarrierCNLObj.remark);
    }

    // add the combination
    for (const currentCombination of combinedZoneTaskParts) {
      var cnlsToCombine = [];
      for (const currentZoneTask of currentCombination.zoneTasks) {
        const theCNL = thisFloorCNLMap.get(currentZoneTask);
        if (theCNL !== undefined) {
          cnlsToCombine.push(theCNL);
        }
      }

      var thisCombinedCNL = getCombinedNoiseLevel(cnlsToCombine);
      var thisFloorCNL = new CustDictionary(currentCombination.key, null, thisCombinedCNL);
      thisFloorCNLs.push(thisFloorCNL);
      thisFloorCNLMap.set(currentCombination.key, thisCombinedCNL);
    }

    // get the max CNL
    var maxCNL = 0;
    for (const aThisFloorCNL of thisFloorCNLs) {
      var aCNL = aThisFloorCNL.remark;
      if (maxCNL < aCNL) {
        maxCNL = aCNL;
      }
    }

    //compare this floor's cnl with currentNoiseCriteria
    if (maxCNL <= currentNoiseCriteria) {
      greenFound = true;
      break;
    }

    currentFloor = currentFloor + 1;
    currentHeight = currentFloor * heightPerFloor;
  }
  if (!greenFound) {
    currentFloor = currentlBuildingTotalFloor;
    currentHeight = currentFloor * heightPerFloor;
  }

  //calculate barrier height
  var barrierDistFromEqp = 3; // barrier located fixed distance from equipment
  var defaultEquipmentBaseHeight = 1; // 1 meter from ground;
  var maxHeight = 7; // max barrier height = 7 meter
  var barHeight = (currentHeight * barrierDistFromEqp) / horizontalDistance + defaultEquipmentBaseHeight;
  if (barHeight > maxHeight) {
    barHeight = maxHeight;
  }

  //save back to calculationResultNSRArray
  for (const currentCalcResultNSR of calculationResultMitigatedNSRArray) {
    var currentBuildingId = currentCalcResultNSR.buildingid;
    var currentIsmitigated = currentCalcResultNSR.ismitigated;
    if (currentIsmitigated === true && currentBuildingId === buildingIdForMitigation) {
      if (greenFound) {
        currentCalcResultNSR.lastredfloor = currentFloor - 1;
      } else {
        currentCalcResultNSR.lastredfloor = currentFloor;
      }
      currentCalcResultNSR.barrierheight = barHeight;
      currentCalcResultNSR.totalfloor = currentlBuildingTotalFloor;

      console.log("currentCalcResultNSR.lastredfloor");
      console.log(currentCalcResultNSR.lastredfloor);
      console.log("currentCalcResultNSR.barrierheight");
      console.log(currentCalcResultNSR.barrierheight);
      console.log("currentCalcResultNSR.totalfloor");
      console.log(currentCalcResultNSR.totalfloor);
    }
  }
}

function saveCalculationResultDetail(projectId, calculationResultDetailArr, calculationResultNSRArr, callback) {
  var deleteURL = SERVER_URL2 + "CalculationResultDetail/projectid/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      console.log("Finish delete result detail in saveCalculationDetail");

      deleteURL = SERVER_URL2 + "CalculationResultNSR/projectid/" + projectId.toString();
      fetch(deleteURL, {
        method: "DELETE",
        //mode: 'no-cors',
      })
        .then(function (response) {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function (json) {
          console.log("Finish delete result nsr in saveCalculationDetail");

          saveCalculationResultDetail2(projectId, calculationResultDetailArr, calculationResultNSRArr, callback);
        });
    });
}

function saveCalculationResultDetail2(projectId, calculationResultDetailArr, calculationResultNSRArr, callback) {
  console.log("saveCalculationResultDetail2");
  // calculationResultGroupArr.forEach(item => {
  //     console.log(item.buildingName);
  // })
  calculationResultGroupArray = calculationResultDetailArr; // ==> save to global so vue can get the value.
  console.log("calculationResultDetailArr");
  console.log(calculationResultDetailArr);
  console.log(JSON.stringify(calculationResultDetailArr));
  var postURL = SERVER_URL2 + "CalculationResultDetail";
  var batchSize = 100;
  var detailBatches = [];
  for (var i = 0; i < calculationResultDetailArr.length; i += batchSize) {
    detailBatches.push(calculationResultDetailArr.slice(i, i + batchSize));
  }

  function postNextBatch(batchIndex) {
    if (batchIndex >= detailBatches.length) {
      console.log("Finish saveCalculationResult2");
      saveCalculationResultDetail3(projectId, calculationResultNSRArr, callback);
      //updateIsCalculated(projectId,1,callback);
      console.log("Finish saveCalculationResultDetail2");
      //alert("Finish calculating");
      return;
    }

    fetch(postURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      //mode: 'no-cors',
      body: JSON.stringify(detailBatches[batchIndex]),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        console.log("Finish saveCalculationResultDetail2 batch " + (batchIndex + 1).toString() + "/" + detailBatches.length.toString());
        postNextBatch(batchIndex + 1);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  postNextBatch(0);
}
function saveCalculationResultDetail3(projectId, calculationResultNSRArr, callback) {
  console.log("saveCalculationResultDetail3");
  //console.log(calculationResultNSRArr);
  // calculationResultNSRArr.forEach(item => {
  //     if(item.nsrname){

  //     }
  // })
  calculationResultGroupArray = calculationResultNSRArr
    .filter((c) => c.cnl)
    .filter((c) => selectedNSRPointIds.map((id) => id.toString()).includes(c.nsrpointid.toString())); // ==> save to global so vue can get the value.

  calculationResultGroupArray = calculationResultGroupArray.map((c) => {
    if (c.highestnoiselevel === 0) {
      return {
        ...c,
        highestnoiselevel: c.highestnoiselevelwithneighbour,
      };
    } else if (c.highestnoiselevelwithneighbour === 0) {
      return {
        ...c,
        highestnoiselevelwithneighbour: c.highestnoiselevel,
      };
    } else return c;
  });
  console.log(calculationResultNSRArr.filter((c) => !c.ismitigated));
  var postURL = SERVER_URL2 + "CalculationResultNSR";
  var batchSize = 100;
  var nsrBatches = [];
  for (var i = 0; i < calculationResultGroupArray.length; i += batchSize) {
    nsrBatches.push(calculationResultGroupArray.slice(i, i + batchSize));
  }

  function postNextNSRBatch(batchIndex) {
    if (batchIndex >= nsrBatches.length) {
      console.log("Finish saveCalculationResultDetail3");
      updateIsCalculated(projectId, 1, callback);
      isCalculatedGlobal2 = 1; //added by Marvin Alex
      console.log("Finish calculating");
      //alert("Finish calculating");
      return;
    }

    fetch(postURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      //mode: 'no-cors',
      body: JSON.stringify(nsrBatches[batchIndex]),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        console.log("Finish saveCalculationResultDetail3 batch " + (batchIndex + 1).toString() + "/" + nsrBatches.length.toString());
        postNextNSRBatch(batchIndex + 1);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  postNextNSRBatch(0);
}

olMap.calculatedNoiseGroupArray = function () {
  return calculationResultGroupArray;
};

olMap.getCalculationResult = function () {
  return calculationResultGroupArray;
};

olMap.getSelectedNSRPointIds = function () {
  return selectedNSRPointIds;
};

olMap.getHighestNoiseNSRIds = function () {
  return highestNoiseNSRIds;
};

olMap.isHighestNoiseNSRMoved = function () {
  let result = false;
  highestNoiseNSRIds.forEach((id) => {
    if (movedNSRPointIds.includes(id)) {
      result = true;
    }
  });
  return result;
};
olMap.isHighestNoiseNSRDeleted = function () {
  let result = false;
  let deletedNSRPointIds = selectedDefaultBuildingFeats.map((f) => f.get("id"));
  highestNoiseNSRIds.forEach((id) => {
    if (deletedNSRPointIds.includes(id)) {
      result = true;
    }
  });
  return result;
};

olMap.getSelectedNSRPoints = function () {
  return selectedNSRFeatures.map((f) => {
    return {
      id: f.get("id"),
      nsrName: f.get("nsrname"),
      buildingName: f.get("BldName_E"),
      noisecriteria: f.get("noisecriteria"),
      contributionText: f.get("othernoisecriteria"),
      contributions: f.get("othernoisecriteria")
        ? f
            .get("othernoisecriteria")
            .split("#")
            .map((o) => {
              return { contributionText: o };
            })
        : [],
      feature: f,
    };
  });
};

olMap.setSelectedNSRPointsIDState = function () {
  oldSelectedNSRPointIds = selectedNSRPointIds;
  console.log(oldSelectedNSRPointIds);
};

olMap.getApprovedProjectIds = function () {
  return approvedProjectIDs;
};

olMap.getMapCanvas = function () {
  return map?.getTargetElement().querySelectorAll(".ol-layer canvas");
};

olMap.zoomToCurrentBuffer = function (projectid, callback) {
  notionalPointSource.clear();
  zoomToCurrentBuffer(projectid, callback);
};

function CalculatedValues(dateGroup, tasks, totalCNL) {
  this.dateGroup = dateGroup;
  this.tasks = tasks;
  this.totalCNL = totalCNL;
}

function CalculatedValuesPopup(ismitigated, zonetask, totalCNL) {
  this.ismitigated = ismitigated;
  this.zonetask = zonetask;
  this.totalCNL = totalCNL;
}

function CalculationResultGroup(
  id,
  projectId,
  startDate,
  endDate,
  totalCnl,
  buildingId,
  noiseCriteria,
  buildingName,
  totalcnlalone,
  approvedprojectid,
  approvedprojectidcnl,
  maxExclusiveGroup
) {
  this.id = id;
  this.projectId = projectId;
  this.startDate = startDate;
  this.endDate = endDate;
  this.totalcnl = totalCnl;
  this.buildingid = buildingId;
  this.noiseCriteria = noiseCriteria;
  this.buildingName = buildingName;
  this.totalcnlalone = totalcnlalone;
  this.approvedprojectid = approvedprojectid;
  this.approvedprojectidcnl = approvedprojectidcnl;
  this.maxExclusiveGroup = maxExclusiveGroup;
  this.lastredfloor = -1;
  this.barrierheight = -1;
  this.totalfloor = -1;
}

function CalculationResultDetail(
  id,
  projectid,
  ismitigated,
  zoneid,
  taskid,
  exclusivegroup,
  startdate,
  enddate,
  pmeid,
  pmename,
  pmeref,
  swl,
  timepercent,
  timecorrection,
  qty,
  totalswl,
  mitigationmeasure,
  mitigationeffect,
  mitigatedswl,
  groupswl,
  highestswl
) {
  this.id = id;
  this.projectid = projectid;
  this.ismitigated = ismitigated;
  this.zoneid = zoneid;
  this.taskid = taskid;
  this.exclusivegroup = exclusivegroup;
  this.startDate = startdate;
  this.endDate = enddate;
  this.pmeid = pmeid;
  this.pmename = pmename;
  this.pmeref = pmeref;
  this.swl = swl;
  this.timepercent = timepercent;
  this.timecorrection = timecorrection;
  this.qty = qty;
  this.totalswl = totalswl;
  this.mitigationmeasure = mitigationmeasure;
  this.mitigationeffect = mitigationeffect;
  this.mitigatedswl = mitigatedswl;
  this.groupswl = groupswl;
  this.highestswl = highestswl;
}

function CalculationResultNSR(
  id,
  projectid,
  ismitigated,
  buildingid,
  bldname_e,
  nsrpointid,
  nsrname,
  zonetaskorcombined,
  excgroups,
  highestswl,
  distance,
  distancecorr,
  facadecorr,
  spl,
  totalspl,
  cnl,
  noisecriteria,
  approvedprojectid,
  highestnoiselevel,
  highestnoiselevelwithneighbour,
  totalFloor
) {
  this.id = id;
  this.projectid = projectid;
  this.ismitigated = ismitigated;
  this.buildingid = buildingid;
  this.buildingName = bldname_e;
  this.nsrpointid = nsrpointid;
  this.nsrname = nsrname;
  this.zonetaskorcombined = zonetaskorcombined;
  this.excgroups = excgroups;
  this.highestswl = highestswl;
  this.distance = distance;
  this.distancecorr = distancecorr;
  this.facadecorr = facadecorr;
  this.spl = spl;
  this.totalspl = totalspl;
  this.cnl = cnl;
  this.noisecriteria = noisecriteria;
  this.approvedProjectId = approvedprojectid;
  this.lastredfloor = -1;
  this.barrierheight = -1;
  this.totalfloor = totalFloor;
  this.highestnoiselevel = highestnoiselevel;
  this.highestnoiselevelwithneighbour = highestnoiselevelwithneighbour;
  this.othernoisecriteriaexceed = "";
  this.othernoisecriteriaexceedmax = "";
}

function ProjectIsCalculated(projectId, isCalculated) {
  this.id = projectId;
  this.iscalculated = isCalculated;
}

function ProjectSelectedNSR(projectId, selectedNSR) {
  this.id = projectId;
  this.selectednsr = selectedNSR;
}

function CustDictionary(key, item, remark) {
  this.key = key;
  this.item = item;
  this.remark = remark;
}

olMap.getNSRNameAndBuildingNameFromNSRPointIDAndBuildingId = function (nsrPointId, buildingId) {
  var thisLayer = getLayerByTitle("calculatedNSRPointsLayer");
  var allFeatures = thisLayer.getSource().getFeatures();
  var nsrName = "";
  var buildingName = "";
  var returnValues = [];
  for (let i = 0; i < allFeatures.length; i++) {
    var currentFeat = allFeatures[i];
    var currentFeatId = currentFeat.get("id");
    var currentBuildingId = currentFeat.get("buildingid");
    var currentBuildingName = currentFeat.get("BldName_E");
    var currentNSRName = currentFeat.get("nsrname");

    if (currentFeatId === nsrPointId && currentBuildingId === buildingId) {
      nsrName = currentNSRName;
      buildingName = currentBuildingName;
      returnValues.push(nsrName);
      returnValues.push(buildingName);
      break;
    }
  }
  return returnValues;
};

olMap.changeNSRPointColorForSelection = function (update, callback) {
  let calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");
  // get all nsr point features
  let allCalculatedNSRPointFeats = calculatedNSRPointsLayer.getSource().getFeatures();

  // check whether using mitigated cnl or unmitigated cnl
  let isMitgated = false;
  // console.log("allCalculatedNSRPointFeats");
  // console.log(allCalculatedNSRPointFeats);
  for (let i = 0; i < allCalculatedNSRPointFeats.length; i++) {
    let curFeat = allCalculatedNSRPointFeats[i];
    if (curFeat.get("totalcnl") !== curFeat.get("totalcnlmit")) {
      isMitgated = true;
    }
  }
  //get sorted array of colored-calculated-NSR Points
  let sortedPointArray = [];
  // var sortedPointArray = allCalculatedNSRPointFeats
  //   .filter((p) => p.get("noisecriteria"))
  //   .sort((a, b) =>
  //     isMitgated
  //       ? b.get("totalcnlmit") -
  //         b.get("noisecriteria") -
  //         (a.get("totalcnlmit") - a.get("noisecriteria"))
  //       : b.get("totalcnl") -
  //         b.get("noisecriteria") -
  //         (a.get("totalcnl") - a.get("noisecriteria"))
  //   );
  for (let i = 0; i < allCalculatedNSRPointFeats.length; i++) {
    let pointFeatToProcess = allCalculatedNSRPointFeats[i];
    let pointFeatToProcessNoiseCrit = pointFeatToProcess.get("noisecriteria");
    let pointFeatToProcessValToCompare = 0;
    if (isMitgated) {
      pointFeatToProcessValToCompare = pointFeatToProcess.get("totalcnlmit");
    } else {
      pointFeatToProcessValToCompare = pointFeatToProcess.get("totalcnl");
    }
    pointFeatToProcessValToCompare = pointFeatToProcessValToCompare - pointFeatToProcessNoiseCrit;

    let alreadyInserted = false;
    for (let j = 0; j < sortedPointArray.length; j++) {
      let curCheckFeat = sortedPointArray[j];
      let curCheckFeatNoiseCrit = curCheckFeat.get("noisecriteria");
      let curCheckFeatValToCompare = 0;
      if (isMitgated) {
        curCheckFeatValToCompare = curCheckFeat.get("totalcnlmit");
      } else {
        curCheckFeatValToCompare = curCheckFeat.get("totalcnl");
      }
      curCheckFeatValToCompare = curCheckFeatValToCompare - curCheckFeatNoiseCrit;

      if (pointFeatToProcessValToCompare >= curCheckFeatValToCompare) {
        alreadyInserted = true;
        sortedPointArray.splice(j, 0, pointFeatToProcess);
        break;
      }
    }
    if (sortedPointArray.length === 0 || !alreadyInserted) {
      sortedPointArray.push(pointFeatToProcess);
    }
  }
  // color the points
  let accommodationFound = false;
  let educationalFound = false;
  highestNoiseNSRIds = [];
  // if (selectedNSRPointIds.filter((p) => p).length === 0) {
  let sortByNoise = [...sortedPointArray];
  sortByNoise.sort((a, b) => b.get("totalcnl") - a.get("totalcnl"));
  console.log("sortedPointArray", sortedPointArray);
  console.log(
    "sortedPointArrayIds",
    sortedPointArray.map((f) => f.get("id"))
  );
  for (let i = 0; i < sortByNoise.length; i++) {
    let f = sortByNoise[i];
    let currentNoiseCriteria = f.get("noisecriteria");
    let buildingId = f.get("buildingid"); // default building nsr id starts from 1000000001
    let id = f.get("id");
    if (!accommodationFound && currentNoiseCriteria == 75 && buildingId > 1000000000) {
      if (!selectedNSRPoints.map((p) => p.buildingId).includes(buildingId)) {
        selectedNSRPointIds.push(id);
        selectedNSRPoints.push({
          id: id,
          buildingId: buildingId,
        });
      }
      highestNoiseNSRIds.push(id);
      accommodationFound = true;
    }
    if (!educationalFound && currentNoiseCriteria == 70 && buildingId > 1000000000) {
      if (!selectedNSRPoints.map((p) => p.buildingId).includes(buildingId)) {
        selectedNSRPointIds.push(id);
        selectedNSRPoints.push({
          id: id,
          buildingId: buildingId,
        });
      }
      highestNoiseNSRIds.push(id);
      educationalFound = true;
    }
    if (accommodationFound && educationalFound) {
      break;
    }
  }
  // }
  nsrFeaturesToAdd.forEach((f) => {
    if (!selectedNSRPoints.map((p) => p.id).includes(f.get("id"))) {
      selectedNSRPointIds.push(f.get("id"));
      selectedNSRPoints.push({
        id: f.get("id"),
        buildingId: f.get("buildingid"),
      });
    }
  });
  nsrFeaturesToAdd = [];
  for (let i = 0; i < sortByNoise.length; i++) {
    let curCheckFeat = sortByNoise[i];
    let currentNoiseCriteria = curCheckFeat.get("noisecriteria");
    let maxMitigatedCNL = curCheckFeat.get("totalcnlmit");
    let maxOriginalCNL = curCheckFeat.get("totalcnl");

    if (isMitgated) {
      if (i >= 20) {
        if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
          // if the result is red
          curCheckFeat.setStyle(redNSRPointMitStyleFunctionWithNSRName);
        } else {
          curCheckFeat.setStyle(greenNSRPointWithWhiteStrokeStyleFunctionWithNSRName);
        }
      } else {
        if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
          // if the result is red
          curCheckFeat.setStyle(redNSRPointMitStyle20MaxFunctionWithNSRName);
        } else {
          curCheckFeat.setStyle(greenNSRPointStyle20MaxFunctionWithNSRName);
        }
      }
    } else {
      if (i >= 20) {
        if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
          // if the result is red
          curCheckFeat.setStyle(redNSRPointUnmitStyleFunctionWithNSRName);
        } else {
          curCheckFeat.setStyle(greenNSRPointWithWhiteStrokeStyleFunctionWithNSRName);
        }
      } else {
        if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
          // if the result is red
          curCheckFeat.setStyle(redNSRPointUnmitStyle20MaxFunctionWithNSRName);
        } else {
          curCheckFeat.setStyle(greenNSRPointStyle20MaxFunctionWithNSRName);
        }
      }
    }
  }

  initiateSelectNSRPoints(update);

  if (callback) {
    callback();
  }
};

function initiateSelectNSRPoints(update) {
  // set default nsrname
  var calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");

  if (nsrSelect) {
    map.removeInteraction(nsrSelect);
  }
  if (dragBox) {
    map.removeInteraction(dragBox);
  }
  // console.log("check initial selectedNSRFeatures");
  // console.log(selectedNSRFeatures);
  // a normal select interaction to handle click
  // nsrSelect = new Select({
  //   style: function (feature) {
  //     var theVal = "Id: " + feature.get("id").toString();
  //     var currentNSRName = feature.get("nsrname");
  //     if (currentNSRName) {
  //       theVal = currentNSRName;
  //     }

  //     selectedNSRStyle.getText().setText(theVal.toString());

  //     return selectedNSRStyle;
  //   },
  //   layers: [],
  // });
  // map.addInteraction(nsrSelect);

  // selectedNSRFeatures = nsrSelect.getFeatures();

  //get the table node
  // var nsrTableNode = document.getElementById("selectionViewSelectedNSRTable");

  //reset table
  // while (nsrTableNode.hasChildNodes()) {
  //   nsrTableNode.removeChild(nsrTableNode.lastChild);
  // }

  // check if it has a stored selectedNSR
  initSelectedNSRFeatures(true);

  console.log("initiateSelectNSRPoints selectedNSRFeatures", selectedNSRFeatures);

  // a DragBox interaction used to select features by drawing boxes
  dragBox = new DragBox({
    condition: platformModifierKeyOnly,
  });
  map.addInteraction(dragBox);

  let nsrNames = selectedNSRFeatures.map((f) => f.get("nsrname"));

  for (let m = 0; m < selectedNSRFeatures.length; m++) {
    var currentFeat = selectedNSRFeatures[m];
    var currentFeatId = currentFeat.get("id");
    var currentNSRName = currentFeat.get("nsrname");
    var currentBuildingName = currentFeat.get("BldName_E");
    var currentNoiseCriteria = currentFeat.get("noisecriteria");
    var currentOtherNoiseCriteria = currentFeat.get("othernoisecriteria");
    var otherNoiseCriteriaArr = [];
    if (currentOtherNoiseCriteria) {
      otherNoiseCriteriaArr = currentOtherNoiseCriteria.split("#");
    }
    if (!currentNSRName || nsrNames.filter((n) => n === currentNSRName).length > 1) {
      let index = 0;
      while (nsrNames.includes(`N${index + 1}`)) {
        index++;
      }
      nsrNames.push(`N${index + 1}`);
      console.log("nsrname", `N${index + 1}`);
      currentFeat.set("nsrname", `N${index + 1}`);
    }
    currentFeat.setStyle(selectednsrPointStyleFunction);
  }
  dragBox.on("boxstart", function () {
    console.log("boxstart");
  });
  dragBox.on("boxend", function () {
    const extent = dragBox.getGeometry().getExtent();
    const boxFeatures = calculatedNSRPointsLayer
      .getSource()
      .getFeaturesInExtent(extent)
      .filter((feature) => feature.getGeometry().intersectsExtent(extent));

    // features that intersect the box geometry are added to the
    // collection of selected features

    // if the view is not obliquely rotated the box geometry and
    // its extent are equalivalent so intersecting features can
    // be added directly to the collection
    const rotation = map.getView().getRotation();
    const oblique = rotation % (Math.PI / 2) !== 0;

    // when the view is obliquely rotated the box extent will
    // exceed its geometry so both the box and the candidate
    // feature geometries are rotated around a common anchor
    // to confirm that, with the box geometry aligned with its
    // extent, the geometries intersect
    console.log("nsrSelectMode", nsrSelectMode);
    let selectedIds = [];
    let deselectedIds = [];

    if (oblique) {
      const anchor = [0, 0];
      const geometry = dragBox.getGeometry().clone();
      geometry.rotate(-rotation, anchor);
      const extent = geometry.getExtent();
      boxFeatures.forEach(function (feature) {
        const geometry = feature.getGeometry().clone();
        geometry.rotate(-rotation, anchor);
        if (geometry.intersectsExtent(extent)) {
          if (nsrSelectMode === 1) {
            selectedNSRFeatures.push(feature);
            selectedIds.push(feature);
          } else {
            for (let i = 0; i < selectedNSRFeatures.length; i++) {
              var curFeat = selectedNSRFeatures[i];
              if (curFeat == feature) {
                console.log("nsrname", null);
                feature.set("nsrname", null);
                curFeat.set("nsrname", null);
                feature.setStyle(selectionStyleFunction);
                curFeat.setStyle(selectionStyleFunction);
                deselectedNSRFeatures.push(feature);
                deselectedNSRFeatures.push(curFeat);
                deselectedIds.push(feature.get("id"));
                selectedNSRFeatures.splice(i, 1);
                i--;
              }
            }
          }
        }
      });
    } else {
      if (nsrSelectMode === 1) {
        boxFeatures
          .filter((f) => !selectedNSRFeatures.map((f) => f.get("id")).includes(f.get("id")))
          .forEach((f) => {
            if (!selectedNSRFeatures.map((f) => f.get("id")).includes(f.get("id"))) {
              selectedNSRFeatures.push(f);
              selectedIds.push(f.get("id"));
              f.setStyle(selectednsrPointStyleFunction);
            }
            // selectedNSRPointIds.push(f.get("id"));
          });
        //console.log("nsrSelectMode === 1");
      } else {
        // console.log("selectedNSRFeatures");
        // console.log(selectedNSRFeatures);
        // console.log("boxFeatures");
        // console.log(boxFeatures);
        for (let i = 0; i < selectedNSRFeatures.length; i++) {
          var curSelectedFeat = selectedNSRFeatures[i];
          for (let j = 0; j < boxFeatures.length; j++) {
            var featToCheck = boxFeatures[j];
            if (curSelectedFeat.get("id") == featToCheck.get("id")) {
              console.log("nsrname", null);
              featToCheck.set("nsrname", null);
              curSelectedFeat.set("nsrname", null);
              featToCheck.setStyle(selectionStyleFunction);
              curSelectedFeat.setStyle(selectionStyleFunction);
              deselectedNSRFeatures.push(featToCheck);
              deselectedNSRFeatures.push(curSelectedFeat);
              deselectedIds.push(featToCheck.get("id"));
              selectedNSRFeatures.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }
    }

    selectedNSRFeatures = selectedNSRFeatures.filter((f) => !deselectedIds.includes(f.get("id")));
    deselectedNSRFeatures = deselectedNSRFeatures.filter((f) => !selectedIds.includes(f.get("id")));
    console.log("selectedNSRFeatures", selectedNSRFeatures);
    console.log("deselectedNSRFeatures", deselectedNSRFeatures);

    //update the nsr table
    //reset table
    // while (nsrTableNode.hasChildNodes()) {
    //   nsrTableNode.removeChild(nsrTableNode.lastChild);
    // }

    let nsrNames = selectedNSRFeatures.map((f) => f.get("nsrname"));

    for (let m = 0; m < selectedNSRFeatures.length; m++) {
      var currentFeat = selectedNSRFeatures[m];
      var currentFeatId = currentFeat.get("id");
      var currentNSRName = currentFeat.get("nsrname");
      var currentBuildingName = currentFeat.get("BldName_E");
      var currentNoiseCriteria = currentFeat.get("noisecriteria");
      var currentOtherNoiseCriteria = currentFeat.get("othernoisecriteria");
      var otherNoiseCriteriaArr = [];
      if (currentOtherNoiseCriteria) {
        otherNoiseCriteriaArr = currentOtherNoiseCriteria.split("#");
      }
      if (!currentNSRName || nsrNames.filter((n) => n === currentNSRName).length > 1) {
        let index = 0;
        while (nsrNames.includes(`N${index + 1}`)) {
          index++;
        }
        nsrNames.push(`N${index + 1}`);
        console.log("nsrname", `N${index + 1}`);
        currentFeat.set("nsrname", `N${index + 1}`);
      }
      currentFeat.setStyle(selectednsrPointStyleFunction);
    }
    if (update) {
      update();
    }
  });
}

olMap.changeNSRPointColorBackAfterSelection = function (selectedNSRData, save, callback, backstate) {
  console.log("inside changeNSRPointColorBackAfterSelection");

  if (backstate) {
    selectedNSRPointIds = oldSelectedNSRPointIds;
    selectedNSRPoints = selectedNSRPoints.filter((p) => oldSelectedNSRPointIds.includes(p.id));
  }

  if (nsrSelect) {
    map.removeInteraction(nsrSelect);
  }
  if (dragBox) {
    map.removeInteraction(dragBox);
  }

  let calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");
  // get all nsr point features
  let allCalculatedNSRPointFeats = calculatedNSRPointsLayer.getSource().getFeatures();

  // check whether using mitigated cnl or unmitigated cnl
  let isMitgated = false;
  for (let i = 0; i < allCalculatedNSRPointFeats.length; i++) {
    let curFeat = allCalculatedNSRPointFeats[i];
    if (curFeat.get("totalcnl") !== curFeat.get("totalcnlmit") && curFeat.get("totalcnlmit") !== 0) {
      isMitgated = true;
    }
  }
  //get sorted array of colored-calculated-NSR Points
  let sortedPointArray = [];
  for (let i = 0; i < allCalculatedNSRPointFeats.length; i++) {
    let pointFeatToProcess = allCalculatedNSRPointFeats[i];
    let pointFeatToProcessNoiseCrit = pointFeatToProcess.get("noisecriteria");
    let pointFeatToProcessValToCompare = 0;
    if (isMitgated) {
      pointFeatToProcessValToCompare = pointFeatToProcess.get("totalcnlmit");
    } else {
      pointFeatToProcessValToCompare = pointFeatToProcess.get("totalcnl");
    }
    pointFeatToProcessValToCompare = pointFeatToProcessValToCompare - pointFeatToProcessNoiseCrit;

    let alreadyInserted = false;
    for (let j = 0; j < sortedPointArray.length; j++) {
      let curCheckFeat = sortedPointArray[j];
      let curCheckFeatNoiseCrit = curCheckFeat.get("noisecriteria");
      let curCheckFeatValToCompare = 0;
      if (isMitgated) {
        curCheckFeatValToCompare = curCheckFeat.get("totalcnlmit");
      } else {
        curCheckFeatValToCompare = curCheckFeat.get("totalcnl");
      }
      curCheckFeatValToCompare = curCheckFeatValToCompare - curCheckFeatNoiseCrit;

      if (pointFeatToProcessValToCompare >= curCheckFeatValToCompare) {
        sortedPointArray.splice(j, 0, pointFeatToProcess);
        alreadyInserted = true;
        break;
      }
    }
    if (sortedPointArray.length === 0 || !alreadyInserted) {
      sortedPointArray.push(pointFeatToProcess);
    }
  }
  // color the points
  for (let i = 0; i < sortedPointArray.length; i++) {
    let nsrPointFeat = sortedPointArray[i];
    let currentNoiseCriteria = nsrPointFeat.get("noisecriteria");
    let maxMitigatedCNL = nsrPointFeat.get("totalcnlmit");
    let maxOriginalCNL = nsrPointFeat.get("totalcnl");
    let currentPointId = nsrPointFeat.get("id");

    if (isMitgated) {
      if (Math.round(currentNoiseCriteria) < Math.round(maxMitigatedCNL)) {
        // if the result is red
        nsrPointFeat.setStyle(redNSRPointMitStyleFunctionWithNSRName);
      } else {
        nsrPointFeat.setStyle(greenNSRPointStyleFunctionWithNSRName);
      }
    } else {
      if (Math.round(currentNoiseCriteria) < Math.round(maxOriginalCNL)) {
        // if the result is red
        nsrPointFeat.setStyle(redNSRPointUnmitStyleFunctionWithNSRName);
      } else {
        nsrPointFeat.setStyle(greenNSRPointStyleFunctionWithNSRName);
      }
    }
  }

  //obtaining the nsr points parameters for db storing
  let nsrPointIds = [];
  let nsrPointBuildingIds = [];
  console.log("selectedNSRFeatures", selectedNSRFeatures);
  console.log("deselectedNSRFeatures", deselectedNSRFeatures);
  for (let i = 0; i < selectedNSRFeatures.length; i++) {
    let curSelectedFeat = selectedNSRFeatures[i];
    let curId = curSelectedFeat.get("id");
    let curBuildingId = curSelectedFeat.get("buildingid");
    nsrPointIds.push(curId);
    nsrPointBuildingIds.push(curBuildingId);

    let curNSRData = selectedNSRData.filter((d) => d.id == curId);

    if (curNSRData.length == 0) continue;

    curNSRData = curNSRData[0];

    // set nsr names
    console.log("changeNSRPointColorBackAfterSelection curSelectedFeat.get('id')", curId);
    console.log("changeNSRPointColorBackAfterSelection curNSRData.nsrName", curNSRData.nsrName);
    console.log("changeNSRPointColorBackAfterSelection curNSRData.nsrname", curNSRData.nsrname);
    console.log("changeNSRPointColorBackAfterSelection curSelectedFeat.get('nsrname')", curSelectedFeat.get("nsrname"));
    const nsrNameToSave = curNSRData.nsrName || curNSRData.nsrname || curSelectedFeat.get("nsrname") || "";
    console.log("changeNSRPointColorBackAfterSelection nsrNameToSave", nsrNameToSave);
    curSelectedFeat.set("nsrname", nsrNameToSave);
    curSelectedFeat.set("noisecriteria", curNSRData.noisecriteria);

    // set the building names
    curSelectedFeat.set("BldName_E", curNSRData.buildingName);
    let otherCritArr = curNSRData.contributions;
    let combinedStringOtherCrit = otherCritArr.map((c) => c.contributionText).join("#");
    //set the other noise criteria
    curSelectedFeat.set("othernoisecriteria", combinedStringOtherCrit);

    // curSelectedFeat.set("othernoisecriteria", combinedStringOtherCrit);
    // } else {
    //   curSelectedFeat.set("othernoisecriteria", "");
    // }

    //calculate neighbor site contribution
    let detailInJSONString = curSelectedFeat.get("calcvalues");
    let calcvalues = JSON.parse(detailInJSONString);
    let totalcnlwithneighbor = curSelectedFeat.get("totalcnl");
    if (combinedStringOtherCrit != "") {
      calcvalues.forEach((c) => {
        c.startDate = getStartDateFromZoneTask(c.zonetask);
        c.endDate = getEndDateFromZoneTask(c.zonetask);
        c.totalCNLInNeighbor = c.totalCNL;
      });
      for (let j = 0; j < otherCritArr.length; j++) {
        let start = Date.parse(otherCritArr[j].startDate);
        let end = Date.parse(otherCritArr[j].endDate);
        let contribution = parseFloat(otherCritArr[j].contribution);
        calcvalues.forEach((c) => {
          if (isTwoDatesOverlaped(start, end, c.startDate, c.endDate)) {
            c.totalCNLInNeighbor = getCombinedNoiseLevel([c.totalCNLInNeighbor, contribution]);
            totalcnlwithneighbor = c.totalCNLInNeighbor > totalcnlwithneighbor ? c.totalCNLInNeighbor : totalcnlwithneighbor;
          }
        });
      }
    }
    curSelectedFeat.set("totalcnlwithneighbor", totalcnlwithneighbor);
  }
  if (!backstate) {
    selectedNSRPointIds = nsrPointIds; // store it to global var;
    selectedNSRPoints = selectedNSRPoints.filter((p) => nsrPointIds.includes(p.id));
  }
  for (let i = 0; i < sortedPointArray.length; i++) {
    let nsrPointFeat = sortedPointArray[i];
    let currentPointId = nsrPointFeat.get("id");

    if (selectedNSRPoints.length > 0) {
      let isThisNSRSelected = false;
      let isAllEmpty = true;
      for (let j = 0; j < selectedNSRPoints.length; j++) {
        let selNSRId = selectedNSRPoints[j].id;
        if (selNSRId !== "") {
          isAllEmpty = false;
          // continue;
        }
        if (parseInt(currentPointId) === parseInt(selNSRId)) {
          isThisNSRSelected = true;
          break;
        }
      }
      if (!isThisNSRSelected && !isAllEmpty) {
        nsrPointFeat.setStyle(unselectedNSRPointStyle);
      }
    }
  }
  let selNSRVal = nsrPointIds.join() + ";" + nsrPointBuildingIds.join();
  if (selNSRVal === ";") {
    selNSRVal = "";
  }

  if (save) {
    updateSelectedNSR(currentProjectID, selNSRVal, function () {
      console.log("updateSelectedNSRNames");
      updateSelectedNSRNames(function () {
        updateDeselectedNSRNames(function () {
          console.log("calculateNoise1");
          calculateNoise1(currentProjectID, callback);
        });
      });
    });
  }

  //set the unselected style
  // console.log("sortedPointArray");
  // console.log(sortedPointArray);
  if (callback && !save) {
    callback();
  }
};

olMap.clearNSRPointColorBackSelection = function (updateData) {
  selectedNSRFeatures.forEach((f) => {
    console.log("nsrname", null);
    f.set("nsrname", null);
    deselectedNSRFeatures.push(f);
    f.setStyle(selectionStyleFunction);
  });
  selectedNSRFeatures = [];
  updateData();
};

olMap.changeNSRPointSelectionModeToSelect = function () {
  nsrSelectMode = 1;
};
olMap.changeNSRPointSelectionModeToDeselect = function () {
  nsrSelectMode = 0;
};

function updateSelectedNSR(projectId, value, callback) {
  var bodyObj = new ProjectSelectedNSR(projectId, value);
  var postURL = SERVER_URL2 + "Project/selectednsr";
  //var postURL = 'https://localhost:44384/Project/selectednsr';
  fetch(postURL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    //mode: 'no-cors',
    body: JSON.stringify(bodyObj),
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      console.log("Finish updateSelectedNSR into: " + value.toString());
      if (callback) {
        callback();
      }
    });
}

function updateDeselectedNSRNames(callback) {
  console.log("inside updateDeselectedNSRNames");
  console.log("deselectedNSRFeatures");
  console.log(deselectedNSRFeatures);

  modifiedFeatureList = [];
  for (let i = 0; i < deselectedNSRFeatures.length; i++) {
    var aFeat = deselectedNSRFeatures[i];
    //var theNSRName = aFeat.get('nsrname');
    modifiedFeatureList.push(aFeat);
  }
  if (modifiedFeatureList.length === 0) {
    callback();
  }

  var task = "update";
  var geoserverWorkspace = "http://www.abc.com/webcnmpws";
  var editLayer = "projectNSRPoints";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", callback);
}

function updateSelectedNSRNames(callback) {
  console.log("inside updateSelectedNSRNames");
  console.log("selectedNSRFeatures");
  console.log(selectedNSRFeatures);

  modifiedFeatureList = [];
  for (let i = 0; i < selectedNSRFeatures.length; i++) {
    var aFeat = selectedNSRFeatures[i];
    //var theNSRName = aFeat.get('nsrname');
    modifiedFeatureList.push(aFeat);
  }
  if (modifiedFeatureList.length === 0) {
    callback();
  }

  var task = "update";
  var geoserverWorkspace = "http://www.abc.com/webcnmpws";
  var editLayer = "projectNSRPoints";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", callback);
}

function getHKDateStringFromZulu(zuluDate) {
  var aDate = new Date(zuluDate);
  //aDate.setDate(aDate.getDate() + 1);
  return getSimpleDate(aDate);
}

function getHKDateFromZulu(zuluDate) {
  var aDate = new Date(zuluDate);
  aDate.setDate(aDate.getDate() + 1);
  return aDate;
}

function getSimpleDate(aDate) {
  let month = (aDate.getMonth() + 1).toString().padStart(2, "0");
  let day = aDate.getDate().toString().padStart(2, "0");
  let year = aDate.getFullYear();
  return [year, month, day].join("-");
}

function openZoneCentroidPoints(projectId) {
  //console.log("Enter openZoneCentroidPoints()")

  var zoneFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["zones"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectId),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const zonefeatures = new GeoJSON().readFeatures(json);
      if (zonefeatures.length > 0) {
        for (let i = 0; i < zonefeatures.length; i++) {
          zoneFeat = zonefeatures[i];
          var curIndex = zoneFeat.get("id");
          var curName = zoneFeat.get("name");

          //var centroidFeat = getCenterOfMass(zoneFeat);
          var centroidFeat = getSavedCenterPointByZoneID(curIndex);
          if (centroidFeat == null) {
            centroidFeat = getCenterOfMass(zoneFeat);
          }
          var tempCentroidPoint = new Point(centroidFeat.getGeometry().getCoordinates());
          var tempCentroidPointFeat = new Feature({
            geometry: tempCentroidPoint,
          });
          tempCentroidPointFeat.set("order", curName.toString());
          zoneLabelCentroidSource.addFeature(tempCentroidPointFeat);
        }
      }
    });
}

function changeActionMode(index) {
  isAddNSRBuildingMode = false;
  isRemoveNSRBuildingMode = false;
  isChangeNoiseLevelNSRBuildingMode = false;
  isChangeNoiseNSRBuildingPointMode = false;
  isAddNSRPointsMode = false;
  isRemoveNSRPointsMode = false;
  isChangeCentralPointMode = false;

  switch (index) {
    case 1:
      isAddNSRBuildingMode = true;
      break;
    case 2:
      isRemoveNSRBuildingMode = true;
      break;
    case 3:
      isChangeNoiseLevelNSRBuildingMode = true;
      break;
    case 4:
      isChangeNoiseNSRBuildingPointMode = true;
      break;
    case 5:
      isAddNSRPointsMode = true;
      break;
    case 6:
      isRemoveNSRPointsMode = true;
      break;
    case 7:
      isChangeCentralPointMode = true;
      break;
    default:
  }
}

function saveNotionalPoints(niotionalFeatures) {
  //### for testing
  console.log("enter saveNotionalPoints");
  console.log("niotionalFeatures");
  console.log(niotionalFeatures);
  modifiedFeatureList = [];

  var notPointFeat;
  for (let i = 0; i < niotionalFeatures.length; i++) {
    notPointFeat = niotionalFeatures[i];
    modifiedFeatureList.push(notPointFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "notionalPoints";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", null);
}

function newProjectSaveUnregSites(projectId) {
  console.log("inside newProjectSaveUnregSites");
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "UnregSites/projectid/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      newProjectSaveUnregSites2(projectId);
    });
}
function newProjectSaveSite(projectId, callback) {
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "sites/projectid/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      header = new Headers();
      header.append("Access-Control-Allow-Origin", "*");
      // header.append('Access-Control-Request-Headers', 'Content-Type');
      header.append("Access-Control-Request-Method", "DELETE");
      var deleteURL = SERVER_URL2 + "sites2/projectid/" + projectId.toString();
      fetch(deleteURL, {
        method: "DELETE",
        //mode: 'no-cors',
        headers: header,
      })
        .then(function (response) {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function (json) {
          newProjectSaveSite2(projectId, callback);
        });
    });
}

function newProjectSaveUnregSites2(projectId) {
  console.log("inside newProjectSaveUnregSites2");
  modifiedFeatureList = [];
  // overlay layer for site is: vector6 = "sitelayer"
  var index = 0;
  var siteFeat;
  for (let i = 0; i < unregisterSitesSource.getFeatures().length; i++) {
    siteFeat = unregisterSitesSource.getFeatures()[i];
    siteFeat.set("projectid", projectId);
    modifiedFeatureList.push(siteFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "unregsites";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", newProjectSaveUnregSites3);

  //vecSource.clear();
  //vecSource6.clear();
}

function newProjectSaveSite2(projectId, callback) {
  modifiedFeatureList = [];
  globalCurrentSiteFeature = null;
  console.log("newProjectSaveSite2 siteSource.getFeatures()", siteSource.getFeatures());
  var index = 0;
  var siteFeat;
  for (let i = 0; i < siteSource.getFeatures().length; i++) {
    siteFeat = siteSource.getFeatures()[i];
    console.log("siteFeat.getGeometry().getType()", siteFeat.getGeometry().getType());
    siteFeat.set("projectid", projectId);
    globalCurrentSiteFeature = siteFeat;
    modifiedFeatureList.push(siteFeat);
    console.log(siteFeat);
  }

  // remove project nsr points if no site
  if (!siteSource.getFeatures().length) {
    deleteProjectNSRPoints(projectId);
    projBuildingPointsWFSSource.refresh();
  }

  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "";
  if (issitemultipolygon) {
    editLayer = "sites2";
  } else {
    editLayer = "sites";
  }
  saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
    newProjectSaveSite3(callback);
  });

  //vecSource.clear();
  //vecSource6.clear();
}

function newProjectSaveUnregSites3() {
  console.log("inside newProjectSaveUnregSites3");
  var siteWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Aunregsites&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + siteWFSURL + "&srsname=EPSG:3857");
  siteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return siteWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("unregSiteWFSLayer");
  thisLayer.setSource(siteWFSSource);
  thisLayer.setVisible(true);

  newProjectSaveUnregBuffer(currentProjectID);
}

function newProjectSaveSite3(callback) {
  //console.log("currentProjectID", currentProjectID.toString());
  var siteWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + siteWFSURL + "&srsname=EPSG:3857");
  siteWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return siteWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("siteWFSLayer");
  thisLayer.setSource(siteWFSSource);
  thisLayer.setVisible(true);
  console.log("siteWFSSource.getFeatures()");
  console.log(siteWFSSource.getFeatures());
  var site2WFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Asites2&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + site2WFSURL + "&srsname=EPSG:3857");
  site2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return site2WFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("site2WFSLayer");
  thisLayer.setSource(site2WFSSource);
  thisLayer.setVisible(true);
  console.log("site2WFSSource.getFeatures()");
  console.log(site2WFSSource.getFeatures());

  newProjectSaveBuffer(currentProjectID, callback);
}

function newProjectSaveUnregBuffer(projectId) {
  console.log("inside newProjectSaveUnregBuffer");
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "UnregSitesBuffers/projectId/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      newProjectSaveUnregBuffer2(projectId);
    });
}

function newProjectSaveBuffer(projectId, callback) {
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "buffers/projectId/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      header = new Headers();
      header.append("Access-Control-Allow-Origin", "*");
      // header.append('Access-Control-Request-Headers', 'Content-Type');
      header.append("Access-Control-Request-Method", "DELETE");
      var deleteURL = SERVER_URL2 + "buffers2/projectId/" + projectId.toString();
      fetch(deleteURL, {
        method: "DELETE",
        //mode: 'no-cors',
        headers: header,
      })
        .then(function (response) {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function (json) {
          newProjectSaveBuffer2(projectId, callback);
        });
    });
}

function newProjectSaveUnregBuffer2(projectId) {
  console.log("inside newProjectSaveUnregBuffer2");
  modifiedFeatureList = [];
  // overlay layer for buffer is: vector4 = "sitebufferLayer"
  var index = 0;
  var bufFeat;
  unregisteredBufferArray = []; // global par is for nsr noise criteria reduction process.
  for (let i = 0; i < unregisterSiteBufferSource.getFeatures().length; i++) {
    bufFeat = unregisterSiteBufferSource.getFeatures()[i];
    bufFeat.set("projectid", projectId);
    modifiedFeatureList.push(bufFeat);
    unregisteredBufferArray.push(bufFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "unregbuffers";

  saveEdits(task, geoserverWorkspace, editLayer, "geom", newProjectSaveUnregBuffer3);

  unregisterSitesSource.clear();
  unregisterSiteBufferSource.clear();
}

function newProjectSaveBuffer2(projectId, callback) {
  modifiedFeatureList = [];
  // overlay layer for buffer is: vector4 = "sitebufferLayer"
  var index = 0;
  var bufFeat;
  for (let i = 0; i < siteBufferSource.getFeatures().length; i++) {
    bufFeat = siteBufferSource.getFeatures()[i];
    bufFeat.set("projectid", projectId);
    modifiedFeatureList.push(bufFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "";
  if (issitemultipolygon) {
    editLayer = "buffers2";
  } else {
    editLayer = "buffers";
  }
  //var editLayer = "buffers";
  // var editLayer = "buffers2";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
    newProjectSaveBuffer3(callback);
  });

  //vecSource.clear();
  // vecSource4.clear();
}

function newProjectSaveUnregBuffer3() {
  console.log("inside newProjectSaveUnregBuffer3");
  var bufferWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Aunregbuffers&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + bufferWFSURL + "&srsname=EPSG:3857");
  unregBufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return bufferWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("unregBufferWFSLayer");
  thisLayer.setSource(unregBufferWFSSource);
  thisLayer.setVisible(true);

  checkNSRBuildingIntersectUnregBuffer(currentProjectID, unregisteredBufferArray);
}

function newProjectSaveBuffer3(callback) {
  //console.log("currentProjectID", currentProjectID.toString());
  var bufferWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + bufferWFSURL + "&srsname=EPSG:3857");
  bufferWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return bufferWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("bufferWFSLayer");
  thisLayer.setSource(bufferWFSSource);
  if (saveProjectFinish) {
    thisLayer.setVisible(true);
  }
  var buffer2WFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Abuffers2&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + buffer2WFSURL + "&srsname=EPSG:3857");
  buffer2WFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return buffer2WFSURL + "&srsname=EPSG:3857";
    },
  });
  thisLayer = getLayerByTitle("buffer2WFSLayer");
  thisLayer.setSource(buffer2WFSSource);
  if (saveProjectFinish) {
    thisLayer.setVisible(true);
  }

  newProjectSaveZones(currentProjectID, callback);
}

function checkNSRBuildingIntersectUnregBuffer(projectId, bufferFeatArray) {
  console.log("inside checkNSRBuildingIntersectUnregBuffer");

  //for each project nsr buildings, get the closest point to the site
  var buildingFeat;
  var bufferFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectNSRBuilding"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectId),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const defaultBuildingfeatures = new GeoJSON().readFeatures(json);
      if (defaultBuildingfeatures.length > 0) {
        modifiedFeatureList = [];
        projectBuildingFeatArrayAfterReduced = [];
        for (let i = 0; i < defaultBuildingfeatures.length; i++) {
          buildingFeat = defaultBuildingfeatures[i];
          var bldNoiseCrit = buildingFeat.get("noisecriteria");

          // cek building intersect unreg buffer
          for (let j = 0; j < bufferFeatArray.length; j++) {
            bufferFeat = bufferFeatArray[j];
            if (isIntersect(buildingFeat, bufferFeat)) {
              var affectDeg = bufferFeat.get("affectdegree");
              var reductionVal = 0;
              if (affectDeg === "Slightly Affected") {
                reductionVal = 3;
              } else if (affectDeg === "Affected") {
                reductionVal = 7;
              }

              bldNoiseCrit = bldNoiseCrit - reductionVal;
            }
          }

          buildingFeat.set("reducenoisecriteria", bldNoiseCrit);

          modifiedFeatureList.push(buildingFeat);
          projectBuildingFeatArrayAfterReduced.push(buildingFeat);

          //vecTestSource.addFeature(pointFeat);
          //vecSource8.addFeature(pointFeat);
        }

        var task = "update";
        var geoserverWorkspace = "http://www.abc.com/webcnmpws";
        var editLayer = "projectNSRBuilding";
        saveEdits(task, geoserverWorkspace, editLayer, "geom", updateNSRPointsIntersectUnregBuffer);
      }
    });
}
function updateNSRPointsIntersectUnregBuffer() {
  console.log("inside updateNSRPointsIntersectUnregBuffer");

  //for each project nsr buildings, get the closest point to the site
  var pointFeat;
  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectNSRPoints"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", currentProjectID),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const nsrPointsfeatures = new GeoJSON().readFeatures(json);
      if (nsrPointsfeatures.length > 0) {
        // var aProjectBuildingLayer = getLayerByTitle("projectBuildingLayer");
        // var aProjectBuildingFeatures = aProjectBuildingLayer.getSource().getFeatures();

        modifiedFeatureList = [];
        for (let i = 0; i < nsrPointsfeatures.length; i++) {
          pointFeat = nsrPointsfeatures[i];
          var pointBuildingId = pointFeat.get("buildingid");

          for (let j = 0; j < projectBuildingFeatArrayAfterReduced.length; j++) {
            var aProjectBuildingFeature = projectBuildingFeatArrayAfterReduced[j];
            var reducedNoiseCrit = aProjectBuildingFeature.get("reducenoisecriteria");
            if (pointBuildingId === aProjectBuildingFeature.get("buildingid")) {
              pointFeat.set("noisecriteria", reducedNoiseCrit);
              break;
            }
          }

          modifiedFeatureList.push(pointFeat);

          //vecTestSource.addFeature(pointFeat);
          //vecSource8.addFeature(pointFeat);
        }

        var task = "update";
        var geoserverWorkspace = "http://www.abc.com/webcnmpws";
        var editLayer = "projectNSRPoints";
        saveEdits(task, geoserverWorkspace, editLayer, "geom", null);

        alert("Finish");
      }
    });
}

function newProjectSaveZones(projectId, callback) {
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "zones/projectId/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      newProjectSaveZones2(projectId, callback);
    });
}
function newProjectSaveZones2(projectId, callback) {
  modifiedFeatureList = [];
  // overlay layer for zone is: vector = "zoneLayer"
  var index = 0;
  var zoneFeat;
  console.log("getting zones from vecSource");
  console.log(zoneSource.getFeatures());
  for (let i = 0; i < zoneSource.getFeatures().length; i++) {
    zoneFeat = zoneSource.getFeatures()[i];
    zoneFeat.set("projectid", projectId);
    if (zoneFeat.get("id") === null) {
      zoneFeat.set("id", index + 1);
    }
    index = zoneFeat.get("id");
    console.log("ZoneIndex:", index);
    var zoneName = getZoneNameByIndex(index);
    zoneFeat.set("name", zoneName);
    var zoneType = getZoneCalcTypeByIndex(index);
    zoneFeat.set("calculationtype", zoneType);
    modifiedFeatureList.push(zoneFeat);
    console.log("zoneFeat:");
    console.log(zoneFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "zones";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
    newProjectSaveZones3(callback);
  });

  // //
  // // // add site to the modifiedfeaturelist
  // // modifiedFeatureList.push(e.feature);
  // // var task = "insert";
  // // var geoserverWorkspace = "webcnmpws";
  // // var editLayer = "sites";
  // // console.log("about to save edits");
  // // saveEdits(task, geoserverWorkspace, editLayer);
  // if(saveProjectFinish) { // don't clear yet, zone is still used below on getting centroid. moved this code to centroid.
  //     vecSource.clear();
  // }
}
function newProjectSaveZones3(callback) {
  //console.log("currentProjectID", currentProjectID.toString());
  var zoneWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3Azones&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + zoneWFSURL + "&srsname=EPSG:3857");
  zoneWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return zoneWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("zoneWFSLayer");
  thisLayer.setSource(zoneWFSSource);
  if (saveProjectFinish) {
    thisLayer.setVisible(true);
  }

  //getDefBuildingsIntersectBuffer(currentProjectID);
  newProjectSaveCenterPoint(currentProjectID, callback);
}

function newProjectSaveCenterPoint(projectId, callback) {
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "geomcenter/projectid/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      newProjectSaveCenterPoint2(projectId, callback);
    });
}

function newProjectSaveCenterPoint2(projectId, callback) {
  modifiedFeatureList = [];
  // overlay layer for zone is: vector = "zoneLayer"
  var index = 0;
  var zoneFeat;
  var zoneCentroidFeat;
  console.log("getting zones from vecSource");
  console.log(zoneSource.getFeatures());
  for (let i = 0; i < zoneSource.getFeatures().length; i++) {
    zoneFeat = zoneSource.getFeatures()[i];
    zoneCentroidFeat = getCenterOfMass(zoneFeat);
    zoneCentroidFeat.set("projectid", projectId);
    var index = zoneFeat.get("id");
    console.log("ZoneIndex:", index);
    zoneCentroidFeat.set("zoneid", index?.toString());
    var zoneName = getZoneNameByIndex(index);
    // var startDate = getZoneStartDateByIndex(index);
    // var endDate = getZoneEndDateByIndex(index);
    zoneCentroidFeat.set("zonename", zoneName);
    var zoneType = getZoneCalcTypeByIndex(index);
    zoneCentroidFeat.set("calculationtype", zoneType);
    // zoneFeat.set('startdate', startDate);
    // zoneFeat.set('enddate', endDate);
    // zoneFeat.set('index', index);
    // zoneFeat.unset('order');
    modifiedFeatureList.push(zoneCentroidFeat);
  }
  var task = "insert";
  var geoserverWorkspace = "webcnmpws";
  var editLayer = "geomCenter";
  saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
    newProjectSaveCenterPoint3(callback);
  });
}

function newProjectSaveCenterPoint3(callback) {
  //console.log("currentProjectID", currentProjectID.toString());
  var centerWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AgeomCenter&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  console.log("Trying to load: " + centerWFSURL + "&srsname=EPSG:3857");
  centerPtWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return centerWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("centerPtWFSLayer");
  thisLayer.setSource(centerPtWFSSource);
  if (saveProjectFinish) {
    zoneSource.clear();
    thisLayer.setVisible(true);
  }

  isAfterCalculation = false;
  updateIsCalculated(currentProjectID, 0, callback);
  isCalculatedGlobal2 = 0; //added by Marvin Alex

  getDefBuildingsIntersectBuffer(currentProjectID);
  //newProjectSaveCenterPoint(currentProjectID);
}

function removeLayerFromMap(layertitle) {
  map.getLayers().forEach((layer) => {
    if (layer && layer.get("title") === layertitle) {
      map.removeLayer(layer);
    }
  });
}

function saveEdits(taskType, geoserverWorkspace, editLayer, geometryFieldName, followUpFunction) {
  modifiedFeatureCloneList = [];

  for (var i = 0; i < modifiedFeatureList.length; i++) {
    let feature = modifiedFeatureList[i];
    // console.log("feature chec getProperties()");
    // console.log(feature);
    // if (Array.isArray(feature))
    // {
    //     feature = feature[0];
    // }
    let featProp = feature.getProperties();
    delete featProp.boundedBy;

    // try {
    let clone = feature.clone();
    clone.setId(feature.getId());
    modifiedFeatureCloneList.push(feature);
    // } catch {
    //   modifiedFeatureCloneList.push(feature);
    // }
  }
  console.log("modifiedFeatureCloneList", modifiedFeatureCloneList);

  if (taskType == "update") {
    transactionWFS("update_batch", modifiedFeatureCloneList, geoserverWorkspace, editLayer, geometryFieldName, followUpFunction);
  }
  if (taskType == "insert") {
    transactionWFS("insert_batch", modifiedFeatureCloneList, geoserverWorkspace, editLayer, geometryFieldName, followUpFunction);
  }
  if (taskType == "delete") {
    transactionWFS("delete_batch", modifiedFeatureCloneList, geoserverWorkspace, editLayer, geometryFieldName, followUpFunction);
  }
}

function chunkArray(array, chunkSize) {
  var chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

function getTransactionNode(formatWFS, mode, features, formatGML) {
  switch (mode) {
    case "insert":
      return formatWFS.writeTransaction([features], null, null, formatGML);
    case "insert_batch":
      return formatWFS.writeTransaction(features, null, null, formatGML);
    case "update":
      return formatWFS.writeTransaction(null, [features], null, formatGML);
    case "update_batch":
      return formatWFS.writeTransaction(null, features, null, formatGML);
    case "delete":
      return formatWFS.writeTransaction(null, null, [features], formatGML);
    case "delete_batch":
      return formatWFS.writeTransaction(null, null, features, formatGML);
    default:
      return null;
  }
}

function getTransactionPayload(mode, features, geoserverWorkspace, editLayer, geometryFieldName) {
  var formatWFS = new WFS();
  var formatGML = new GML({
    featureNS: geoserverWorkspace,
    featureType: editLayer,
    //version: '1.1.0',
    request: "GetFeature",
    srsName: "EPSG:3857",
  });
  var node = getTransactionNode(formatWFS, mode, features, formatGML);
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(node);

  payload = payload.split("geometry>").join(geometryFieldName + ">");
  if (mode === "update_batch") {
    payload = payload.split("geometry").join(geometryFieldName);
  }

  return payload;
}

function sendWFSPayload(payload) {
  return new Promise((resolve, reject) => {
    let request = new XMLHttpRequest();
    request.open("POST", SERVER_URL + "/gsProxy/wfs");
    request.onreadystatechange = function () {
      if (request.readyState == 4) {
        if (request.status >= 200 && request.status < 300) {
          resolve(request.responseXML);
        } else {
          reject(new Error("WFS request failed with status " + request.status));
        }
      }
    };
    request.onerror = function () {
      reject(new Error("WFS request error"));
    };

    request.setRequestHeader("Content-Type", "text/xml");
    request.send(payload);
  });
}

function transactionWFS(mode, features, geoserverWorkspace, editLayer, geometryFieldName, followUpFunction) {
  var isBatchMode = mode.endsWith("_batch");
  if (isBatchMode && Array.isArray(features) && features.length > 10000) {
    // Split into chunks of 10000 features
    var featureChunks = chunkArray(features, 10000);
    console.log("Total features: " + features.length + ", chunks of 10000: " + featureChunks.length);

    // Send chunks in parallel batches of 10
    var sendChunkBatch = function (chunkBatchIndex) {
      var startIdx = chunkBatchIndex * 10;
      var endIdx = Math.min(startIdx + 10, featureChunks.length);

      if (startIdx >= featureChunks.length) {
        console.log("All chunk batches sent successfully");
        if (followUpFunction) {
          followUpFunction();
        }
        return;
      }

      var batchPromises = [];
      for (let i = startIdx; i < endIdx; i++) {
        var payload = getTransactionPayload(mode, featureChunks[i], geoserverWorkspace, editLayer, geometryFieldName);
        batchPromises.push(sendWFSPayload(payload));
      }

      Promise.all(batchPromises)
        .then(function () {
          console.log("Chunk batch " + (chunkBatchIndex + 1) + " sent successfully");
          sendChunkBatch(chunkBatchIndex + 1);
        })
        .catch(function (error) {
          console.error("Error sending chunk batch " + (chunkBatchIndex + 1) + ":", error);
          sendChunkBatch(chunkBatchIndex + 1);
        });
    };

    sendChunkBatch(0);
    return;
  }

  var payload = getTransactionPayload(mode, features, geoserverWorkspace, editLayer, geometryFieldName);
  sendWFSPayload(payload)
    .then(function () {
      if (followUpFunction) {
        followUpFunction();
      }
    })
    .catch(function (error) {
      console.error("Error sending request:", error);
      if (followUpFunction) {
        followUpFunction();
      }
    });
}

function deleteEquipmentPointByID(theID) {
  console.log("trying to delete id:", theID);
  var searchedFeat = equipmentManualLocationSource.getFeatureById(theID);
  console.log(searchedFeat);
  equipmentManualLocationSource.removeFeature(searchedFeat);
}

function splitByLine(olPolygonFeature, olLineStringFeature) {
  const parser = new OL3Parser();
  parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);

  // change to jsts features
  let jstsPolygon = parser.read(olPolygonFeature.getGeometry());
  let jstsPoline = parser.read(olLineStringFeature.getGeometry());

  //Perform union of Polygon and Line and use Polygonizer to split the polygon by line
  let union = Union.union(jstsPolygon.getExteriorRing(), jstsPoline);
  let polygonizer = new Polygonizer();
  polygonizer.add(union);

  //Get splitted polygons
  let polygons = polygonizer.getPolygons();
  return polygons;
}

function isIntersect(olFeature, olFeature2) {
  if (!olFeature || !olFeature2) return false;
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var featGeoJSON2 = geoJSON.writeFeatureObject(olFeature2);
  var featTurfGeom2 = turf.getGeom(featGeoJSON2);
  return turf.booleanIntersects(featTurfGeom1, featTurfGeom2);
}
function isContain(olFeature, olFeature2) {
  if (olFeature || olFeature2) return false;
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var featGeoJSON2 = geoJSON.writeFeatureObject(olFeature2);
  var featTurfGeom2 = turf.getGeom(featGeoJSON2);
  return turf.booleanContains(featTurfGeom1, featTurfGeom2);
}

function isWithin(olFeature, olFeature2) {
  if (olFeature || olFeature2) return false;
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var featGeoJSON2 = geoJSON.writeFeatureObject(olFeature2);
  var featTurfGeom2 = turf.getGeom(featGeoJSON2);
  return turf.booleanWithin(featTurfGeom1, featTurfGeom2);
}

function isPolygonCentroidWithinPolygon(olPolygonFeature, olPolygonFeature2) {
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olPolygonFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var centroid = turf.centerOfMass(featTurfGeom1);
  var featGeoJSON2 = geoJSON.writeFeatureObject(olPolygonFeature2);
  var featTurfGeom2 = turf.getGeom(featGeoJSON2);
  return turf.booleanIntersects(featTurfGeom2, centroid);
}

function getCentroid(olPolygonFeature) {
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olPolygonFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var centroid = turf.centroid(featTurfGeom1);
  return geoJSON.readFeature(centroid);
}

function getCenter(olPolygonFeature) {
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olPolygonFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var centroid = turf.center(featTurfGeom1);
  return geoJSON.readFeature(centroid);
}

function getCenterOfMass(olPolygonFeature) {
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olPolygonFeature);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var centroid = turf.centerOfMass(featTurfGeom1);
  return geoJSON.readFeature(centroid);
}

function getSavedCenterPointByZoneID(zoneId) {
  var aCenterPtLayer = getLayerByTitle("centerPtWFSLayer");
  // var aCenterPtFeatures = aCenterPtLayer.getSource().getFeatures();

  // aCenterPtLayer.getSource().on('change', function(evt) {
  //     console.log("change");
  //     var source = evt.target;
  //     if(source.getState() === 'ready'){
  //         console.log("ready");
  //         var aCenterPtFeatures = aCenterPtLayer.getSource().getFeatures();
  //         for(let i =0; i < aCenterPtFeatures.length; i++){
  //             var aCenterPt = aCenterPtFeatures[i];
  //             var zoneIdStr = aCenterPt.get("zoneid");
  //             if(zoneId.toString() === zoneIdStr) {
  //                 console.log("aCenterPt");
  //                 console.log(aCenterPt);
  //                 return aCenterPt;
  //             }
  //         }
  //         return null;
  //     }
  // });

  var aCenterPtFeatures = aCenterPtLayer.getSource().getFeatures();
  for (let i = 0; i < aCenterPtFeatures.length; i++) {
    var aCenterPt = aCenterPtFeatures[i];
    var zoneIdStr = aCenterPt.get("zoneid");
    if (zoneId.toString() === zoneIdStr) {
      // console.log("aCenterPt");
      // console.log(aCenterPt);
      return aCenterPt;
    }
  }
  return null;
}

function getIntesectedPoint(olLineString1, olLineString2, nsrPointFeat) {
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olLineString1);
  var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var featGeoJSON2 = geoJSON.writeFeatureObject(olLineString2);
  var featTurfGeom2 = turf.getGeom(featGeoJSON2);
  var pointColl = turf.lineIntersect(featTurfGeom1, featTurfGeom2);

  var featGeoJSONNSRPoint = geoJSON.writeFeatureObject(nsrPointFeat);
  var featTurfNSRPoint = turf.getGeom(featGeoJSONNSRPoint);

  if (pointColl.features.length > 0) {
    var dist = 999999999;
    var closestPointToNSR;
    for (let i = 0; i < pointColl.features.length; i++) {
      var curPoint = pointColl.features[i];
      var curPointGeom = turf.getGeom(curPoint);
      var curDistance = turf.distance(featTurfNSRPoint, curPointGeom);
      if (dist > curDistance) {
        dist = curDistance;
        closestPointToNSR = curPoint;
      }
    }
    return geoJSON.readFeature(closestPointToNSR);
  } else {
    return null;
  }
}
function getUnion(olPolygonFeature1, olPolygonFeature2) {
  // console.log("olPolygonFeature1");
  // console.log(olPolygonFeature1);
  // console.log("olPolygonFeature2");
  // console.log(olPolygonFeature2);
  var geoJSON = new GeoJSON();
  var featGeoJSON1 = geoJSON.writeFeatureObject(olPolygonFeature1);
  // var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  var featGeoJSON2 = geoJSON.writeFeatureObject(olPolygonFeature2);
  // var featTurfGeom2 = turf.getGeom(featGeoJSON2);
  // console.log("featGeoJSON1");
  // console.log(featGeoJSON1);
  // console.log("featGeoJSON2");
  // console.log(featGeoJSON2);
  //var union = turf.union(turf.featureCollection([featGeoJSON1, featGeoJSON2]));
  var union = turf.union(featGeoJSON1, featGeoJSON2);
  return geoJSON.readFeature(union);
}

function getPolygonBuffer(olFeature, meterRadius, forceSinglePolygon) {
  // var geoJSON = new GeoJSON();
  // var featGeoJSON1 = geoJSON.writeFeatureObject(olFeature);
  // var featTurfGeom1 = turf.getGeom(featGeoJSON1);
  // var bufferredTurfGeom = turf.buffer(featTurfGeom1, meterRadius, {units: 'meters'});
  // return geoJSON.readFeature(bufferredTurfGeom);

  // create buffer
  const parser = new OL3Parser();
  parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);

  //check if it is multipolygons
  //if(olFeature.getGeometry().getPolygons().length > 1){
  if (issitemultipolygon && forceSinglePolygon === false) {
    console.log("enter the multipolygon");
    console.log(olFeature.getGeometry().getType());
    console.log(olFeature);
    var allCoordArr = [];
    var allFeatArr = [];
    for (let i = 0; i < olFeature.getGeometry().getPolygons().length; i++) {
      var currentGeom = olFeature.getGeometry().getPolygons()[i];
      var jstsGeom = parser.read(currentGeom);
      var buffered = BufferOp.bufferOp(jstsGeom, meterRadius);
      var featGeoJSON2 = parser.write(buffered);
      var aPol = new Feature({
        geometry: new Polygon(featGeoJSON2.getCoordinates()),
      });
      allFeatArr.push(aPol);
      allCoordArr.push(featGeoJSON2.getCoordinates());
    }

    //check for feat intersections. union if intersects.
    var groupIndexArr = getGroupOfIntersectedIndex(allFeatArr);
    var processedCoord = [];
    for (let i = 0; i < groupIndexArr.length; i++) {
      var indexArr = groupIndexArr[i];

      if (indexArr.length > 1) {
        var currentFeat;
        for (let j = 0; j < indexArr.length; j++) {
          var curIndexVal = indexArr[j];
          if (j === 0) {
            currentFeat = allFeatArr[curIndexVal];
          } else {
            currentFeat = getUnion(currentFeat, allFeatArr[curIndexVal]);
          }
        }
        processedCoord.push(currentFeat.getGeometry().getCoordinates());
      } else {
        var indexVal = indexArr[0];
        var currentCoord = allCoordArr[indexVal];
        processedCoord.push(currentCoord);
      }
    }

    if (groupIndexArr.length > 1 || issitemultipolygon) {
      return new Feature({
        geometry: new MultiPolygon(processedCoord),
      });
    } else {
      return new Feature({
        geometry: new Polygon(processedCoord[0]),
      });
    }
  } else {
    var jstsGeom = parser.read(olFeature.getGeometry());
    var buffered = BufferOp.bufferOp(jstsGeom, meterRadius);
    var featGeoJSON2 = parser.write(buffered);
    return new Feature({
      geometry: new Polygon(featGeoJSON2.getCoordinates()),
    });
  }
}

function isGeomValid(olFeature) {
  const parser = new OL3Parser();
  parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);
  var jstsGeom = parser.read(olFeature.getGeometry());
  return IsValidOp.isValid(jstsGeom);
}

function isSelectedLayerEqualLayerID(selectedTarget, layerId) {
  for (var testkey in selectedTarget.featureLayerAssociation_) {
    if (selectedTarget.featureLayerAssociation_[testkey]) {
      if (selectedTarget.featureLayerAssociation_[testkey].className_ === "ol-layer") {
        if (selectedTarget.featureLayerAssociation_[testkey].ol_uid === layerId) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  return null;
}

function getDefBuildingsIntersectBuffer(projectId, callback) {
  //console.log("inside getDefBuildingsIntersectBuffer");

  // let tempFeat;
  // for (let i = 0; i < projBuildingWFSSource.getFeatures().length; i++) {
  //     tempFeat = projBuildingWFSSource.getFeatures()[i];
  //     if (tempFeat.get('projectid') === projectId) {
  //         console.log("tempFeat.get('projectid')");
  //         console.log(tempFeat.get('projectid'));
  //         console.log("projectId");
  //         console.log(projectId);
  //         projBuildingWFSSource.removeFeature(tempFeat);
  //     }

  // }

  // console.log("inside getDefBuildingsIntersectBuffer END");

  // // clear projBuildingWFSSource that has current Project first
  // const clearFeatRequest = new WFS().writeGetFeature({
  //     srsName: 'EPSG:3857',
  //     featureNS: 'webcnmpws',
  //     featureTypes: ['projectNSRBuilding'],
  //     outputFormat: 'application/json',
  //     filter: equalToFilter('projectid', projectId)
  // })
  // var xs = new XMLSerializer();
  // var payload = xs.serializeToString(clearFeatRequest);

  // fetch(SERVER_URL + '/gsProxy/wfs', {
  //     method:'POST',
  //     body: payload
  // })
  // .then(function (response) {
  //     return response.json();
  // })
  // .then(function (json) {
  //     const projectBuildingfeatures = new GeoJSON().readFeatures(json);
  //     if (projectBuildingfeatures.length > 0 )
  //     {
  //         // var projectBuildingLayer = getLayerByTitle("projectBuildingLayer");
  //         // console.log("projectBuildingLayer");
  //         // console.log(projectBuildingLayer);
  //         // projectBuildingLayer.removeFeatures(projectBuildingfeatures);

  //         // console.log("inside getDefBuildingsIntersectBuffer DONE");

  //         modifiedFeatureList = [];
  //         for (let i = 0; i < projectBuildingfeatures.length; i++) {
  //             var tempFeat = projectBuildingfeatures[i];
  //             modifiedFeatureList.push(tempFeat);
  //         }

  //         var task = "delete";
  //         var geoserverWorkspace = "http://www.abc.com/webcnmpws";
  //         var editLayer = "projectNSRBuilding";
  //         saveEdits(task, geoserverWorkspace, editLayer,getDefBuildingsIntersectBuffer2);
  //         //saveEdits(task, geoserverWorkspace, editLayer,null);
  //     }
  //     else
  //     {
  //          getDefBuildingsIntersectBuffer2();
  //     }

  // })

  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "projectnsrbuilding/projectId/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      getDefBuildingsIntersectBuffer2(callback);
    });

  // modifiedFeatureList = [];
  // var buildingFeat;
  // for (let i = 0; i < defBuildingWFSSource.getFeatures().length; i++) {
  //     buildingFeat = defBuildingWFSSource.getFeatures()[i];
  //     if (isIntersect(bufferFeat, buildingFeat)) {
  //         buildingFeat.set('projectid', projectId);
  //         modifiedFeatureList.push(buildingFeat);
  //     }
  // }

  //getDefBuildingsIntersectBuffer2();
}

function getDefBuildingsIntersectBuffer2(callback) {
  console.log("inside getDefBuildingsIntersectBuffer2");
  //projBuildingWFSSource.refresh();

  // get the buffer from vector4
  var index = 0;
  var bufferGeom;
  for (let i = 0; i < siteBufferSource.getFeatures().length; i++) {
    bufferGeom = siteBufferSource.getFeatures()[i].getGeometry(); // buffer feature should be only 1
  }
  // console.log("bufferGeom");
  // console.log(bufferGeom);

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["Building_2022_nsr_wgs84sp_noZM"],
    outputFormat: "application/json",
    //filter: andFilter(disjointFilter('the_geom', siteGeom, 'EPSG:3857'), intersectsFilter('the_geom', bufferGeom, 'EPSG:3857')),
    //filter: disjointFilter('the_geom', siteGeom, 'EPSG:3857'), // not sure why disjoint does not work and produce error
    filter: intersectsFilter("the_geom", bufferGeom, "EPSG:3857"),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      console.log("getDefBuildingsIntersectBuffer2 response");
      console.log(response);
      return response.json();
    })
    .then(function (json) {
      const defaultBuildingfeatures = new GeoJSON().readFeatures(json);
      if (defaultBuildingfeatures.length > 0) {
        if (saveProjectFinish) {
          siteBufferSource.clear();
        }

        var siteFeat;
        for (let i = 0; i < siteSource.getFeatures().length; i++) {
          siteFeat = siteSource.getFeatures()[i];
        }
        // console.log("siteFeat");
        // console.log(siteFeat);

        modifiedFeatureList = [];

        console.log("intersected with boundary nsr building features", defaultBuildingfeatures);

        for (let i = 0; i < defaultBuildingfeatures.length; i++) {
          if (isIntersect(defaultBuildingfeatures[i], siteFeat)) {
            continue;
          }

          var mpGeom = defaultBuildingfeatures[i].getGeometry();
          var thePolygons = mpGeom.getPolygons();
          var buildingid = defaultBuildingfeatures[i].get("BUILDINGID");
          var noisecrit = defaultBuildingfeatures[i].get("noisecrit");
          var buildName = defaultBuildingfeatures[i].get("BldName_E") == null ? "" : defaultBuildingfeatures[i].get("BldName_E");
          var bdtype = defaultBuildingfeatures[i].get("NSR");
          var bdHt =
            defaultBuildingfeatures[i].get("Bld_Ht") == null
              ? defaultBuildingfeatures[i].get("ROOFLEVEL") - defaultBuildingfeatures[i].get("BASELEVEL")
              : defaultBuildingfeatures[i].get("Bld_Ht");

          for (let j = 0; j < thePolygons.length; j++) {
            var aPolygon = thePolygons[j];
            let tempFeat = new Feature({
              geom: aPolygon,
            });
            tempFeat.set("projectid", currentProjectID);
            tempFeat.set("buildingid", buildingid);
            tempFeat.set("noisecriteria", noisecrit); //### either to generate by if else by time, or to generate one fixed value by nsr type, or just copy from the origin source
            tempFeat.set("BldName_E", buildName);
            tempFeat.set("type", bdtype);
            //tempFeat.set('noofshare', someAmount); ### find other projects that are approved and not yet end date
            tempFeat.set("modifiedAt", new Date().toISOString());
            tempFeat.set("Bld_Ht", bdHt);
            modifiedFeatureList.push(tempFeat);
          }
        }
        if (saveProjectFinish) {
          siteSource.clear();
        }

        console.log("intersected nsr building features but not intersect with site", modifiedFeatureList);

        var task = "insert";
        var geoserverWorkspace = "webcnmpws";
        var editLayer = "projectNSRBuilding";
        saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
          getDefBuildingsIntersectBuffer3(callback);
        });
      } else {
        isAfterCalculation = true;
        isCalculatedGlobal2 = 1; //added by Marvin Alex
        projBuildingWFSSource.clear();
        nsrPointsSource.clear(); // uncalculated nsr point - purple
        projBuildingPointsWFSSource.clear();
        let calculatedNSRPointsLayer = getLayerByTitle("calculatedNSRPointsLayer");
        calculatedNSRPointsLayer.getSource().clear();
        deleteProjectNSRPoints(currentProjectID, () => {
          updateIsCalculated(currentProjectID, 1, callback);
        });
      }
    });
}

function getDefBuildingsIntersectBuffer3(callback) {
  console.log("inside getDefBuildingsIntersectBuffer3");

  var projectNSRBuildingWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectNSRBuilding&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  projBuildingWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projectNSRBuildingWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("projectBuildingLayer");
  thisLayer.setSource(projBuildingWFSSource);
  thisLayer.setVisible(true);
  projBuildingWFSSource.refresh();

  getPointsOfProjNSRBuildings(currentProjectID, callback);
}

function getPointsOfProjNSRBuildings(projectId, callback) {
  deleteProjectNSRPoints(projectId, getPointsOfProjNSRBuildings2(projectId, callback));
}

function deleteProjectNSRPoints(projectId, callback) {
  console.log("Enter getPointsOfProjNSRBuildings()");
  var header = new Headers();
  header.append("Access-Control-Allow-Origin", "*");
  // header.append('Access-Control-Request-Headers', 'Content-Type');
  header.append("Access-Control-Request-Method", "DELETE");
  var deleteURL = SERVER_URL2 + "projectnsrpoints/projectId/" + projectId.toString();
  fetch(deleteURL, {
    method: "DELETE",
    //mode: 'no-cors',
    headers: header,
  })
    .then(function (response) {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(function (json) {
      // addBackManualAddedNSRs(callback);
      if (callback) {
        callback();
      }
    });
}

function getSiteFeature() {}

function getPointsOfProjNSRBuildings2(projectId, callback) {
  console.log("Enter getPointsOfProjNSRBuildings2()");
  //get site
  var siteFeat;
  if (issitemultipolygon) {
    console.log("site2WFSSource.getFeatures()");
    console.log(site2WFSSource.getFeatures());
    for (let i = 0; i < site2WFSSource.getFeatures().length; i++) {
      siteFeat = site2WFSSource.getFeatures()[i];
      if (siteFeat.get("projectid") === projectId) {
        break;
      }
    }
  }
  if (!siteFeat) {
    console.log("siteWFSSource.getFeatures()");
    console.log(siteWFSSource.getFeatures());
    for (let i = 0; i < siteWFSSource.getFeatures().length; i++) {
      siteFeat = siteWFSSource.getFeatures()[i];
      if (siteFeat.get("projectid") === projectId) {
        break;
      }
    }
  }
  if (!siteFeat) {
    console.log("siteSource.getFeatures()");
    console.log(siteSource.getFeatures());
    for (let i = 0; i < siteSource.getFeatures().length; i++) {
      siteFeat = siteSource.getFeatures()[i];
      if (siteFeat.get("projectid") === projectId) {
        break;
      }
    }
  }

  if (!saveProjectFinish) {
    var thisLayer = getLayerByTitle("siteWFSLayer");
    thisLayer.setVisible(false);
    var thisLayer = getLayerByTitle("site2WFSLayer");
    thisLayer.setVisible(false);
  }

  //for each project nsr buildings, get the closest point to the site
  var buildingFeat;

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    featureTypes: ["projectNSRBuilding"],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectId),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const defaultBuildingfeatures = new GeoJSON().readFeatures(json);
      if (defaultBuildingfeatures.length > 0) {
        modifiedFeatureList = [];
        for (let i = 0; i < defaultBuildingfeatures.length; i++) {
          buildingFeat = defaultBuildingfeatures[i];
          var buildingid = defaultBuildingfeatures[i].get("buildingid");
          var buildingHt = defaultBuildingfeatures[i].get("Bld_Ht");
          //console.log("buildingHt",buildingHt);
          var noiseCriteria = 0;
          if (defaultBuildingfeatures[i].get("reducenoisecriteria")) {
            noiseCriteria = defaultBuildingfeatures[i].get("reducenoisecriteria");
          } else {
            noiseCriteria = defaultBuildingfeatures[i].get("noisecriteria");
          }
          var buildingName = defaultBuildingfeatures[i].get("BldName_E");
          // console.log("siteFeat.getGeometry()");
          // console.log(siteFeat.getGeometry());
          var shortestLineGeom = getShortestLine(siteFeat.getGeometry(), buildingFeat.getGeometry());

          // get 1m from the last, equals what fraction
          var lineLength = shortestLineGeom.getLength();
          var fraction = 1 - 1 / lineLength;
          var nsrPointGeom = new Point(shortestLineGeom.getCoordinateAt(fraction));
          //console.log(nsrPointGeom);
          // var firstPointGeom = new Point(shortestLineGeom.getFirstCoordinate());

          // var lineFeat = new Feature({
          //     geometry: shortestLineGeom
          // });
          var pointFeat = new Feature({
            geometry: nsrPointGeom,
          });
          pointFeat.setId(i);
          pointFeat.set("id", i);
          pointFeat.set("projectid", projectId);
          pointFeat.set("buildingid", buildingid);
          pointFeat.set("Bld_Ht", buildingHt);
          pointFeat.set("noisecriteria", noiseCriteria);
          pointFeat.set("BldName_E", buildingName);
          modifiedFeatureList.push(pointFeat);

          //vecTestSource.addFeature(pointFeat);
          //vecSource8.addFeature(pointFeat);
        }
        let bufferFeat;
        for (let i = 0; i < siteBufferSource.getFeatures().length; i++) {
          bufferFeat = siteBufferSource.getFeatures()[i]; // buffer feature should be only 1
        }
        if (!bufferFeat) {
          for (let i = 0; i < bufferWFSLayer.getSource().getFeatures().length; i++) {
            bufferFeat = bufferWFSLayer.getSource().getFeatures()[i]; // buffer feature should be only 1
          }
        }
        for (const manuallyAddedNSR of manuallyAddedNSRs) {
          if (!manuallyAddedNSR.getId()) {
            manuallyAddedNSR.setId(manuallyAddedNSR.get("id"));
          }
          if (isIntersect(manuallyAddedNSR, bufferFeat) && !isIntersect(manuallyAddedNSR, siteFeat)) {
            modifiedFeatureList.push(manuallyAddedNSR);
          }
        }

        var task = "insert";
        var geoserverWorkspace = "webcnmpws";
        var editLayer = "projectNSRPoints";
        saveEdits(task, geoserverWorkspace, editLayer, "geom", function () {
          getPointsOfProjNSRBuildings3(callback);
        });
      }
    });
}

function getPointsOfProjNSRBuildings3(callback) {
  console.log("inside getPointsOfProjNSRBuildings3");

  var projectNSRPointsWFSURL =
    SERVER_URL +
    "/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3AprojectNSRPoints&outputFormat=application%2Fjson&cql_filter=projectid=" +
    currentProjectID.toString();
  projBuildingPointsWFSSource = new VectorSource({
    format: new GeoJSON(),
    url: function (extent) {
      return projectNSRPointsWFSURL + "&srsname=EPSG:3857";
    },
  });
  var thisLayer = getLayerByTitle("projectBuildingPointsLayer");
  thisLayer.setSource(projBuildingPointsWFSSource);
  thisLayer.setVisible(true);
  projBuildingPointsWFSSource.refresh();

  updateIsCalculated(currentProjectID, 0, null);
  approvedProjectIDs = [];
  openApprovedSites(currentProjectID);
  if (callback) {
    callback();
  }
}

olMap.getProjectPMEFeatures = function (callback) {
  var aEqpLayer = getLayerByTitle("pmeWFSLayer");
  var aEqpFeatures = aEqpLayer.getSource().getFeatures();

  var zoneLayer = getLayerByTitle("zoneWFSLayer");
  var zoneFeatures = zoneLayer.getSource().getFeatures();
  // console.log("zoneFeatures");
  // console.log(zoneFeatures);
  var zoneCentroids = [];
  for (let i = 0; i < zoneFeatures.length; i++) {
    var aZoneFeat = zoneFeatures[i];
    var aZoneID = aZoneFeat.get("id");
    //var centroidFeat = getCenterOfMass(aZoneFeat);
    var centroidFeat = getSavedCenterPointByZoneID(aZoneID);
    if (centroidFeat == null) {
      centroidFeat = getCenterOfMass(aZoneFeat);
    }
    var centroidDict = new CustDictionary(aZoneID, centroidFeat, null);
    zoneCentroids.push(centroidDict);
  }

  // console.log("aEqpFeatures");
  // console.log(aEqpFeatures);
  callback(aEqpFeatures, zoneCentroids);
};

olMap.getZoneNSRNotionalInfo = function () {
  return zoneNSRNotionalInfo;
};

function getShortestLineAlex(geom1, geom2) {
  var result;
  var distanceSq = Infinity;

  (geom1.getLinearRing ? geom1.getLinearRing(0) : geom1).getCoordinates().forEach(function (coordinates) {
    var closest = geom2.getClosestPoint(coordinates);
    var distanceNew = Math.pow(closest[0] - coordinates[0], 2) + Math.pow(closest[1] - coordinates[1], 2);
    if (distanceNew < distanceSq) {
      distanceSq = distanceNew;
      //result = [coordinates, closest];
      result = [[coordinates], [closest]];
    }
  });

  (geom2.getLinearRing ? geom2.getLinearRing(0) : geom2).getCoordinates().forEach(function (coordinates) {
    var closest = geom1.getClosestPoint(coordinates);
    var distanceNew = Math.pow(closest[0] - coordinates[0], 2) + Math.pow(closest[1] - coordinates[1], 2);
    if (distanceNew < distanceSq) {
      distanceSq = distanceNew;
      //result = [closest, coordinates];
      result = [[closest], [coordinates]];
    }
  });

  return new LineString(result);
}

function getShortestLine(geom1, geom2) {
  var result;
  var distanceSq = Infinity;

  (geom1.getLinearRing ? geom1.getLinearRing(0) : geom1).getCoordinates().forEach(function (coordinates) {
    var closest = geom2.getClosestPoint(coordinates);
    var distanceNew = Math.pow(closest[0] - coordinates[0], 2) + Math.pow(closest[1] - coordinates[1], 2);
    if (distanceNew < distanceSq) {
      distanceSq = distanceNew;
      result = [coordinates, closest];
      //result = [[coordinates], [closest]];
    }
  });

  (geom2.getLinearRing ? geom2.getLinearRing(0) : geom2).getCoordinates().forEach(function (coordinates) {
    var closest = geom1.getClosestPoint(coordinates);
    var distanceNew = Math.pow(closest[0] - coordinates[0], 2) + Math.pow(closest[1] - coordinates[1], 2);
    if (distanceNew < distanceSq) {
      distanceSq = distanceNew;
      result = [closest, coordinates];
      //result = [[closest], [coordinates]];
    }
  });

  return new LineString(result);
}

function getLayerByTitle(layerTitle) {
  var resultLayer;
  map.getLayers().forEach(function (layer) {
    if (layer.get("title") != undefined && layer.get("title") === layerTitle) {
      resultLayer = layer;
    }
  });
  return resultLayer;
}

function keepVecSource2Clean(e) {
  vecSource2.clear();
}
function turnOffEqpDraw(e) {
  map.removeInteraction(siteDraw);
}

function doSplitPolygon(e) {
  // console.log(vecSource.getFeatures()[0].getGeometry())
  // console.log(vecSource2.getFeatures()[0].getGeometry())
  const parser = new OL3Parser();
  parser.inject(Point, LineString, Polygon);
  var jstsPolygon = parser.read(zoneSource.getFeatures()[0].getGeometry());
  var jstsPoline = parser.read(vecSource2.getFeatures()[0].getGeometry());

  // //Perform union of Polygon and Line and use Polygonizer to split the polygon by line
  // let union = jstsPolygon.getExteriorRing().union(jstsPoline);
  // let polygonizer = new Polygonizer();
  // polygonizer.add(union);

  // //Get splitted polygons
  // let polygons = polygonizer.getPolygons();

  // if(polygons.array.length >= 2) {
  //     //Clear old splitted polygons and measurement overlays
  //     vecSource.clear();
  //     //this.map.getOverlays().clear();

  //     //Iterate through splitted polygons
  //     polygons.array.forEach((geom) => {
  //         let splitted_polygon = new ol.Feature({
  //             geometry: new ol.geom.Polygon(parser.write(geom).getCoordinates())
  //         });

  //         vecSource.addFeature(splitted_polygon);

  //     });
  // }
  // else{

  // }
}

function getCurrentSiteFeaturePutOnGlobalVar(projectid, followUpFunction) {
  var siteFeat;
  var featType = "";
  if (issitemultipolygon) {
    featType = "sites2";
  } else {
    featType = "sites";
  }

  const defaultFeatRequest = new WFS().writeGetFeature({
    srsName: "EPSG:3857",
    featureNS: "webcnmpws",
    //featureTypes: ['Bld_HKSAR2011_wgs84sp'],
    //featureTypes: ['sites'],
    //featureTypes: ['sites2'],
    featureTypes: [featType],
    outputFormat: "application/json",
    filter: equalToFilter("projectid", projectid),
  });
  var xs = new XMLSerializer();
  var payload = xs.serializeToString(defaultFeatRequest);

  fetch(SERVER_URL + "/gsProxy/wfs", {
    method: "POST",
    body: payload,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const sitefeatures = new GeoJSON().readFeatures(json);
      if (sitefeatures.length > 0) {
        globalCurrentSiteFeature = null;
        for (let i = 0; i < sitefeatures.length; i++) {
          globalCurrentSiteFeature = sitefeatures[i];
        }

        if (followUpFunction) {
          followUpFunction();
        }
      }
    });
}

function getStartDateFromZoneTask(zonetask) {
  let startDates = zonetask
    .split("+")
    .map((zt) => Date.parse(projectObj.tasks.filter((t) => t.zone.toString() == zt.split("-")[0] && t.id == zt.split("-")[1])[0].start));
  return new Date(Math.min(startDates));
}

function getEndDateFromZoneTask(zonetask) {
  let endDates = zonetask
    .split("+")
    .map((zt) => Date.parse(projectObj.tasks.filter((t) => t.zone.toString() == zt.split("-")[0] && t.id == zt.split("-")[1])[0].end));
  return new Date(Math.max(endDates));
}

olMap.copyToProductionServer = async function (table, sourceId, targetId) {
  const url = `${SERVER_URL}/gsProxy/webcnmpws/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=webcnmpws%3A${table}&outputFormat=application%2Fjson&cql_filter=projectid=${sourceId}&srsname=EPSG:3857`;
  const response = await axios.get(url);
  const sourceFeatures = new GeoJSON().readFeatures(response.data);
  let features = sourceFeatures.map((f) => {
    f.set("projectid", targetId);
    return f;
  });
  console.log(features);
  var formatWFS = new WFS();

  var node;
  var formatGML = new GML({
    featureNS: "webcnmpws",
    featureType: table,
    //version: '1.1.0',
    request: "GetFeature",
    srsName: "EPSG:3857",
  });
  node = formatWFS.writeTransaction(features, null, null, formatGML);

  var xs = new XMLSerializer();
  var payload = xs.serializeToString(node);

  // if (mode === 'insert_batch') {
  //     payload = payload.split('geometry>').join('the_geom>');
  // }
  payload = payload.split("geometry>").join("geom" + ">");
  console.log("payload");
  console.log(payload);
  let request = new XMLHttpRequest();
  request.open("POST", "https://web-cnmp.net/gsProxy/wfs");
  request.onreadystatechange = function () {
    if (request.readyState == 4) {
      console.log("Response");
      console.log(request.responseXML);
    }
    // else
    // {
    //     console.log('Response NOT readystate == 4');
    //     console.log(request.responseXML);
    // }
  };

  request.setRequestHeader("Content-Type", "text/xml");
  request.send(payload);

  console.log("features were posted to server");
};

export default olMap;
